const US_COUNTIES = [
    // Alabama (AL) - 67 counties
    { fips: '01001', name: 'Autauga', state: 'AL' },
    { fips: '01003', name: 'Baldwin', state: 'AL' },
    { fips: '01005', name: 'Barbour', state: 'AL' },
    { fips: '01007', name: 'Bibb', state: 'AL' },
    { fips: '01009', name: 'Blount', state: 'AL' },
    { fips: '01011', name: 'Bullock', state: 'AL' },
    { fips: '01013', name: 'Butler', state: 'AL' },
    { fips: '01015', name: 'Calhoun', state: 'AL' },
    { fips: '01017', name: 'Chambers', state: 'AL' },
    { fips: '01019', name: 'Cherokee', state: 'AL' },
    { fips: '01021', name: 'Chilton', state: 'AL' },
    { fips: '01023', name: 'Choctaw', state: 'AL' },
    { fips: '01025', name: 'Clarke', state: 'AL' },
    { fips: '01027', name: 'Clay', state: 'AL' },
    { fips: '01029', name: 'Cleburne', state: 'AL' },
    { fips: '01031', name: 'Coffee', state: 'AL' },
    { fips: '01033', name: 'Colbert', state: 'AL' },
    { fips: '01035', name: 'Conecuh', state: 'AL' },
    { fips: '01037', name: 'Coosa', state: 'AL' },
    { fips: '01039', name: 'Covington', state: 'AL' },
    { fips: '01041', name: 'Crenshaw', state: 'AL' },
    { fips: '01043', name: 'Cullman', state: 'AL' },
    { fips: '01045', name: 'Dale', state: 'AL' },
    { fips: '01047', name: 'Dallas', state: 'AL' },
    { fips: '01049', name: 'DeKalb', state: 'AL' },
    { fips: '01051', name: 'Elmore', state: 'AL' },
    { fips: '01053', name: 'Escambia', state: 'AL' },
    { fips: '01055', name: 'Etowah', state: 'AL' },
    { fips: '01057', name: 'Fayette', state: 'AL' },
    { fips: '01059', name: 'Franklin', state: 'AL' },
    { fips: '01061', name: 'Geneva', state: 'AL' },
    { fips: '01063', name: 'Greene', state: 'AL' },
    { fips: '01065', name: 'Hale', state: 'AL' },
    { fips: '01067', name: 'Henry', state: 'AL' },
    { fips: '01069', name: 'Houston', state: 'AL' },
    { fips: '01071', name: 'Jackson', state: 'AL' },
    { fips: '01073', name: 'Jefferson', state: 'AL' },
    { fips: '01075', name: 'Lamar', state: 'AL' },
    { fips: '01077', name: 'Lauderdale', state: 'AL' },
    { fips: '01079', name: 'Lawrence', state: 'AL' },
    { fips: '01081', name: 'Lee', state: 'AL' },
    { fips: '01083', name: 'Limestone', state: 'AL' },
    { fips: '01085', name: 'Lowndes', state: 'AL' },
    { fips: '01087', name: 'Macon', state: 'AL' },
    { fips: '01089', name: 'Madison', state: 'AL' },
    { fips: '01091', name: 'Marengo', state: 'AL' },
    { fips: '01093', name: 'Marion', state: 'AL' },
    { fips: '01095', name: 'Marshall', state: 'AL' },
    { fips: '01097', name: 'Mobile', state: 'AL' },
    { fips: '01099', name: 'Monroe', state: 'AL' },
    { fips: '01101', name: 'Montgomery', state: 'AL' },
    { fips: '01103', name: 'Morgan', state: 'AL' },
    { fips: '01105', name: 'Perry', state: 'AL' },
    { fips: '01107', name: 'Pickens', state: 'AL' },
    { fips: '01109', name: 'Pike', state: 'AL' },
    { fips: '01111', name: 'Randolph', state: 'AL' },
    { fips: '01113', name: 'Russell', state: 'AL' },
    { fips: '01115', name: 'St. Clair', state: 'AL' },
    { fips: '01117', name: 'Shelby', state: 'AL' },
    { fips: '01119', name: 'Sumter', state: 'AL' },
    { fips: '01121', name: 'Talladega', state: 'AL' },
    { fips: '01123', name: 'Tallapoosa', state: 'AL' },
    { fips: '01125', name: 'Tuscaloosa', state: 'AL' },
    { fips: '01127', name: 'Walker', state: 'AL' },
    { fips: '01129', name: 'Washington', state: 'AL' },
    { fips: '01131', name: 'Wilcox', state: 'AL' },
    { fips: '01133', name: 'Winston', state: 'AL' },
    // Alaska (AK) - 30 boroughs/census areas
    { fips: '02013', name: 'Aleutians East', state: 'AK' },
    { fips: '02016', name: 'Aleutians West', state: 'AK' },
    { fips: '02020', name: 'Anchorage', state: 'AK' },
    { fips: '02050', name: 'Bethel', state: 'AK' },
    { fips: '02060', name: 'Bristol Bay', state: 'AK' },
    { fips: '02063', name: 'Chugach', state: 'AK' },
    { fips: '02066', name: 'Copper River', state: 'AK' },
    { fips: '02068', name: 'Denali', state: 'AK' },
    { fips: '02070', name: 'Dillingham', state: 'AK' },
    { fips: '02090', name: 'Fairbanks North Star', state: 'AK' },
    { fips: '02100', name: 'Haines', state: 'AK' },
    { fips: '02105', name: 'Hoonah-Angoon', state: 'AK' },
    { fips: '02110', name: 'Juneau', state: 'AK' },
    { fips: '02122', name: 'Kenai Peninsula', state: 'AK' },
    { fips: '02130', name: 'Ketchikan Gateway', state: 'AK' },
    { fips: '02150', name: 'Kodiak Island', state: 'AK' },
    { fips: '02158', name: 'Kusilvak', state: 'AK' },
    { fips: '02164', name: 'Lake and Peninsula', state: 'AK' },
    { fips: '02170', name: 'Matanuska-Susitna', state: 'AK' },
    { fips: '02180', name: 'Nome', state: 'AK' },
    { fips: '02185', name: 'North Slope', state: 'AK' },
    { fips: '02188', name: 'Northwest Arctic', state: 'AK' },
    { fips: '02195', name: 'Petersburg', state: 'AK' },
    { fips: '02198', name: 'Prince of Wales-Hyder', state: 'AK' },
    { fips: '02220', name: 'Sitka', state: 'AK' },
    { fips: '02230', name: 'Skagway', state: 'AK' },
    { fips: '02240', name: 'Southeast Fairbanks', state: 'AK' },
    { fips: '02275', name: 'Wrangell', state: 'AK' },
    { fips: '02282', name: 'Yakutat', state: 'AK' },
    { fips: '02290', name: 'Yukon-Koyukuk', state: 'AK' },
    // Arizona (AZ) - 15 counties
    { fips: '04001', name: 'Apache', state: 'AZ' },
    { fips: '04003', name: 'Cochise', state: 'AZ' },
    { fips: '04005', name: 'Coconino', state: 'AZ' },
    { fips: '04007', name: 'Gila', state: 'AZ' },
    { fips: '04009', name: 'Graham', state: 'AZ' },
    { fips: '04011', name: 'Greenlee', state: 'AZ' },
    { fips: '04012', name: 'La Paz', state: 'AZ' },
    { fips: '04013', name: 'Maricopa', state: 'AZ' },
    { fips: '04015', name: 'Mohave', state: 'AZ' },
    { fips: '04017', name: 'Navajo', state: 'AZ' },
    { fips: '04019', name: 'Pima', state: 'AZ' },
    { fips: '04021', name: 'Pinal', state: 'AZ' },
    { fips: '04023', name: 'Santa Cruz', state: 'AZ' },
    { fips: '04025', name: 'Yavapai', state: 'AZ' },
    { fips: '04027', name: 'Yuma', state: 'AZ' },
    // Arkansas (AR) - 75 counties
    { fips: '05001', name: 'Arkansas', state: 'AR' },
    { fips: '05003', name: 'Ashley', state: 'AR' },
    { fips: '05005', name: 'Baxter', state: 'AR' },
    { fips: '05007', name: 'Benton', state: 'AR' },
    { fips: '05009', name: 'Boone', state: 'AR' },
    { fips: '05011', name: 'Bradley', state: 'AR' },
    { fips: '05013', name: 'Calhoun', state: 'AR' },
    { fips: '05015', name: 'Carroll', state: 'AR' },
    { fips: '05017', name: 'Chicot', state: 'AR' },
    { fips: '05019', name: 'Clark', state: 'AR' },
    { fips: '05021', name: 'Clay', state: 'AR' },
    { fips: '05023', name: 'Cleburne', state: 'AR' },
    { fips: '05025', name: 'Cleveland', state: 'AR' },
    { fips: '05027', name: 'Columbia', state: 'AR' },
    { fips: '05029', name: 'Conway', state: 'AR' },
    { fips: '05031', name: 'Craighead', state: 'AR' },
    { fips: '05033', name: 'Crawford', state: 'AR' },
    { fips: '05035', name: 'Crittenden', state: 'AR' },
    { fips: '05037', name: 'Cross', state: 'AR' },
    { fips: '05039', name: 'Dallas', state: 'AR' },
    { fips: '05041', name: 'Desha', state: 'AR' },
    { fips: '05043', name: 'Drew', state: 'AR' },
    { fips: '05045', name: 'Faulkner', state: 'AR' },
    { fips: '05047', name: 'Franklin', state: 'AR' },
    { fips: '05049', name: 'Fulton', state: 'AR' },
    { fips: '05051', name: 'Garland', state: 'AR' },
    { fips: '05053', name: 'Grant', state: 'AR' },
    { fips: '05055', name: 'Greene', state: 'AR' },
    { fips: '05057', name: 'Hempstead', state: 'AR' },
    { fips: '05059', name: 'Hot Spring', state: 'AR' },
    { fips: '05061', name: 'Howard', state: 'AR' },
    { fips: '05063', name: 'Independence', state: 'AR' },
    { fips: '05065', name: 'Izard', state: 'AR' },
    { fips: '05067', name: 'Jackson', state: 'AR' },
    { fips: '05069', name: 'Jefferson', state: 'AR' },
    { fips: '05071', name: 'Johnson', state: 'AR' },
    { fips: '05073', name: 'Lafayette', state: 'AR' },
    { fips: '05075', name: 'Lawrence', state: 'AR' },
    { fips: '05077', name: 'Lee', state: 'AR' },
    { fips: '05079', name: 'Lincoln', state: 'AR' },
    { fips: '05081', name: 'Little River', state: 'AR' },
    { fips: '05083', name: 'Logan', state: 'AR' },
    { fips: '05085', name: 'Lonoke', state: 'AR' },
    { fips: '05087', name: 'Madison', state: 'AR' },
    { fips: '05089', name: 'Marion', state: 'AR' },
    { fips: '05091', name: 'Miller', state: 'AR' },
    { fips: '05093', name: 'Mississippi', state: 'AR' },
    { fips: '05095', name: 'Monroe', state: 'AR' },
    { fips: '05097', name: 'Montgomery', state: 'AR' },
    { fips: '05099', name: 'Nevada', state: 'AR' },
    { fips: '05101', name: 'Newton', state: 'AR' },
    { fips: '05103', name: 'Ouachita', state: 'AR' },
    { fips: '05105', name: 'Perry', state: 'AR' },
    { fips: '05107', name: 'Phillips', state: 'AR' },
    { fips: '05109', name: 'Pike', state: 'AR' },
    { fips: '05111', name: 'Poinsett', state: 'AR' },
    { fips: '05113', name: 'Polk', state: 'AR' },
    { fips: '05115', name: 'Pope', state: 'AR' },
    { fips: '05117', name: 'Prairie', state: 'AR' },
    { fips: '05119', name: 'Pulaski', state: 'AR' },
    { fips: '05121', name: 'Randolph', state: 'AR' },
    { fips: '05123', name: 'St. Francis', state: 'AR' },
    { fips: '05125', name: 'Saline', state: 'AR' },
    { fips: '05127', name: 'Scott', state: 'AR' },
    { fips: '05129', name: 'Searcy', state: 'AR' },
    { fips: '05131', name: 'Sebastian', state: 'AR' },
    { fips: '05133', name: 'Sevier', state: 'AR' },
    { fips: '05135', name: 'Sharp', state: 'AR' },
    { fips: '05137', name: 'Stone', state: 'AR' },
    { fips: '05139', name: 'Union', state: 'AR' },
    { fips: '05141', name: 'Van Buren', state: 'AR' },
    { fips: '05143', name: 'Washington', state: 'AR' },
    { fips: '05145', name: 'White', state: 'AR' },
    { fips: '05147', name: 'Woodruff', state: 'AR' },
    { fips: '05149', name: 'Yell', state: 'AR' },
    // California (CA) - 58 counties
    { fips: '06001', name: 'Alameda', state: 'CA' },
    { fips: '06003', name: 'Alpine', state: 'CA' },
    { fips: '06005', name: 'Amador', state: 'CA' },
    { fips: '06007', name: 'Butte', state: 'CA' },
    { fips: '06009', name: 'Calaveras', state: 'CA' },
    { fips: '06011', name: 'Colusa', state: 'CA' },
    { fips: '06013', name: 'Contra Costa', state: 'CA' },
    { fips: '06015', name: 'Del Norte', state: 'CA' },
    { fips: '06017', name: 'El Dorado', state: 'CA' },
    { fips: '06019', name: 'Fresno', state: 'CA' },
    { fips: '06021', name: 'Glenn', state: 'CA' },
    { fips: '06023', name: 'Humboldt', state: 'CA' },
    { fips: '06025', name: 'Imperial', state: 'CA' },
    { fips: '06027', name: 'Inyo', state: 'CA' },
    { fips: '06029', name: 'Kern', state: 'CA' },
    { fips: '06031', name: 'Kings', state: 'CA' },
    { fips: '06033', name: 'Lake', state: 'CA' },
    { fips: '06035', name: 'Lassen', state: 'CA' },
    { fips: '06037', name: 'Los Angeles', state: 'CA' },
    { fips: '06039', name: 'Madera', state: 'CA' },
    { fips: '06041', name: 'Marin', state: 'CA' },
    { fips: '06043', name: 'Mariposa', state: 'CA' },
    { fips: '06045', name: 'Mendocino', state: 'CA' },
    { fips: '06047', name: 'Merced', state: 'CA' },
    { fips: '06049', name: 'Modoc', state: 'CA' },
    { fips: '06051', name: 'Mono', state: 'CA' },
    { fips: '06053', name: 'Monterey', state: 'CA' },
    { fips: '06055', name: 'Napa', state: 'CA' },
    { fips: '06057', name: 'Nevada', state: 'CA' },
    { fips: '06059', name: 'Orange', state: 'CA' },
    { fips: '06061', name: 'Placer', state: 'CA' },
    { fips: '06063', name: 'Plumas', state: 'CA' },
    { fips: '06065', name: 'Riverside', state: 'CA' },
    { fips: '06067', name: 'Sacramento', state: 'CA' },
    { fips: '06069', name: 'San Benito', state: 'CA' },
    { fips: '06071', name: 'San Bernardino', state: 'CA' },
    { fips: '06073', name: 'San Diego', state: 'CA' },
    { fips: '06075', name: 'San Francisco', state: 'CA' },
    { fips: '06077', name: 'San Joaquin', state: 'CA' },
    { fips: '06079', name: 'San Luis Obispo', state: 'CA' },
    { fips: '06081', name: 'San Mateo', state: 'CA' },
    { fips: '06083', name: 'Santa Barbara', state: 'CA' },
    { fips: '06085', name: 'Santa Clara', state: 'CA' },
    { fips: '06087', name: 'Santa Cruz', state: 'CA' },
    { fips: '06089', name: 'Shasta', state: 'CA' },
    { fips: '06091', name: 'Sierra', state: 'CA' },
    { fips: '06093', name: 'Siskiyou', state: 'CA' },
    { fips: '06095', name: 'Solano', state: 'CA' },
    { fips: '06097', name: 'Sonoma', state: 'CA' },
    { fips: '06099', name: 'Stanislaus', state: 'CA' },
    { fips: '06101', name: 'Sutter', state: 'CA' },
    { fips: '06103', name: 'Tehama', state: 'CA' },
    { fips: '06105', name: 'Trinity', state: 'CA' },
    { fips: '06107', name: 'Tulare', state: 'CA' },
    { fips: '06109', name: 'Tuolumne', state: 'CA' },
    { fips: '06111', name: 'Ventura', state: 'CA' },
    { fips: '06113', name: 'Yolo', state: 'CA' },
    { fips: '06115', name: 'Yuba', state: 'CA' },
    // Colorado (CO) - 64 counties
    { fips: '08001', name: 'Adams', state: 'CO' },
    { fips: '08003', name: 'Alamosa', state: 'CO' },
    { fips: '08005', name: 'Arapahoe', state: 'CO' },
    { fips: '08007', name: 'Archuleta', state: 'CO' },
    { fips: '08009', name: 'Baca', state: 'CO' },
    { fips: '08011', name: 'Bent', state: 'CO' },
    { fips: '08013', name: 'Boulder', state: 'CO' },
    { fips: '08014', name: 'Broomfield', state: 'CO' },
    { fips: '08015', name: 'Chaffee', state: 'CO' },
    { fips: '08017', name: 'Cheyenne', state: 'CO' },
    { fips: '08019', name: 'Clear Creek', state: 'CO' },
    { fips: '08021', name: 'Conejos', state: 'CO' },
    { fips: '08023', name: 'Costilla', state: 'CO' },
    { fips: '08025', name: 'Crowley', state: 'CO' },
    { fips: '08027', name: 'Custer', state: 'CO' },
    { fips: '08029', name: 'Delta', state: 'CO' },
    { fips: '08031', name: 'Denver', state: 'CO' },
    { fips: '08033', name: 'Dolores', state: 'CO' },
    { fips: '08035', name: 'Douglas', state: 'CO' },
    { fips: '08037', name: 'Eagle', state: 'CO' },
    { fips: '08039', name: 'Elbert', state: 'CO' },
    { fips: '08041', name: 'El Paso', state: 'CO' },
    { fips: '08043', name: 'Fremont', state: 'CO' },
    { fips: '08045', name: 'Garfield', state: 'CO' },
    { fips: '08047', name: 'Gilpin', state: 'CO' },
    { fips: '08049', name: 'Grand', state: 'CO' },
    { fips: '08051', name: 'Gunnison', state: 'CO' },
    { fips: '08053', name: 'Hinsdale', state: 'CO' },
    { fips: '08055', name: 'Huerfano', state: 'CO' },
    { fips: '08057', name: 'Jackson', state: 'CO' },
    { fips: '08059', name: 'Jefferson', state: 'CO' },
    { fips: '08061', name: 'Kiowa', state: 'CO' },
    { fips: '08063', name: 'Kit Carson', state: 'CO' },
    { fips: '08065', name: 'Lake', state: 'CO' },
    { fips: '08067', name: 'La Plata', state: 'CO' },
    { fips: '08069', name: 'Larimer', state: 'CO' },
    { fips: '08071', name: 'Las Animas', state: 'CO' },
    { fips: '08073', name: 'Lincoln', state: 'CO' },
    { fips: '08075', name: 'Logan', state: 'CO' },
    { fips: '08077', name: 'Mesa', state: 'CO' },
    { fips: '08079', name: 'Mineral', state: 'CO' },
    { fips: '08081', name: 'Moffat', state: 'CO' },
    { fips: '08083', name: 'Montezuma', state: 'CO' },
    { fips: '08085', name: 'Montrose', state: 'CO' },
    { fips: '08087', name: 'Morgan', state: 'CO' },
    { fips: '08089', name: 'Otero', state: 'CO' },
    { fips: '08091', name: 'Ouray', state: 'CO' },
    { fips: '08093', name: 'Park', state: 'CO' },
    { fips: '08095', name: 'Phillips', state: 'CO' },
    { fips: '08097', name: 'Pitkin', state: 'CO' },
    { fips: '08099', name: 'Prowers', state: 'CO' },
    { fips: '08101', name: 'Pueblo', state: 'CO' },
    { fips: '08103', name: 'Rio Blanco', state: 'CO' },
    { fips: '08105', name: 'Rio Grande', state: 'CO' },
    { fips: '08107', name: 'Routt', state: 'CO' },
    { fips: '08109', name: 'Saguache', state: 'CO' },
    { fips: '08111', name: 'San Juan', state: 'CO' },
    { fips: '08113', name: 'San Miguel', state: 'CO' },
    { fips: '08115', name: 'Sedgwick', state: 'CO' },
    { fips: '08117', name: 'Summit', state: 'CO' },
    { fips: '08119', name: 'Teller', state: 'CO' },
    { fips: '08121', name: 'Washington', state: 'CO' },
    { fips: '08123', name: 'Weld', state: 'CO' },
    { fips: '08125', name: 'Yuma', state: 'CO' },
    // Connecticut (CT) - 8 counties
    { fips: '09001', name: 'Fairfield', state: 'CT' },
    { fips: '09003', name: 'Hartford', state: 'CT' },
    { fips: '09005', name: 'Litchfield', state: 'CT' },
    { fips: '09007', name: 'Middlesex', state: 'CT' },
    { fips: '09009', name: 'New Haven', state: 'CT' },
    { fips: '09011', name: 'New London', state: 'CT' },
    { fips: '09013', name: 'Tolland', state: 'CT' },
    { fips: '09015', name: 'Windham', state: 'CT' },
    // Delaware (DE) - 3 counties
    { fips: '10001', name: 'Kent', state: 'DE' },
    { fips: '10003', name: 'New Castle', state: 'DE' },
    { fips: '10005', name: 'Sussex', state: 'DE' },
    // Florida (FL) - 67 counties
    { fips: '12001', name: 'Alachua', state: 'FL' },
    { fips: '12003', name: 'Baker', state: 'FL' },
    { fips: '12005', name: 'Bay', state: 'FL' },
    { fips: '12007', name: 'Bradford', state: 'FL' },
    { fips: '12009', name: 'Brevard', state: 'FL' },
    { fips: '12011', name: 'Broward', state: 'FL' },
    { fips: '12013', name: 'Calhoun', state: 'FL' },
    { fips: '12015', name: 'Charlotte', state: 'FL' },
    { fips: '12017', name: 'Citrus', state: 'FL' },
    { fips: '12019', name: 'Clay', state: 'FL' },
    { fips: '12021', name: 'Collier', state: 'FL' },
    { fips: '12023', name: 'Columbia', state: 'FL' },
    { fips: '12027', name: 'DeSoto', state: 'FL' },
    { fips: '12029', name: 'Dixie', state: 'FL' },
    { fips: '12031', name: 'Duval', state: 'FL' },
    { fips: '12033', name: 'Escambia', state: 'FL' },
    { fips: '12035', name: 'Flagler', state: 'FL' },
    { fips: '12037', name: 'Franklin', state: 'FL' },
    { fips: '12039', name: 'Gadsden', state: 'FL' },
    { fips: '12041', name: 'Gilchrist', state: 'FL' },
    { fips: '12043', name: 'Glades', state: 'FL' },
    { fips: '12045', name: 'Gulf', state: 'FL' },
    { fips: '12047', name: 'Hamilton', state: 'FL' },
    { fips: '12049', name: 'Hardee', state: 'FL' },
    { fips: '12051', name: 'Hendry', state: 'FL' },
    { fips: '12053', name: 'Hernando', state: 'FL' },
    { fips: '12055', name: 'Highlands', state: 'FL' },
    { fips: '12057', name: 'Hillsborough', state: 'FL' },
    { fips: '12059', name: 'Holmes', state: 'FL' },
    { fips: '12061', name: 'Indian River', state: 'FL' },
    { fips: '12063', name: 'Jackson', state: 'FL' },
    { fips: '12065', name: 'Jefferson', state: 'FL' },
    { fips: '12067', name: 'Lafayette', state: 'FL' },
    { fips: '12069', name: 'Lake', state: 'FL' },
    { fips: '12071', name: 'Lee', state: 'FL' },
    { fips: '12073', name: 'Leon', state: 'FL' },
    { fips: '12075', name: 'Levy', state: 'FL' },
    { fips: '12077', name: 'Liberty', state: 'FL' },
    { fips: '12079', name: 'Madison', state: 'FL' },
    { fips: '12081', name: 'Manatee', state: 'FL' },
    { fips: '12083', name: 'Marion', state: 'FL' },
    { fips: '12085', name: 'Martin', state: 'FL' },
    { fips: '12086', name: 'Miami-Dade', state: 'FL' },
    { fips: '12087', name: 'Monroe', state: 'FL' },
    { fips: '12089', name: 'Nassau', state: 'FL' },
    { fips: '12091', name: 'Okaloosa', state: 'FL' },
    { fips: '12093', name: 'Okeechobee', state: 'FL' },
    { fips: '12095', name: 'Orange', state: 'FL' },
    { fips: '12097', name: 'Osceola', state: 'FL' },
    { fips: '12099', name: 'Palm Beach', state: 'FL' },
    { fips: '12101', name: 'Pasco', state: 'FL' },
    { fips: '12103', name: 'Pinellas', state: 'FL' },
    { fips: '12105', name: 'Polk', state: 'FL' },
    { fips: '12107', name: 'Putnam', state: 'FL' },
    { fips: '12109', name: 'St. Johns', state: 'FL' },
    { fips: '12111', name: 'St. Lucie', state: 'FL' },
    { fips: '12113', name: 'Santa Rosa', state: 'FL' },
    { fips: '12115', name: 'Sarasota', state: 'FL' },
    { fips: '12117', name: 'Seminole', state: 'FL' },
    { fips: '12119', name: 'Sumter', state: 'FL' },
    { fips: '12121', name: 'Suwannee', state: 'FL' },
    { fips: '12123', name: 'Taylor', state: 'FL' },
    { fips: '12125', name: 'Union', state: 'FL' },
    { fips: '12127', name: 'Volusia', state: 'FL' },
    { fips: '12129', name: 'Wakulla', state: 'FL' },
    { fips: '12131', name: 'Walton', state: 'FL' },
    { fips: '12133', name: 'Washington', state: 'FL' },
    // Georgia (GA) - 159 counties
    { fips: '13001', name: 'Appling', state: 'GA' },
    { fips: '13003', name: 'Atkinson', state: 'GA' },
    { fips: '13005', name: 'Bacon', state: 'GA' },
    { fips: '13007', name: 'Baker', state: 'GA' },
    { fips: '13009', name: 'Baldwin', state: 'GA' },
    { fips: '13011', name: 'Banks', state: 'GA' },
    { fips: '13013', name: 'Barrow', state: 'GA' },
    { fips: '13015', name: 'Bartow', state: 'GA' },
    { fips: '13017', name: 'Ben Hill', state: 'GA' },
    { fips: '13019', name: 'Berrien', state: 'GA' },
    { fips: '13021', name: 'Bibb', state: 'GA' },
    { fips: '13023', name: 'Bleckley', state: 'GA' },
    { fips: '13025', name: 'Brantley', state: 'GA' },
    { fips: '13027', name: 'Brooks', state: 'GA' },
    { fips: '13029', name: 'Bryan', state: 'GA' },
    { fips: '13031', name: 'Bulloch', state: 'GA' },
    { fips: '13033', name: 'Burke', state: 'GA' },
    { fips: '13035', name: 'Butts', state: 'GA' },
    { fips: '13037', name: 'Calhoun', state: 'GA' },
    { fips: '13039', name: 'Camden', state: 'GA' },
    { fips: '13043', name: 'Candler', state: 'GA' },
    { fips: '13045', name: 'Carroll', state: 'GA' },
    { fips: '13047', name: 'Catoosa', state: 'GA' },
    { fips: '13049', name: 'Charlton', state: 'GA' },
    { fips: '13051', name: 'Chatham', state: 'GA' },
    { fips: '13053', name: 'Chattahoochee', state: 'GA' },
    { fips: '13055', name: 'Chattooga', state: 'GA' },
    { fips: '13057', name: 'Cherokee', state: 'GA' },
    { fips: '13059', name: 'Clarke', state: 'GA' },
    { fips: '13061', name: 'Clay', state: 'GA' },
    { fips: '13063', name: 'Clayton', state: 'GA' },
    { fips: '13065', name: 'Clinch', state: 'GA' },
    { fips: '13067', name: 'Cobb', state: 'GA' },
    { fips: '13069', name: 'Coffee', state: 'GA' },
    { fips: '13071', name: 'Colquitt', state: 'GA' },
    { fips: '13073', name: 'Columbia', state: 'GA' },
    { fips: '13075', name: 'Cook', state: 'GA' },
    { fips: '13077', name: 'Coweta', state: 'GA' },
    { fips: '13079', name: 'Crawford', state: 'GA' },
    { fips: '13081', name: 'Crisp', state: 'GA' },
    { fips: '13083', name: 'Dade', state: 'GA' },
    { fips: '13085', name: 'Dawson', state: 'GA' },
    { fips: '13087', name: 'Decatur', state: 'GA' },
    { fips: '13089', name: 'DeKalb', state: 'GA' },
    { fips: '13091', name: 'Dodge', state: 'GA' },
    { fips: '13093', name: 'Dooly', state: 'GA' },
    { fips: '13095', name: 'Dougherty', state: 'GA' },
    { fips: '13097', name: 'Douglas', state: 'GA' },
    { fips: '13099', name: 'Early', state: 'GA' },
    { fips: '13101', name: 'Echols', state: 'GA' },
    { fips: '13103', name: 'Effingham', state: 'GA' },
    { fips: '13105', name: 'Elbert', state: 'GA' },
    { fips: '13107', name: 'Emanuel', state: 'GA' },
    { fips: '13109', name: 'Evans', state: 'GA' },
    { fips: '13111', name: 'Fannin', state: 'GA' },
    { fips: '13113', name: 'Fayette', state: 'GA' },
    { fips: '13115', name: 'Floyd', state: 'GA' },
    { fips: '13117', name: 'Forsyth', state: 'GA' },
    { fips: '13119', name: 'Franklin', state: 'GA' },
    { fips: '13121', name: 'Fulton', state: 'GA' },
    { fips: '13123', name: 'Gilmer', state: 'GA' },
    { fips: '13125', name: 'Glascock', state: 'GA' },
    { fips: '13127', name: 'Glynn', state: 'GA' },
    { fips: '13129', name: 'Gordon', state: 'GA' },
    { fips: '13131', name: 'Grady', state: 'GA' },
    { fips: '13133', name: 'Greene', state: 'GA' },
    { fips: '13135', name: 'Gwinnett', state: 'GA' },
    { fips: '13137', name: 'Habersham', state: 'GA' },
    { fips: '13139', name: 'Hall', state: 'GA' },
    { fips: '13141', name: 'Hancock', state: 'GA' },
    { fips: '13143', name: 'Haralson', state: 'GA' },
    { fips: '13145', name: 'Harris', state: 'GA' },
    { fips: '13147', name: 'Hart', state: 'GA' },
    { fips: '13149', name: 'Heard', state: 'GA' },
    { fips: '13151', name: 'Henry', state: 'GA' },
    { fips: '13153', name: 'Houston', state: 'GA' },
    { fips: '13155', name: 'Irwin', state: 'GA' },
    { fips: '13157', name: 'Jackson', state: 'GA' },
    { fips: '13159', name: 'Jasper', state: 'GA' },
    { fips: '13161', name: 'Jeff Davis', state: 'GA' },
    { fips: '13163', name: 'Jefferson', state: 'GA' },
    { fips: '13165', name: 'Jenkins', state: 'GA' },
    { fips: '13167', name: 'Johnson', state: 'GA' },
    { fips: '13169', name: 'Jones', state: 'GA' },
    { fips: '13171', name: 'Lamar', state: 'GA' },
    { fips: '13173', name: 'Lanier', state: 'GA' },
    { fips: '13175', name: 'Laurens', state: 'GA' },
    { fips: '13177', name: 'Lee', state: 'GA' },
    { fips: '13179', name: 'Liberty', state: 'GA' },
    { fips: '13181', name: 'Lincoln', state: 'GA' },
    { fips: '13183', name: 'Long', state: 'GA' },
    { fips: '13185', name: 'Lowndes', state: 'GA' },
    { fips: '13187', name: 'Lumpkin', state: 'GA' },
    { fips: '13189', name: 'McDuffie', state: 'GA' },
    { fips: '13191', name: 'McIntosh', state: 'GA' },
    { fips: '13193', name: 'Macon', state: 'GA' },
    { fips: '13195', name: 'Madison', state: 'GA' },
    { fips: '13197', name: 'Marion', state: 'GA' },
    { fips: '13199', name: 'Meriwether', state: 'GA' },
    { fips: '13201', name: 'Miller', state: 'GA' },
    { fips: '13205', name: 'Mitchell', state: 'GA' },
    { fips: '13207', name: 'Monroe', state: 'GA' },
    { fips: '13209', name: 'Montgomery', state: 'GA' },
    { fips: '13211', name: 'Morgan', state: 'GA' },
    { fips: '13213', name: 'Murray', state: 'GA' },
    { fips: '13215', name: 'Muscogee', state: 'GA' },
    { fips: '13217', name: 'Newton', state: 'GA' },
    { fips: '13219', name: 'Oconee', state: 'GA' },
    { fips: '13221', name: 'Oglethorpe', state: 'GA' },
    { fips: '13223', name: 'Paulding', state: 'GA' },
    { fips: '13225', name: 'Peach', state: 'GA' },
    { fips: '13227', name: 'Pickens', state: 'GA' },
    { fips: '13229', name: 'Pierce', state: 'GA' },
    { fips: '13231', name: 'Pike', state: 'GA' },
    { fips: '13233', name: 'Polk', state: 'GA' },
    { fips: '13235', name: 'Pulaski', state: 'GA' },
    { fips: '13237', name: 'Putnam', state: 'GA' },
    { fips: '13239', name: 'Quitman', state: 'GA' },
    { fips: '13241', name: 'Rabun', state: 'GA' },
    { fips: '13243', name: 'Randolph', state: 'GA' },
    { fips: '13245', name: 'Richmond', state: 'GA' },
    { fips: '13247', name: 'Rockdale', state: 'GA' },
    { fips: '13249', name: 'Schley', state: 'GA' },
    { fips: '13251', name: 'Screven', state: 'GA' },
    { fips: '13253', name: 'Seminole', state: 'GA' },
    { fips: '13255', name: 'Spalding', state: 'GA' },
    { fips: '13257', name: 'Stephens', state: 'GA' },
    { fips: '13259', name: 'Stewart', state: 'GA' },
    { fips: '13261', name: 'Sumter', state: 'GA' },
    { fips: '13263', name: 'Talbot', state: 'GA' },
    { fips: '13265', name: 'Taliaferro', state: 'GA' },
    { fips: '13267', name: 'Tattnall', state: 'GA' },
    { fips: '13269', name: 'Taylor', state: 'GA' },
    { fips: '13271', name: 'Telfair', state: 'GA' },
    { fips: '13273', name: 'Terrell', state: 'GA' },
    { fips: '13275', name: 'Thomas', state: 'GA' },
    { fips: '13277', name: 'Tift', state: 'GA' },
    { fips: '13279', name: 'Toombs', state: 'GA' },
    { fips: '13281', name: 'Towns', state: 'GA' },
    { fips: '13283', name: 'Treutlen', state: 'GA' },
    { fips: '13285', name: 'Troup', state: 'GA' },
    { fips: '13287', name: 'Turner', state: 'GA' },
    { fips: '13289', name: 'Twiggs', state: 'GA' },
    { fips: '13291', name: 'Union', state: 'GA' },
    { fips: '13293', name: 'Upson', state: 'GA' },
    { fips: '13295', name: 'Walker', state: 'GA' },
    { fips: '13297', name: 'Walton', state: 'GA' },
    { fips: '13299', name: 'Ware', state: 'GA' },
    { fips: '13301', name: 'Warren', state: 'GA' },
    { fips: '13303', name: 'Washington', state: 'GA' },
    { fips: '13305', name: 'Wayne', state: 'GA' },
    { fips: '13307', name: 'Webster', state: 'GA' },
    { fips: '13309', name: 'Wheeler', state: 'GA' },
    { fips: '13311', name: 'White', state: 'GA' },
    { fips: '13313', name: 'Whitfield', state: 'GA' },
    { fips: '13315', name: 'Wilcox', state: 'GA' },
    { fips: '13317', name: 'Wilkes', state: 'GA' },
    { fips: '13319', name: 'Wilkinson', state: 'GA' },
    { fips: '13321', name: 'Worth', state: 'GA' },
    // Hawaii (HI) - 5 counties
    { fips: '15001', name: 'Hawaii', state: 'HI' },
    { fips: '15003', name: 'Honolulu', state: 'HI' },
    { fips: '15005', name: 'Kalawao', state: 'HI' },
    { fips: '15007', name: 'Kauai', state: 'HI' },
    { fips: '15009', name: 'Maui', state: 'HI' },
    // Idaho (ID) - 44 counties
    { fips: '16001', name: 'Ada', state: 'ID' },
    { fips: '16003', name: 'Adams', state: 'ID' },
    { fips: '16005', name: 'Bannock', state: 'ID' },
    { fips: '16007', name: 'Bear Lake', state: 'ID' },
    { fips: '16009', name: 'Benewah', state: 'ID' },
    { fips: '16011', name: 'Bingham', state: 'ID' },
    { fips: '16013', name: 'Blaine', state: 'ID' },
    { fips: '16015', name: 'Boise', state: 'ID' },
    { fips: '16017', name: 'Bonner', state: 'ID' },
    { fips: '16019', name: 'Bonneville', state: 'ID' },
    { fips: '16021', name: 'Boundary', state: 'ID' },
    { fips: '16023', name: 'Butte', state: 'ID' },
    { fips: '16025', name: 'Camas', state: 'ID' },
    { fips: '16027', name: 'Canyon', state: 'ID' },
    { fips: '16029', name: 'Caribou', state: 'ID' },
    { fips: '16031', name: 'Cassia', state: 'ID' },
    { fips: '16033', name: 'Clark', state: 'ID' },
    { fips: '16035', name: 'Clearwater', state: 'ID' },
    { fips: '16037', name: 'Custer', state: 'ID' },
    { fips: '16039', name: 'Elmore', state: 'ID' },
    { fips: '16041', name: 'Franklin', state: 'ID' },
    { fips: '16043', name: 'Fremont', state: 'ID' },
    { fips: '16045', name: 'Gem', state: 'ID' },
    { fips: '16047', name: 'Gooding', state: 'ID' },
    { fips: '16049', name: 'Idaho', state: 'ID' },
    { fips: '16051', name: 'Jefferson', state: 'ID' },
    { fips: '16053', name: 'Jerome', state: 'ID' },
    { fips: '16055', name: 'Kootenai', state: 'ID' },
    { fips: '16057', name: 'Latah', state: 'ID' },
    { fips: '16059', name: 'Lemhi', state: 'ID' },
    { fips: '16061', name: 'Lewis', state: 'ID' },
    { fips: '16063', name: 'Lincoln', state: 'ID' },
    { fips: '16065', name: 'Madison', state: 'ID' },
    { fips: '16067', name: 'Minidoka', state: 'ID' },
    { fips: '16069', name: 'Nez Perce', state: 'ID' },
    { fips: '16071', name: 'Oneida', state: 'ID' },
    { fips: '16073', name: 'Owyhee', state: 'ID' },
    { fips: '16075', name: 'Payette', state: 'ID' },
    { fips: '16077', name: 'Power', state: 'ID' },
    { fips: '16079', name: 'Shoshone', state: 'ID' },
    { fips: '16081', name: 'Teton', state: 'ID' },
    { fips: '16083', name: 'Twin Falls', state: 'ID' },
    { fips: '16085', name: 'Valley', state: 'ID' },
    { fips: '16087', name: 'Washington', state: 'ID' },
    // Illinois (IL) - 102 counties
    { fips: '17001', name: 'Adams', state: 'IL' },
    { fips: '17003', name: 'Alexander', state: 'IL' },
    { fips: '17005', name: 'Bond', state: 'IL' },
    { fips: '17007', name: 'Boone', state: 'IL' },
    { fips: '17009', name: 'Brown', state: 'IL' },
    { fips: '17011', name: 'Bureau', state: 'IL' },
    { fips: '17013', name: 'Calhoun', state: 'IL' },
    { fips: '17015', name: 'Carroll', state: 'IL' },
    { fips: '17017', name: 'Cass', state: 'IL' },
    { fips: '17019', name: 'Champaign', state: 'IL' },
    { fips: '17021', name: 'Christian', state: 'IL' },
    { fips: '17023', name: 'Clark', state: 'IL' },
    { fips: '17025', name: 'Clay', state: 'IL' },
    { fips: '17027', name: 'Clinton', state: 'IL' },
    { fips: '17029', name: 'Coles', state: 'IL' },
    { fips: '17031', name: 'Cook', state: 'IL' },
    { fips: '17033', name: 'Crawford', state: 'IL' },
    { fips: '17035', name: 'Cumberland', state: 'IL' },
    { fips: '17037', name: 'DeKalb', state: 'IL' },
    { fips: '17039', name: 'De Witt', state: 'IL' },
    { fips: '17041', name: 'Douglas', state: 'IL' },
    { fips: '17043', name: 'DuPage', state: 'IL' },
    { fips: '17045', name: 'Edgar', state: 'IL' },
    { fips: '17047', name: 'Edwards', state: 'IL' },
    { fips: '17049', name: 'Effingham', state: 'IL' },
    { fips: '17051', name: 'Fayette', state: 'IL' },
    { fips: '17053', name: 'Ford', state: 'IL' },
    { fips: '17055', name: 'Franklin', state: 'IL' },
    { fips: '17057', name: 'Fulton', state: 'IL' },
    { fips: '17059', name: 'Gallatin', state: 'IL' },
    { fips: '17061', name: 'Greene', state: 'IL' },
    { fips: '17063', name: 'Grundy', state: 'IL' },
    { fips: '17065', name: 'Hamilton', state: 'IL' },
    { fips: '17067', name: 'Hancock', state: 'IL' },
    { fips: '17069', name: 'Hardin', state: 'IL' },
    { fips: '17071', name: 'Henderson', state: 'IL' },
    { fips: '17073', name: 'Henry', state: 'IL' },
    { fips: '17075', name: 'Iroquois', state: 'IL' },
    { fips: '17077', name: 'Jackson', state: 'IL' },
    { fips: '17079', name: 'Jasper', state: 'IL' },
    { fips: '17081', name: 'Jefferson', state: 'IL' },
    { fips: '17083', name: 'Jersey', state: 'IL' },
    { fips: '17085', name: 'Jo Daviess', state: 'IL' },
    { fips: '17087', name: 'Johnson', state: 'IL' },
    { fips: '17089', name: 'Kane', state: 'IL' },
    { fips: '17091', name: 'Kankakee', state: 'IL' },
    { fips: '17093', name: 'Kendall', state: 'IL' },
    { fips: '17095', name: 'Knox', state: 'IL' },
    { fips: '17097', name: 'Lake', state: 'IL' },
    { fips: '17099', name: 'LaSalle', state: 'IL' },
    { fips: '17101', name: 'Lawrence', state: 'IL' },
    { fips: '17103', name: 'Lee', state: 'IL' },
    { fips: '17105', name: 'Livingston', state: 'IL' },
    { fips: '17107', name: 'Logan', state: 'IL' },
    { fips: '17109', name: 'McDonough', state: 'IL' },
    { fips: '17111', name: 'McHenry', state: 'IL' },
    { fips: '17113', name: 'McLean', state: 'IL' },
    { fips: '17115', name: 'Macon', state: 'IL' },
    { fips: '17117', name: 'Macoupin', state: 'IL' },
    { fips: '17119', name: 'Madison', state: 'IL' },
    { fips: '17121', name: 'Marion', state: 'IL' },
    { fips: '17123', name: 'Marshall', state: 'IL' },
    { fips: '17125', name: 'Mason', state: 'IL' },
    { fips: '17127', name: 'Massac', state: 'IL' },
    { fips: '17129', name: 'Menard', state: 'IL' },
    { fips: '17131', name: 'Mercer', state: 'IL' },
    { fips: '17133', name: 'Monroe', state: 'IL' },
    { fips: '17135', name: 'Montgomery', state: 'IL' },
    { fips: '17137', name: 'Morgan', state: 'IL' },
    { fips: '17139', name: 'Moultrie', state: 'IL' },
    { fips: '17141', name: 'Ogle', state: 'IL' },
    { fips: '17143', name: 'Peoria', state: 'IL' },
    { fips: '17145', name: 'Perry', state: 'IL' },
    { fips: '17147', name: 'Piatt', state: 'IL' },
    { fips: '17149', name: 'Pike', state: 'IL' },
    { fips: '17151', name: 'Pope', state: 'IL' },
    { fips: '17153', name: 'Pulaski', state: 'IL' },
    { fips: '17155', name: 'Putnam', state: 'IL' },
    { fips: '17157', name: 'Randolph', state: 'IL' },
    { fips: '17159', name: 'Richland', state: 'IL' },
    { fips: '17161', name: 'Rock Island', state: 'IL' },
    { fips: '17163', name: 'St. Clair', state: 'IL' },
    { fips: '17165', name: 'Saline', state: 'IL' },
    { fips: '17167', name: 'Sangamon', state: 'IL' },
    { fips: '17169', name: 'Schuyler', state: 'IL' },
    { fips: '17171', name: 'Scott', state: 'IL' },
    { fips: '17173', name: 'Shelby', state: 'IL' },
    { fips: '17175', name: 'Stark', state: 'IL' },
    { fips: '17177', name: 'Stephenson', state: 'IL' },
    { fips: '17179', name: 'Tazewell', state: 'IL' },
    { fips: '17181', name: 'Union', state: 'IL' },
    { fips: '17183', name: 'Vermilion', state: 'IL' },
    { fips: '17185', name: 'Wabash', state: 'IL' },
    { fips: '17187', name: 'Warren', state: 'IL' },
    { fips: '17189', name: 'Washington', state: 'IL' },
    { fips: '17191', name: 'Wayne', state: 'IL' },
    { fips: '17193', name: 'White', state: 'IL' },
    { fips: '17195', name: 'Whiteside', state: 'IL' },
    { fips: '17197', name: 'Will', state: 'IL' },
    { fips: '17199', name: 'Williamson', state: 'IL' },
    { fips: '17201', name: 'Winnebago', state: 'IL' },
    { fips: '17203', name: 'Woodford', state: 'IL' },
    // Indiana (IN) - 92 counties
    { fips: '18001', name: 'Adams', state: 'IN' },
    { fips: '18003', name: 'Allen', state: 'IN' },
    { fips: '18005', name: 'Bartholomew', state: 'IN' },
    { fips: '18007', name: 'Benton', state: 'IN' },
    { fips: '18009', name: 'Blackford', state: 'IN' },
    { fips: '18011', name: 'Boone', state: 'IN' },
    { fips: '18013', name: 'Brown', state: 'IN' },
    { fips: '18015', name: 'Carroll', state: 'IN' },
    { fips: '18017', name: 'Cass', state: 'IN' },
    { fips: '18019', name: 'Clark', state: 'IN' },
    { fips: '18021', name: 'Clay', state: 'IN' },
    { fips: '18023', name: 'Clinton', state: 'IN' },
    { fips: '18025', name: 'Crawford', state: 'IN' },
    { fips: '18027', name: 'Daviess', state: 'IN' },
    { fips: '18029', name: 'Dearborn', state: 'IN' },
    { fips: '18031', name: 'Decatur', state: 'IN' },
    { fips: '18033', name: 'DeKalb', state: 'IN' },
    { fips: '18035', name: 'Delaware', state: 'IN' },
    { fips: '18037', name: 'Dubois', state: 'IN' },
    { fips: '18039', name: 'Elkhart', state: 'IN' },
    { fips: '18041', name: 'Fayette', state: 'IN' },
    { fips: '18043', name: 'Floyd', state: 'IN' },
    { fips: '18045', name: 'Fountain', state: 'IN' },
    { fips: '18047', name: 'Franklin', state: 'IN' },
    { fips: '18049', name: 'Fulton', state: 'IN' },
    { fips: '18051', name: 'Gibson', state: 'IN' },
    { fips: '18053', name: 'Grant', state: 'IN' },
    { fips: '18055', name: 'Greene', state: 'IN' },
    { fips: '18057', name: 'Hamilton', state: 'IN' },
    { fips: '18059', name: 'Hancock', state: 'IN' },
    { fips: '18061', name: 'Harrison', state: 'IN' },
    { fips: '18063', name: 'Hendricks', state: 'IN' },
    { fips: '18065', name: 'Henry', state: 'IN' },
    { fips: '18067', name: 'Howard', state: 'IN' },
    { fips: '18069', name: 'Huntington', state: 'IN' },
    { fips: '18071', name: 'Jackson', state: 'IN' },
    { fips: '18073', name: 'Jasper', state: 'IN' },
    { fips: '18075', name: 'Jay', state: 'IN' },
    { fips: '18077', name: 'Jefferson', state: 'IN' },
    { fips: '18079', name: 'Jennings', state: 'IN' },
    { fips: '18081', name: 'Johnson', state: 'IN' },
    { fips: '18083', name: 'Knox', state: 'IN' },
    { fips: '18085', name: 'Kosciusko', state: 'IN' },
    { fips: '18087', name: 'LaGrange', state: 'IN' },
    { fips: '18089', name: 'Lake', state: 'IN' },
    { fips: '18091', name: 'LaPorte', state: 'IN' },
    { fips: '18093', name: 'Lawrence', state: 'IN' },
    { fips: '18095', name: 'Madison', state: 'IN' },
    { fips: '18097', name: 'Marion', state: 'IN' },
    { fips: '18099', name: 'Marshall', state: 'IN' },
    { fips: '18101', name: 'Martin', state: 'IN' },
    { fips: '18103', name: 'Miami', state: 'IN' },
    { fips: '18105', name: 'Monroe', state: 'IN' },
    { fips: '18107', name: 'Montgomery', state: 'IN' },
    { fips: '18109', name: 'Morgan', state: 'IN' },
    { fips: '18111', name: 'Newton', state: 'IN' },
    { fips: '18113', name: 'Noble', state: 'IN' },
    { fips: '18115', name: 'Ohio', state: 'IN' },
    { fips: '18117', name: 'Orange', state: 'IN' },
    { fips: '18119', name: 'Owen', state: 'IN' },
    { fips: '18121', name: 'Parke', state: 'IN' },
    { fips: '18123', name: 'Perry', state: 'IN' },
    { fips: '18125', name: 'Pike', state: 'IN' },
    { fips: '18127', name: 'Porter', state: 'IN' },
    { fips: '18129', name: 'Posey', state: 'IN' },
    { fips: '18131', name: 'Pulaski', state: 'IN' },
    { fips: '18133', name: 'Putnam', state: 'IN' },
    { fips: '18135', name: 'Randolph', state: 'IN' },
    { fips: '18137', name: 'Ripley', state: 'IN' },
    { fips: '18139', name: 'Rush', state: 'IN' },
    { fips: '18141', name: 'St. Joseph', state: 'IN' },
    { fips: '18143', name: 'Scott', state: 'IN' },
    { fips: '18145', name: 'Shelby', state: 'IN' },
    { fips: '18147', name: 'Spencer', state: 'IN' },
    { fips: '18149', name: 'Starke', state: 'IN' },
    { fips: '18151', name: 'Steuben', state: 'IN' },
    { fips: '18153', name: 'Sullivan', state: 'IN' },
    { fips: '18155', name: 'Switzerland', state: 'IN' },
    { fips: '18157', name: 'Tippecanoe', state: 'IN' },
    { fips: '18159', name: 'Tipton', state: 'IN' },
    { fips: '18161', name: 'Union', state: 'IN' },
    { fips: '18163', name: 'Vanderburgh', state: 'IN' },
    { fips: '18165', name: 'Vermillion', state: 'IN' },
    { fips: '18167', name: 'Vigo', state: 'IN' },
    { fips: '18169', name: 'Wabash', state: 'IN' },
    { fips: '18171', name: 'Warren', state: 'IN' },
    { fips: '18173', name: 'Warrick', state: 'IN' },
    { fips: '18175', name: 'Washington', state: 'IN' },
    { fips: '18177', name: 'Wayne', state: 'IN' },
    { fips: '18179', name: 'Wells', state: 'IN' },
    { fips: '18181', name: 'White', state: 'IN' },
    { fips: '18183', name: 'Whitley', state: 'IN' },
    // Iowa (IA) - 99 counties
    { fips: '19001', name: 'Adair', state: 'IA' },
    { fips: '19003', name: 'Adams', state: 'IA' },
    { fips: '19005', name: 'Allamakee', state: 'IA' },
    { fips: '19007', name: 'Appanoose', state: 'IA' },
    { fips: '19009', name: 'Audubon', state: 'IA' },
    { fips: '19011', name: 'Benton', state: 'IA' },
    { fips: '19013', name: 'Black Hawk', state: 'IA' },
    { fips: '19015', name: 'Boone', state: 'IA' },
    { fips: '19017', name: 'Bremer', state: 'IA' },
    { fips: '19019', name: 'Buchanan', state: 'IA' },
    { fips: '19021', name: 'Buena Vista', state: 'IA' },
    { fips: '19023', name: 'Butler', state: 'IA' },
    { fips: '19025', name: 'Calhoun', state: 'IA' },
    { fips: '19027', name: 'Carroll', state: 'IA' },
    { fips: '19029', name: 'Cass', state: 'IA' },
    { fips: '19031', name: 'Cedar', state: 'IA' },
    { fips: '19033', name: 'Cerro Gordo', state: 'IA' },
    { fips: '19035', name: 'Cherokee', state: 'IA' },
    { fips: '19037', name: 'Chickasaw', state: 'IA' },
    { fips: '19039', name: 'Clarke', state: 'IA' },
    { fips: '19041', name: 'Clay', state: 'IA' },
    { fips: '19043', name: 'Clayton', state: 'IA' },
    { fips: '19045', name: 'Clinton', state: 'IA' },
    { fips: '19047', name: 'Crawford', state: 'IA' },
    { fips: '19049', name: 'Dallas', state: 'IA' },
    { fips: '19051', name: 'Davis', state: 'IA' },
    { fips: '19053', name: 'Decatur', state: 'IA' },
    { fips: '19055', name: 'Delaware', state: 'IA' },
    { fips: '19057', name: 'Des Moines', state: 'IA' },
    { fips: '19059', name: 'Dickinson', state: 'IA' },
    { fips: '19061', name: 'Dubuque', state: 'IA' },
    { fips: '19063', name: 'Emmet', state: 'IA' },
    { fips: '19065', name: 'Fayette', state: 'IA' },
    { fips: '19067', name: 'Floyd', state: 'IA' },
    { fips: '19069', name: 'Franklin', state: 'IA' },
    { fips: '19071', name: 'Fremont', state: 'IA' },
    { fips: '19073', name: 'Greene', state: 'IA' },
    { fips: '19075', name: 'Grundy', state: 'IA' },
    { fips: '19077', name: 'Guthrie', state: 'IA' },
    { fips: '19079', name: 'Hamilton', state: 'IA' },
    { fips: '19081', name: 'Hancock', state: 'IA' },
    { fips: '19083', name: 'Hardin', state: 'IA' },
    { fips: '19085', name: 'Harrison', state: 'IA' },
    { fips: '19087', name: 'Henry', state: 'IA' },
    { fips: '19089', name: 'Howard', state: 'IA' },
    { fips: '19091', name: 'Humboldt', state: 'IA' },
    { fips: '19093', name: 'Ida', state: 'IA' },
    { fips: '19095', name: 'Iowa', state: 'IA' },
    { fips: '19097', name: 'Jackson', state: 'IA' },
    { fips: '19099', name: 'Jasper', state: 'IA' },
    { fips: '19101', name: 'Jefferson', state: 'IA' },
    { fips: '19103', name: 'Johnson', state: 'IA' },
    { fips: '19105', name: 'Jones', state: 'IA' },
    { fips: '19107', name: 'Keokuk', state: 'IA' },
    { fips: '19109', name: 'Kossuth', state: 'IA' },
    { fips: '19111', name: 'Lee', state: 'IA' },
    { fips: '19113', name: 'Linn', state: 'IA' },
    { fips: '19115', name: 'Louisa', state: 'IA' },
    { fips: '19117', name: 'Lucas', state: 'IA' },
    { fips: '19119', name: 'Lyon', state: 'IA' },
    { fips: '19121', name: 'Madison', state: 'IA' },
    { fips: '19123', name: 'Mahaska', state: 'IA' },
    { fips: '19125', name: 'Marion', state: 'IA' },
    { fips: '19127', name: 'Marshall', state: 'IA' },
    { fips: '19129', name: 'Mills', state: 'IA' },
    { fips: '19131', name: 'Mitchell', state: 'IA' },
    { fips: '19133', name: 'Monona', state: 'IA' },
    { fips: '19135', name: 'Monroe', state: 'IA' },
    { fips: '19137', name: 'Montgomery', state: 'IA' },
    { fips: '19139', name: 'Muscatine', state: 'IA' },
    { fips: '19141', name: "O'Brien", state: 'IA' },
    { fips: '19143', name: 'Osceola', state: 'IA' },
    { fips: '19145', name: 'Page', state: 'IA' },
    { fips: '19147', name: 'Palo Alto', state: 'IA' },
    { fips: '19149', name: 'Plymouth', state: 'IA' },
    { fips: '19151', name: 'Pocahontas', state: 'IA' },
    { fips: '19153', name: 'Polk', state: 'IA' },
    { fips: '19155', name: 'Pottawattamie', state: 'IA' },
    { fips: '19157', name: 'Poweshiek', state: 'IA' },
    { fips: '19159', name: 'Ringgold', state: 'IA' },
    { fips: '19161', name: 'Sac', state: 'IA' },
    { fips: '19163', name: 'Scott', state: 'IA' },
    { fips: '19165', name: 'Shelby', state: 'IA' },
    { fips: '19167', name: 'Sioux', state: 'IA' },
    { fips: '19169', name: 'Story', state: 'IA' },
    { fips: '19171', name: 'Tama', state: 'IA' },
    { fips: '19173', name: 'Taylor', state: 'IA' },
    { fips: '19175', name: 'Union', state: 'IA' },
    { fips: '19177', name: 'Van Buren', state: 'IA' },
    { fips: '19179', name: 'Wapello', state: 'IA' },
    { fips: '19181', name: 'Warren', state: 'IA' },
    { fips: '19183', name: 'Washington', state: 'IA' },
    { fips: '19185', name: 'Wayne', state: 'IA' },
    { fips: '19187', name: 'Webster', state: 'IA' },
    { fips: '19189', name: 'Winnebago', state: 'IA' },
    { fips: '19191', name: 'Winneshiek', state: 'IA' },
    { fips: '19193', name: 'Woodbury', state: 'IA' },
    { fips: '19195', name: 'Worth', state: 'IA' },
    { fips: '19197', name: 'Wright', state: 'IA' },
    // Kansas (KS) - 105 counties
    { fips: '20001', name: 'Allen', state: 'KS' },
    { fips: '20003', name: 'Anderson', state: 'KS' },
    { fips: '20005', name: 'Atchison', state: 'KS' },
    { fips: '20007', name: 'Barber', state: 'KS' },
    { fips: '20009', name: 'Barton', state: 'KS' },
    { fips: '20011', name: 'Bourbon', state: 'KS' },
    { fips: '20013', name: 'Brown', state: 'KS' },
    { fips: '20015', name: 'Butler', state: 'KS' },
    { fips: '20017', name: 'Chase', state: 'KS' },
    { fips: '20019', name: 'Chautauqua', state: 'KS' },
    { fips: '20021', name: 'Cherokee', state: 'KS' },
    { fips: '20023', name: 'Cheyenne', state: 'KS' },
    { fips: '20025', name: 'Clark', state: 'KS' },
    { fips: '20027', name: 'Clay', state: 'KS' },
    { fips: '20029', name: 'Cloud', state: 'KS' },
    { fips: '20031', name: 'Coffey', state: 'KS' },
    { fips: '20033', name: 'Comanche', state: 'KS' },
    { fips: '20035', name: 'Cowley', state: 'KS' },
    { fips: '20037', name: 'Crawford', state: 'KS' },
    { fips: '20039', name: 'Decatur', state: 'KS' },
    { fips: '20041', name: 'Dickinson', state: 'KS' },
    { fips: '20043', name: 'Doniphan', state: 'KS' },
    { fips: '20045', name: 'Douglas', state: 'KS' },
    { fips: '20047', name: 'Edwards', state: 'KS' },
    { fips: '20049', name: 'Elk', state: 'KS' },
    { fips: '20051', name: 'Ellis', state: 'KS' },
    { fips: '20053', name: 'Ellsworth', state: 'KS' },
    { fips: '20055', name: 'Finney', state: 'KS' },
    { fips: '20057', name: 'Ford', state: 'KS' },
    { fips: '20059', name: 'Franklin', state: 'KS' },
    { fips: '20061', name: 'Geary', state: 'KS' },
    { fips: '20063', name: 'Gove', state: 'KS' },
    { fips: '20065', name: 'Graham', state: 'KS' },
    { fips: '20067', name: 'Grant', state: 'KS' },
    { fips: '20069', name: 'Gray', state: 'KS' },
    { fips: '20071', name: 'Greeley', state: 'KS' },
    { fips: '20073', name: 'Greenwood', state: 'KS' },
    { fips: '20075', name: 'Hamilton', state: 'KS' },
    { fips: '20077', name: 'Harper', state: 'KS' },
    { fips: '20079', name: 'Harvey', state: 'KS' },
    { fips: '20081', name: 'Haskell', state: 'KS' },
    { fips: '20083', name: 'Hodgeman', state: 'KS' },
    { fips: '20085', name: 'Jackson', state: 'KS' },
    { fips: '20087', name: 'Jefferson', state: 'KS' },
    { fips: '20089', name: 'Jewell', state: 'KS' },
    { fips: '20091', name: 'Johnson', state: 'KS' },
    { fips: '20093', name: 'Kearny', state: 'KS' },
    { fips: '20095', name: 'Kingman', state: 'KS' },
    { fips: '20097', name: 'Kiowa', state: 'KS' },
    { fips: '20099', name: 'Labette', state: 'KS' },
    { fips: '20101', name: 'Lane', state: 'KS' },
    { fips: '20103', name: 'Leavenworth', state: 'KS' },
    { fips: '20105', name: 'Lincoln', state: 'KS' },
    { fips: '20107', name: 'Linn', state: 'KS' },
    { fips: '20109', name: 'Logan', state: 'KS' },
    { fips: '20111', name: 'Lyon', state: 'KS' },
    { fips: '20113', name: 'McPherson', state: 'KS' },
    { fips: '20115', name: 'Marion', state: 'KS' },
    { fips: '20117', name: 'Marshall', state: 'KS' },
    { fips: '20119', name: 'Meade', state: 'KS' },
    { fips: '20121', name: 'Miami', state: 'KS' },
    { fips: '20123', name: 'Mitchell', state: 'KS' },
    { fips: '20125', name: 'Montgomery', state: 'KS' },
    { fips: '20127', name: 'Morris', state: 'KS' },
    { fips: '20129', name: 'Morton', state: 'KS' },
    { fips: '20131', name: 'Nemaha', state: 'KS' },
    { fips: '20133', name: 'Neosho', state: 'KS' },
    { fips: '20135', name: 'Ness', state: 'KS' },
    { fips: '20137', name: 'Norton', state: 'KS' },
    { fips: '20139', name: 'Osage', state: 'KS' },
    { fips: '20141', name: 'Osborne', state: 'KS' },
    { fips: '20143', name: 'Ottawa', state: 'KS' },
    { fips: '20145', name: 'Pawnee', state: 'KS' },
    { fips: '20147', name: 'Phillips', state: 'KS' },
    { fips: '20149', name: 'Pottawatomie', state: 'KS' },
    { fips: '20151', name: 'Pratt', state: 'KS' },
    { fips: '20153', name: 'Rawlins', state: 'KS' },
    { fips: '20155', name: 'Reno', state: 'KS' },
    { fips: '20157', name: 'Republic', state: 'KS' },
    { fips: '20159', name: 'Rice', state: 'KS' },
    { fips: '20161', name: 'Riley', state: 'KS' },
    { fips: '20163', name: 'Rooks', state: 'KS' },
    { fips: '20165', name: 'Rush', state: 'KS' },
    { fips: '20167', name: 'Russell', state: 'KS' },
    { fips: '20169', name: 'Saline', state: 'KS' },
    { fips: '20171', name: 'Scott', state: 'KS' },
    { fips: '20173', name: 'Sedgwick', state: 'KS' },
    { fips: '20175', name: 'Seward', state: 'KS' },
    { fips: '20177', name: 'Shawnee', state: 'KS' },
    { fips: '20179', name: 'Sheridan', state: 'KS' },
    { fips: '20181', name: 'Sherman', state: 'KS' },
    { fips: '20183', name: 'Smith', state: 'KS' },
    { fips: '20185', name: 'Stafford', state: 'KS' },
    { fips: '20187', name: 'Stanton', state: 'KS' },
    { fips: '20189', name: 'Stevens', state: 'KS' },
    { fips: '20191', name: 'Sumner', state: 'KS' },
    { fips: '20193', name: 'Thomas', state: 'KS' },
    { fips: '20195', name: 'Trego', state: 'KS' },
    { fips: '20197', name: 'Wabaunsee', state: 'KS' },
    { fips: '20199', name: 'Wallace', state: 'KS' },
    { fips: '20201', name: 'Washington', state: 'KS' },
    { fips: '20203', name: 'Wichita', state: 'KS' },
    { fips: '20205', name: 'Wilson', state: 'KS' },
    { fips: '20207', name: 'Woodson', state: 'KS' },
    { fips: '20209', name: 'Wyandotte', state: 'KS' },
    // Kentucky (KY) - 120 counties
    { fips: '21001', name: 'Adair', state: 'KY' },
    { fips: '21003', name: 'Allen', state: 'KY' },
    { fips: '21005', name: 'Anderson', state: 'KY' },
    { fips: '21007', name: 'Ballard', state: 'KY' },
    { fips: '21009', name: 'Barren', state: 'KY' },
    { fips: '21011', name: 'Bath', state: 'KY' },
    { fips: '21013', name: 'Bell', state: 'KY' },
    { fips: '21015', name: 'Boone', state: 'KY' },
    { fips: '21017', name: 'Bourbon', state: 'KY' },
    { fips: '21019', name: 'Boyd', state: 'KY' },
    { fips: '21021', name: 'Boyle', state: 'KY' },
    { fips: '21023', name: 'Bracken', state: 'KY' },
    { fips: '21025', name: 'Breathitt', state: 'KY' },
    { fips: '21027', name: 'Breckinridge', state: 'KY' },
    { fips: '21029', name: 'Bullitt', state: 'KY' },
    { fips: '21031', name: 'Butler', state: 'KY' },
    { fips: '21033', name: 'Caldwell', state: 'KY' },
    { fips: '21035', name: 'Calloway', state: 'KY' },
    { fips: '21037', name: 'Campbell', state: 'KY' },
    { fips: '21039', name: 'Carlisle', state: 'KY' },
    { fips: '21041', name: 'Carroll', state: 'KY' },
    { fips: '21043', name: 'Carter', state: 'KY' },
    { fips: '21045', name: 'Casey', state: 'KY' },
    { fips: '21047', name: 'Christian', state: 'KY' },
    { fips: '21049', name: 'Clark', state: 'KY' },
    { fips: '21051', name: 'Clay', state: 'KY' },
    { fips: '21053', name: 'Clinton', state: 'KY' },
    { fips: '21055', name: 'Crittenden', state: 'KY' },
    { fips: '21057', name: 'Cumberland', state: 'KY' },
    { fips: '21059', name: 'Daviess', state: 'KY' },
    { fips: '21061', name: 'Edmonson', state: 'KY' },
    { fips: '21063', name: 'Elliott', state: 'KY' },
    { fips: '21065', name: 'Estill', state: 'KY' },
    { fips: '21067', name: 'Fayette', state: 'KY' },
    { fips: '21069', name: 'Fleming', state: 'KY' },
    { fips: '21071', name: 'Floyd', state: 'KY' },
    { fips: '21073', name: 'Franklin', state: 'KY' },
    { fips: '21075', name: 'Fulton', state: 'KY' },
    { fips: '21077', name: 'Gallatin', state: 'KY' },
    { fips: '21079', name: 'Garrard', state: 'KY' },
    { fips: '21081', name: 'Grant', state: 'KY' },
    { fips: '21083', name: 'Graves', state: 'KY' },
    { fips: '21085', name: 'Grayson', state: 'KY' },
    { fips: '21087', name: 'Green', state: 'KY' },
    { fips: '21089', name: 'Greenup', state: 'KY' },
    { fips: '21091', name: 'Hancock', state: 'KY' },
    { fips: '21093', name: 'Hardin', state: 'KY' },
    { fips: '21095', name: 'Harlan', state: 'KY' },
    { fips: '21097', name: 'Harrison', state: 'KY' },
    { fips: '21099', name: 'Hart', state: 'KY' },
    { fips: '21101', name: 'Henderson', state: 'KY' },
    { fips: '21103', name: 'Henry', state: 'KY' },
    { fips: '21105', name: 'Hickman', state: 'KY' },
    { fips: '21107', name: 'Hopkins', state: 'KY' },
    { fips: '21109', name: 'Jackson', state: 'KY' },
    { fips: '21111', name: 'Jefferson', state: 'KY' },
    { fips: '21113', name: 'Jessamine', state: 'KY' },
    { fips: '21115', name: 'Johnson', state: 'KY' },
    { fips: '21117', name: 'Kenton', state: 'KY' },
    { fips: '21119', name: 'Knott', state: 'KY' },
    { fips: '21121', name: 'Knox', state: 'KY' },
    { fips: '21123', name: 'Larue', state: 'KY' },
    { fips: '21125', name: 'Laurel', state: 'KY' },
    { fips: '21127', name: 'Lawrence', state: 'KY' },
    { fips: '21129', name: 'Lee', state: 'KY' },
    { fips: '21131', name: 'Leslie', state: 'KY' },
    { fips: '21133', name: 'Letcher', state: 'KY' },
    { fips: '21135', name: 'Lewis', state: 'KY' },
    { fips: '21137', name: 'Lincoln', state: 'KY' },
    { fips: '21139', name: 'Livingston', state: 'KY' },
    { fips: '21141', name: 'Logan', state: 'KY' },
    { fips: '21143', name: 'Lyon', state: 'KY' },
    { fips: '21145', name: 'McCracken', state: 'KY' },
    { fips: '21147', name: 'McCreary', state: 'KY' },
    { fips: '21149', name: 'McLean', state: 'KY' },
    { fips: '21151', name: 'Madison', state: 'KY' },
    { fips: '21153', name: 'Magoffin', state: 'KY' },
    { fips: '21155', name: 'Marion', state: 'KY' },
    { fips: '21157', name: 'Marshall', state: 'KY' },
    { fips: '21159', name: 'Martin', state: 'KY' },
    { fips: '21161', name: 'Mason', state: 'KY' },
    { fips: '21163', name: 'Meade', state: 'KY' },
    { fips: '21165', name: 'Menifee', state: 'KY' },
    { fips: '21167', name: 'Mercer', state: 'KY' },
    { fips: '21169', name: 'Metcalfe', state: 'KY' },
    { fips: '21171', name: 'Monroe', state: 'KY' },
    { fips: '21173', name: 'Montgomery', state: 'KY' },
    { fips: '21175', name: 'Morgan', state: 'KY' },
    { fips: '21177', name: 'Muhlenberg', state: 'KY' },
    { fips: '21179', name: 'Nelson', state: 'KY' },
    { fips: '21181', name: 'Nicholas', state: 'KY' },
    { fips: '21183', name: 'Ohio', state: 'KY' },
    { fips: '21185', name: 'Oldham', state: 'KY' },
    { fips: '21187', name: 'Owen', state: 'KY' },
    { fips: '21189', name: 'Owsley', state: 'KY' },
    { fips: '21191', name: 'Pendleton', state: 'KY' },
    { fips: '21193', name: 'Perry', state: 'KY' },
    { fips: '21195', name: 'Pike', state: 'KY' },
    { fips: '21197', name: 'Powell', state: 'KY' },
    { fips: '21199', name: 'Pulaski', state: 'KY' },
    { fips: '21201', name: 'Robertson', state: 'KY' },
    { fips: '21203', name: 'Rockcastle', state: 'KY' },
    { fips: '21205', name: 'Rowan', state: 'KY' },
    { fips: '21207', name: 'Russell', state: 'KY' },
    { fips: '21209', name: 'Scott', state: 'KY' },
    { fips: '21211', name: 'Shelby', state: 'KY' },
    { fips: '21213', name: 'Simpson', state: 'KY' },
    { fips: '21215', name: 'Spencer', state: 'KY' },
    { fips: '21217', name: 'Taylor', state: 'KY' },
    { fips: '21219', name: 'Todd', state: 'KY' },
    { fips: '21221', name: 'Trigg', state: 'KY' },
    { fips: '21223', name: 'Trimble', state: 'KY' },
    { fips: '21225', name: 'Union', state: 'KY' },
    { fips: '21227', name: 'Warren', state: 'KY' },
    { fips: '21229', name: 'Washington', state: 'KY' },
    { fips: '21231', name: 'Wayne', state: 'KY' },
    { fips: '21233', name: 'Webster', state: 'KY' },
    { fips: '21235', name: 'Whitley', state: 'KY' },
    { fips: '21237', name: 'Wolfe', state: 'KY' },
    { fips: '21239', name: 'Woodford', state: 'KY' },
    // Louisiana (LA) - 64 parishes
    { fips: '22001', name: 'Acadia', state: 'LA' },
    { fips: '22003', name: 'Allen', state: 'LA' },
    { fips: '22005', name: 'Ascension', state: 'LA' },
    { fips: '22007', name: 'Assumption', state: 'LA' },
    { fips: '22009', name: 'Avoyelles', state: 'LA' },
    { fips: '22011', name: 'Beauregard', state: 'LA' },
    { fips: '22013', name: 'Bienville', state: 'LA' },
    { fips: '22015', name: 'Bossier', state: 'LA' },
    { fips: '22017', name: 'Caddo', state: 'LA' },
    { fips: '22019', name: 'Calcasieu', state: 'LA' },
    { fips: '22021', name: 'Caldwell', state: 'LA' },
    { fips: '22023', name: 'Cameron', state: 'LA' },
    { fips: '22025', name: 'Catahoula', state: 'LA' },
    { fips: '22027', name: 'Claiborne', state: 'LA' },
    { fips: '22029', name: 'Concordia', state: 'LA' },
    { fips: '22031', name: 'De Soto', state: 'LA' },
    { fips: '22033', name: 'East Baton Rouge', state: 'LA' },
    { fips: '22035', name: 'East Carroll', state: 'LA' },
    { fips: '22037', name: 'East Feliciana', state: 'LA' },
    { fips: '22039', name: 'Evangeline', state: 'LA' },
    { fips: '22041', name: 'Franklin', state: 'LA' },
    { fips: '22043', name: 'Grant', state: 'LA' },
    { fips: '22045', name: 'Iberia', state: 'LA' },
    { fips: '22047', name: 'Iberville', state: 'LA' },
    { fips: '22049', name: 'Jackson', state: 'LA' },
    { fips: '22051', name: 'Jefferson', state: 'LA' },
    { fips: '22053', name: 'Jefferson Davis', state: 'LA' },
    { fips: '22055', name: 'Lafayette', state: 'LA' },
    { fips: '22057', name: 'Lafourche', state: 'LA' },
    { fips: '22059', name: 'LaSalle', state: 'LA' },
    { fips: '22061', name: 'Lincoln', state: 'LA' },
    { fips: '22063', name: 'Livingston', state: 'LA' },
    { fips: '22065', name: 'Madison', state: 'LA' },
    { fips: '22067', name: 'Morehouse', state: 'LA' },
    { fips: '22069', name: 'Natchitoches', state: 'LA' },
    { fips: '22071', name: 'Orleans', state: 'LA' },
    { fips: '22073', name: 'Ouachita', state: 'LA' },
    { fips: '22075', name: 'Plaquemines', state: 'LA' },
    { fips: '22077', name: 'Pointe Coupee', state: 'LA' },
    { fips: '22079', name: 'Rapides', state: 'LA' },
    { fips: '22081', name: 'Red River', state: 'LA' },
    { fips: '22083', name: 'Richland', state: 'LA' },
    { fips: '22085', name: 'Sabine', state: 'LA' },
    { fips: '22087', name: 'St. Bernard', state: 'LA' },
    { fips: '22089', name: 'St. Charles', state: 'LA' },
    { fips: '22091', name: 'St. Helena', state: 'LA' },
    { fips: '22093', name: 'St. James', state: 'LA' },
    { fips: '22095', name: 'St. John the Baptist', state: 'LA' },
    { fips: '22097', name: 'St. Landry', state: 'LA' },
    { fips: '22099', name: 'St. Martin', state: 'LA' },
    { fips: '22101', name: 'St. Mary', state: 'LA' },
    { fips: '22103', name: 'St. Tammany', state: 'LA' },
    { fips: '22105', name: 'Tangipahoa', state: 'LA' },
    { fips: '22107', name: 'Tensas', state: 'LA' },
    { fips: '22109', name: 'Terrebonne', state: 'LA' },
    { fips: '22111', name: 'Union', state: 'LA' },
    { fips: '22113', name: 'Vermilion', state: 'LA' },
    { fips: '22115', name: 'Vernon', state: 'LA' },
    { fips: '22117', name: 'Washington', state: 'LA' },
    { fips: '22119', name: 'Webster', state: 'LA' },
    { fips: '22121', name: 'West Baton Rouge', state: 'LA' },
    { fips: '22123', name: 'West Carroll', state: 'LA' },
    { fips: '22125', name: 'West Feliciana', state: 'LA' },
    { fips: '22127', name: 'Winn', state: 'LA' },
    // Maine (ME) - 16 counties
    { fips: '23001', name: 'Androscoggin', state: 'ME' },
    { fips: '23003', name: 'Aroostook', state: 'ME' },
    { fips: '23005', name: 'Cumberland', state: 'ME' },
    { fips: '23007', name: 'Franklin', state: 'ME' },
    { fips: '23009', name: 'Hancock', state: 'ME' },
    { fips: '23011', name: 'Kennebec', state: 'ME' },
    { fips: '23013', name: 'Knox', state: 'ME' },
    { fips: '23015', name: 'Lincoln', state: 'ME' },
    { fips: '23017', name: 'Oxford', state: 'ME' },
    { fips: '23019', name: 'Penobscot', state: 'ME' },
    { fips: '23021', name: 'Piscataquis', state: 'ME' },
    { fips: '23023', name: 'Sagadahoc', state: 'ME' },
    { fips: '23025', name: 'Somerset', state: 'ME' },
    { fips: '23027', name: 'Waldo', state: 'ME' },
    { fips: '23029', name: 'Washington', state: 'ME' },
    { fips: '23031', name: 'York', state: 'ME' },
    // Maryland (MD) - 24 counties
    { fips: '24001', name: 'Allegany', state: 'MD' },
    { fips: '24003', name: 'Anne Arundel', state: 'MD' },
    { fips: '24005', name: 'Baltimore', state: 'MD' },
    { fips: '24009', name: 'Calvert', state: 'MD' },
    { fips: '24011', name: 'Caroline', state: 'MD' },
    { fips: '24013', name: 'Carroll', state: 'MD' },
    { fips: '24015', name: 'Cecil', state: 'MD' },
    { fips: '24017', name: 'Charles', state: 'MD' },
    { fips: '24019', name: 'Dorchester', state: 'MD' },
    { fips: '24021', name: 'Frederick', state: 'MD' },
    { fips: '24023', name: 'Garrett', state: 'MD' },
    { fips: '24025', name: 'Harford', state: 'MD' },
    { fips: '24027', name: 'Howard', state: 'MD' },
    { fips: '24029', name: 'Kent', state: 'MD' },
    { fips: '24031', name: 'Montgomery', state: 'MD' },
    { fips: '24033', name: "Prince George's", state: 'MD' },
    { fips: '24035', name: "Queen Anne's", state: 'MD' },
    { fips: '24037', name: 'St. Marys', state: 'MD' },
    { fips: '24039', name: 'Somerset', state: 'MD' },
    { fips: '24041', name: 'Talbot', state: 'MD' },
    { fips: '24043', name: 'Washington', state: 'MD' },
    { fips: '24045', name: 'Wicomico', state: 'MD' },
    { fips: '24047', name: 'Worcester', state: 'MD' },
    { fips: '24510', name: 'Baltimore City', state: 'MD' },
    // Massachusetts (MA) - 14 counties
    { fips: '25001', name: 'Barnstable', state: 'MA' },
    { fips: '25003', name: 'Berkshire', state: 'MA' },
    { fips: '25005', name: 'Bristol', state: 'MA' },
    { fips: '25007', name: 'Dukes', state: 'MA' },
    { fips: '25009', name: 'Essex', state: 'MA' },
    { fips: '25011', name: 'Franklin', state: 'MA' },
    { fips: '25013', name: 'Hampden', state: 'MA' },
    { fips: '25015', name: 'Hampshire', state: 'MA' },
    { fips: '25017', name: 'Middlesex', state: 'MA' },
    { fips: '25019', name: 'Nantucket', state: 'MA' },
    { fips: '25021', name: 'Norfolk', state: 'MA' },
    { fips: '25023', name: 'Plymouth', state: 'MA' },
    { fips: '25025', name: 'Suffolk', state: 'MA' },
    { fips: '25027', name: 'Worcester', state: 'MA' },
    // Michigan (MI) - 83 counties
    { fips: '26001', name: 'Alcona', state: 'MI' },
    { fips: '26003', name: 'Alger', state: 'MI' },
    { fips: '26005', name: 'Allegan', state: 'MI' },
    { fips: '26007', name: 'Alpena', state: 'MI' },
    { fips: '26009', name: 'Antrim', state: 'MI' },
    { fips: '26011', name: 'Arenac', state: 'MI' },
    { fips: '26013', name: 'Baraga', state: 'MI' },
    { fips: '26015', name: 'Barry', state: 'MI' },
    { fips: '26017', name: 'Bay', state: 'MI' },
    { fips: '26019', name: 'Benzie', state: 'MI' },
    { fips: '26021', name: 'Berrien', state: 'MI' },
    { fips: '26023', name: 'Branch', state: 'MI' },
    { fips: '26025', name: 'Calhoun', state: 'MI' },
    { fips: '26027', name: 'Cass', state: 'MI' },
    { fips: '26029', name: 'Charlevoix', state: 'MI' },
    { fips: '26031', name: 'Cheboygan', state: 'MI' },
    { fips: '26033', name: 'Chippewa', state: 'MI' },
    { fips: '26035', name: 'Clare', state: 'MI' },
    { fips: '26037', name: 'Clinton', state: 'MI' },
    { fips: '26039', name: 'Crawford', state: 'MI' },
    { fips: '26041', name: 'Delta', state: 'MI' },
    { fips: '26043', name: 'Dickinson', state: 'MI' },
    { fips: '26045', name: 'Eaton', state: 'MI' },
    { fips: '26047', name: 'Emmet', state: 'MI' },
    { fips: '26049', name: 'Genesee', state: 'MI' },
    { fips: '26051', name: 'Gladwin', state: 'MI' },
    { fips: '26053', name: 'Gogebic', state: 'MI' },
    { fips: '26055', name: 'Grand Traverse', state: 'MI' },
    { fips: '26057', name: 'Gratiot', state: 'MI' },
    { fips: '26059', name: 'Hillsdale', state: 'MI' },
    { fips: '26061', name: 'Houghton', state: 'MI' },
    { fips: '26063', name: 'Huron', state: 'MI' },
    { fips: '26065', name: 'Ingham', state: 'MI' },
    { fips: '26067', name: 'Ionia', state: 'MI' },
    { fips: '26069', name: 'Iosco', state: 'MI' },
    { fips: '26071', name: 'Iron', state: 'MI' },
    { fips: '26073', name: 'Isabella', state: 'MI' },
    { fips: '26075', name: 'Jackson', state: 'MI' },
    { fips: '26077', name: 'Kalamazoo', state: 'MI' },
    { fips: '26079', name: 'Kalkaska', state: 'MI' },
    { fips: '26081', name: 'Kent', state: 'MI' },
    { fips: '26083', name: 'Keweenaw', state: 'MI' },
    { fips: '26085', name: 'Lake', state: 'MI' },
    { fips: '26087', name: 'Lapeer', state: 'MI' },
    { fips: '26089', name: 'Leelanau', state: 'MI' },
    { fips: '26091', name: 'Lenawee', state: 'MI' },
    { fips: '26093', name: 'Livingston', state: 'MI' },
    { fips: '26095', name: 'Luce', state: 'MI' },
    { fips: '26097', name: 'Mackinac', state: 'MI' },
    { fips: '26099', name: 'Macomb', state: 'MI' },
    { fips: '26101', name: 'Manistee', state: 'MI' },
    { fips: '26103', name: 'Marquette', state: 'MI' },
    { fips: '26105', name: 'Mason', state: 'MI' },
    { fips: '26107', name: 'Mecosta', state: 'MI' },
    { fips: '26109', name: 'Menominee', state: 'MI' },
    { fips: '26111', name: 'Midland', state: 'MI' },
    { fips: '26113', name: 'Missaukee', state: 'MI' },
    { fips: '26115', name: 'Monroe', state: 'MI' },
    { fips: '26117', name: 'Montcalm', state: 'MI' },
    { fips: '26119', name: 'Montmorency', state: 'MI' },
    { fips: '26121', name: 'Muskegon', state: 'MI' },
    { fips: '26123', name: 'Newaygo', state: 'MI' },
    { fips: '26125', name: 'Oakland', state: 'MI' },
    { fips: '26127', name: 'Oceana', state: 'MI' },
    { fips: '26129', name: 'Ogemaw', state: 'MI' },
    { fips: '26131', name: 'Ontonagon', state: 'MI' },
    { fips: '26133', name: 'Osceola', state: 'MI' },
    { fips: '26135', name: 'Oscoda', state: 'MI' },
    { fips: '26137', name: 'Otsego', state: 'MI' },
    { fips: '26139', name: 'Ottawa', state: 'MI' },
    { fips: '26141', name: 'Presque Isle', state: 'MI' },
    { fips: '26143', name: 'Roscommon', state: 'MI' },
    { fips: '26145', name: 'Saginaw', state: 'MI' },
    { fips: '26147', name: 'St. Clair', state: 'MI' },
    { fips: '26149', name: 'St. Joseph', state: 'MI' },
    { fips: '26151', name: 'Sanilac', state: 'MI' },
    { fips: '26153', name: 'Schoolcraft', state: 'MI' },
    { fips: '26155', name: 'Shiawassee', state: 'MI' },
    { fips: '26157', name: 'Tuscola', state: 'MI' },
    { fips: '26159', name: 'Van Buren', state: 'MI' },
    { fips: '26161', name: 'Washtenaw', state: 'MI' },
    { fips: '26163', name: 'Wayne', state: 'MI' },
    { fips: '26165', name: 'Wexford', state: 'MI' },
    // Minnesota (MN) - 87 counties
    { fips: '27001', name: 'Aitkin', state: 'MN' },
    { fips: '27003', name: 'Anoka', state: 'MN' },
    { fips: '27005', name: 'Becker', state: 'MN' },
    { fips: '27007', name: 'Beltrami', state: 'MN' },
    { fips: '27009', name: 'Benton', state: 'MN' },
    { fips: '27011', name: 'Big Stone', state: 'MN' },
    { fips: '27013', name: 'Blue Earth', state: 'MN' },
    { fips: '27015', name: 'Brown', state: 'MN' },
    { fips: '27017', name: 'Carlton', state: 'MN' },
    { fips: '27019', name: 'Carver', state: 'MN' },
    { fips: '27021', name: 'Cass', state: 'MN' },
    { fips: '27023', name: 'Chippewa', state: 'MN' },
    { fips: '27025', name: 'Chisago', state: 'MN' },
    { fips: '27027', name: 'Clay', state: 'MN' },
    { fips: '27029', name: 'Clearwater', state: 'MN' },
    { fips: '27031', name: 'Cook', state: 'MN' },
    { fips: '27033', name: 'Cottonwood', state: 'MN' },
    { fips: '27035', name: 'Crow Wing', state: 'MN' },
    { fips: '27037', name: 'Dakota', state: 'MN' },
    { fips: '27039', name: 'Dodge', state: 'MN' },
    { fips: '27041', name: 'Douglas', state: 'MN' },
    { fips: '27043', name: 'Faribault', state: 'MN' },
    { fips: '27045', name: 'Fillmore', state: 'MN' },
    { fips: '27047', name: 'Freeborn', state: 'MN' },
    { fips: '27049', name: 'Goodhue', state: 'MN' },
    { fips: '27051', name: 'Grant', state: 'MN' },
    { fips: '27053', name: 'Hennepin', state: 'MN' },
    { fips: '27055', name: 'Houston', state: 'MN' },
    { fips: '27057', name: 'Hubbard', state: 'MN' },
    { fips: '27059', name: 'Isanti', state: 'MN' },
    { fips: '27061', name: 'Itasca', state: 'MN' },
    { fips: '27063', name: 'Jackson', state: 'MN' },
    { fips: '27065', name: 'Kanabec', state: 'MN' },
    { fips: '27067', name: 'Kandiyohi', state: 'MN' },
    { fips: '27069', name: 'Kittson', state: 'MN' },
    { fips: '27071', name: 'Koochiching', state: 'MN' },
    { fips: '27073', name: 'Lac qui Parle', state: 'MN' },
    { fips: '27075', name: 'Lake', state: 'MN' },
    { fips: '27077', name: 'Lake of the Woods', state: 'MN' },
    { fips: '27079', name: 'Le Sueur', state: 'MN' },
    { fips: '27081', name: 'Lincoln', state: 'MN' },
    { fips: '27083', name: 'Lyon', state: 'MN' },
    { fips: '27085', name: 'McLeod', state: 'MN' },
    { fips: '27087', name: 'Mahnomen', state: 'MN' },
    { fips: '27089', name: 'Marshall', state: 'MN' },
    { fips: '27091', name: 'Martin', state: 'MN' },
    { fips: '27093', name: 'Meeker', state: 'MN' },
    { fips: '27095', name: 'Mille Lacs', state: 'MN' },
    { fips: '27097', name: 'Morrison', state: 'MN' },
    { fips: '27099', name: 'Mower', state: 'MN' },
    { fips: '27101', name: 'Murray', state: 'MN' },
    { fips: '27103', name: 'Nicollet', state: 'MN' },
    { fips: '27105', name: 'Nobles', state: 'MN' },
    { fips: '27107', name: 'Norman', state: 'MN' },
    { fips: '27109', name: 'Olmsted', state: 'MN' },
    { fips: '27111', name: 'Otter Tail', state: 'MN' },
    { fips: '27113', name: 'Pennington', state: 'MN' },
    { fips: '27115', name: 'Pine', state: 'MN' },
    { fips: '27117', name: 'Pipestone', state: 'MN' },
    { fips: '27119', name: 'Polk', state: 'MN' },
    { fips: '27121', name: 'Pope', state: 'MN' },
    { fips: '27123', name: 'Ramsey', state: 'MN' },
    { fips: '27125', name: 'Red Lake', state: 'MN' },
    { fips: '27127', name: 'Redwood', state: 'MN' },
    { fips: '27129', name: 'Renville', state: 'MN' },
    { fips: '27131', name: 'Rice', state: 'MN' },
    { fips: '27133', name: 'Rock', state: 'MN' },
    { fips: '27135', name: 'Roseau', state: 'MN' },
    { fips: '27137', name: 'St. Louis', state: 'MN' },
    { fips: '27139', name: 'Scott', state: 'MN' },
    { fips: '27141', name: 'Sherburne', state: 'MN' },
    { fips: '27143', name: 'Sibley', state: 'MN' },
    { fips: '27145', name: 'Stearns', state: 'MN' },
    { fips: '27147', name: 'Steele', state: 'MN' },
    { fips: '27149', name: 'Stevens', state: 'MN' },
    { fips: '27151', name: 'Swift', state: 'MN' },
    { fips: '27153', name: 'Todd', state: 'MN' },
    { fips: '27155', name: 'Traverse', state: 'MN' },
    { fips: '27157', name: 'Wabasha', state: 'MN' },
    { fips: '27159', name: 'Wadena', state: 'MN' },
    { fips: '27161', name: 'Waseca', state: 'MN' },
    { fips: '27163', name: 'Washington', state: 'MN' },
    { fips: '27165', name: 'Watonwan', state: 'MN' },
    { fips: '27167', name: 'Wilkin', state: 'MN' },
    { fips: '27169', name: 'Winona', state: 'MN' },
    { fips: '27171', name: 'Wright', state: 'MN' },
    { fips: '27173', name: 'Yellow Medicine', state: 'MN' },
    // Mississippi (MS) - 82 counties
    { fips: '28001', name: 'Adams', state: 'MS' },
    { fips: '28003', name: 'Alcorn', state: 'MS' },
    { fips: '28005', name: 'Amite', state: 'MS' },
    { fips: '28007', name: 'Attala', state: 'MS' },
    { fips: '28009', name: 'Benton', state: 'MS' },
    { fips: '28011', name: 'Bolivar', state: 'MS' },
    { fips: '28013', name: 'Calhoun', state: 'MS' },
    { fips: '28015', name: 'Carroll', state: 'MS' },
    { fips: '28017', name: 'Chickasaw', state: 'MS' },
    { fips: '28019', name: 'Choctaw', state: 'MS' },
    { fips: '28021', name: 'Claiborne', state: 'MS' },
    { fips: '28023', name: 'Clarke', state: 'MS' },
    { fips: '28025', name: 'Clay', state: 'MS' },
    { fips: '28027', name: 'Coahoma', state: 'MS' },
    { fips: '28029', name: 'Copiah', state: 'MS' },
    { fips: '28031', name: 'Covington', state: 'MS' },
    { fips: '28033', name: 'DeSoto', state: 'MS' },
    { fips: '28035', name: 'Forrest', state: 'MS' },
    { fips: '28037', name: 'Franklin', state: 'MS' },
    { fips: '28039', name: 'George', state: 'MS' },
    { fips: '28041', name: 'Greene', state: 'MS' },
    { fips: '28043', name: 'Grenada', state: 'MS' },
    { fips: '28045', name: 'Hancock', state: 'MS' },
    { fips: '28047', name: 'Harrison', state: 'MS' },
    { fips: '28049', name: 'Hinds', state: 'MS' },
    { fips: '28051', name: 'Holmes', state: 'MS' },
    { fips: '28053', name: 'Humphreys', state: 'MS' },
    { fips: '28055', name: 'Issaquena', state: 'MS' },
    { fips: '28057', name: 'Itawamba', state: 'MS' },
    { fips: '28059', name: 'Jackson', state: 'MS' },
    { fips: '28061', name: 'Jasper', state: 'MS' },
    { fips: '28063', name: 'Jefferson', state: 'MS' },
    { fips: '28065', name: 'Jefferson Davis', state: 'MS' },
    { fips: '28067', name: 'Jones', state: 'MS' },
    { fips: '28069', name: 'Kemper', state: 'MS' },
    { fips: '28071', name: 'Lafayette', state: 'MS' },
    { fips: '28073', name: 'Lamar', state: 'MS' },
    { fips: '28075', name: 'Lauderdale', state: 'MS' },
    { fips: '28077', name: 'Lawrence', state: 'MS' },
    { fips: '28079', name: 'Leake', state: 'MS' },
    { fips: '28081', name: 'Lee', state: 'MS' },
    { fips: '28083', name: 'Leflore', state: 'MS' },
    { fips: '28085', name: 'Lincoln', state: 'MS' },
    { fips: '28087', name: 'Lowndes', state: 'MS' },
    { fips: '28089', name: 'Madison', state: 'MS' },
    { fips: '28091', name: 'Marion', state: 'MS' },
    { fips: '28093', name: 'Marshall', state: 'MS' },
    { fips: '28095', name: 'Monroe', state: 'MS' },
    { fips: '28097', name: 'Montgomery', state: 'MS' },
    { fips: '28099', name: 'Neshoba', state: 'MS' },
    { fips: '28101', name: 'Newton', state: 'MS' },
    { fips: '28103', name: 'Noxubee', state: 'MS' },
    { fips: '28105', name: 'Oktibbeha', state: 'MS' },
    { fips: '28107', name: 'Panola', state: 'MS' },
    { fips: '28109', name: 'Pearl River', state: 'MS' },
    { fips: '28111', name: 'Perry', state: 'MS' },
    { fips: '28113', name: 'Pike', state: 'MS' },
    { fips: '28115', name: 'Pontotoc', state: 'MS' },
    { fips: '28117', name: 'Prentiss', state: 'MS' },
    { fips: '28119', name: 'Quitman', state: 'MS' },
    { fips: '28121', name: 'Rankin', state: 'MS' },
    { fips: '28123', name: 'Scott', state: 'MS' },
    { fips: '28125', name: 'Sharkey', state: 'MS' },
    { fips: '28127', name: 'Simpson', state: 'MS' },
    { fips: '28129', name: 'Smith', state: 'MS' },
    { fips: '28131', name: 'Stone', state: 'MS' },
    { fips: '28133', name: 'Sunflower', state: 'MS' },
    { fips: '28135', name: 'Tallahatchie', state: 'MS' },
    { fips: '28137', name: 'Tate', state: 'MS' },
    { fips: '28139', name: 'Tippah', state: 'MS' },
    { fips: '28141', name: 'Tishomingo', state: 'MS' },
    { fips: '28143', name: 'Tunica', state: 'MS' },
    { fips: '28145', name: 'Union', state: 'MS' },
    { fips: '28147', name: 'Walthall', state: 'MS' },
    { fips: '28149', name: 'Warren', state: 'MS' },
    { fips: '28151', name: 'Washington', state: 'MS' },
    { fips: '28153', name: 'Wayne', state: 'MS' },
    { fips: '28155', name: 'Webster', state: 'MS' },
    { fips: '28157', name: 'Wilkinson', state: 'MS' },
    { fips: '28159', name: 'Winston', state: 'MS' },
    { fips: '28161', name: 'Yalobusha', state: 'MS' },
    { fips: '28163', name: 'Yazoo', state: 'MS' },
    // Missouri (MO) - 115 counties + St. Louis City
    { fips: '29001', name: 'Adair', state: 'MO' },
    { fips: '29003', name: 'Andrew', state: 'MO' },
    { fips: '29005', name: 'Atchison', state: 'MO' },
    { fips: '29007', name: 'Audrain', state: 'MO' },
    { fips: '29009', name: 'Barry', state: 'MO' },
    { fips: '29011', name: 'Barton', state: 'MO' },
    { fips: '29013', name: 'Bates', state: 'MO' },
    { fips: '29015', name: 'Benton', state: 'MO' },
    { fips: '29017', name: 'Bollinger', state: 'MO' },
    { fips: '29019', name: 'Boone', state: 'MO' },
    { fips: '29021', name: 'Buchanan', state: 'MO' },
    { fips: '29023', name: 'Butler', state: 'MO' },
    { fips: '29025', name: 'Caldwell', state: 'MO' },
    { fips: '29027', name: 'Callaway', state: 'MO' },
    { fips: '29029', name: 'Camden', state: 'MO' },
    { fips: '29031', name: 'Cape Girardeau', state: 'MO' },
    { fips: '29033', name: 'Carroll', state: 'MO' },
    { fips: '29035', name: 'Carter', state: 'MO' },
    { fips: '29037', name: 'Cass', state: 'MO' },
    { fips: '29039', name: 'Cedar', state: 'MO' },
    { fips: '29041', name: 'Chariton', state: 'MO' },
    { fips: '29043', name: 'Christian', state: 'MO' },
    { fips: '29045', name: 'Clark', state: 'MO' },
    { fips: '29047', name: 'Clay', state: 'MO' },
    { fips: '29049', name: 'Clinton', state: 'MO' },
    { fips: '29051', name: 'Cole', state: 'MO' },
    { fips: '29053', name: 'Cooper', state: 'MO' },
    { fips: '29055', name: 'Crawford', state: 'MO' },
    { fips: '29057', name: 'Dade', state: 'MO' },
    { fips: '29059', name: 'Dallas', state: 'MO' },
    { fips: '29061', name: 'Daviess', state: 'MO' },
    { fips: '29063', name: 'DeKalb', state: 'MO' },
    { fips: '29065', name: 'Dent', state: 'MO' },
    { fips: '29067', name: 'Douglas', state: 'MO' },
    { fips: '29069', name: 'Dunklin', state: 'MO' },
    { fips: '29071', name: 'Franklin', state: 'MO' },
    { fips: '29073', name: 'Gasconade', state: 'MO' },
    { fips: '29075', name: 'Gentry', state: 'MO' },
    { fips: '29077', name: 'Greene', state: 'MO' },
    { fips: '29079', name: 'Grundy', state: 'MO' },
    { fips: '29081', name: 'Harrison', state: 'MO' },
    { fips: '29083', name: 'Henry', state: 'MO' },
    { fips: '29085', name: 'Hickory', state: 'MO' },
    { fips: '29087', name: 'Holt', state: 'MO' },
    { fips: '29089', name: 'Howard', state: 'MO' },
    { fips: '29091', name: 'Howell', state: 'MO' },
    { fips: '29093', name: 'Iron', state: 'MO' },
    { fips: '29095', name: 'Jackson', state: 'MO' },
    { fips: '29097', name: 'Jasper', state: 'MO' },
    { fips: '29099', name: 'Jefferson', state: 'MO' },
    { fips: '29101', name: 'Johnson', state: 'MO' },
    { fips: '29103', name: 'Knox', state: 'MO' },
    { fips: '29105', name: 'Laclede', state: 'MO' },
    { fips: '29107', name: 'Lafayette', state: 'MO' },
    { fips: '29109', name: 'Lawrence', state: 'MO' },
    { fips: '29111', name: 'Lewis', state: 'MO' },
    { fips: '29113', name: 'Lincoln', state: 'MO' },
    { fips: '29115', name: 'Linn', state: 'MO' },
    { fips: '29117', name: 'Livingston', state: 'MO' },
    { fips: '29119', name: 'McDonald', state: 'MO' },
    { fips: '29121', name: 'Macon', state: 'MO' },
    { fips: '29123', name: 'Madison', state: 'MO' },
    { fips: '29125', name: 'Maries', state: 'MO' },
    { fips: '29127', name: 'Marion', state: 'MO' },
    { fips: '29129', name: 'Mercer', state: 'MO' },
    { fips: '29131', name: 'Miller', state: 'MO' },
    { fips: '29133', name: 'Mississippi', state: 'MO' },
    { fips: '29135', name: 'Moniteau', state: 'MO' },
    { fips: '29137', name: 'Monroe', state: 'MO' },
    { fips: '29139', name: 'Montgomery', state: 'MO' },
    { fips: '29141', name: 'Morgan', state: 'MO' },
    { fips: '29143', name: 'New Madrid', state: 'MO' },
    { fips: '29145', name: 'Newton', state: 'MO' },
    { fips: '29147', name: 'Nodaway', state: 'MO' },
    { fips: '29149', name: 'Oregon', state: 'MO' },
    { fips: '29151', name: 'Osage', state: 'MO' },
    { fips: '29153', name: 'Ozark', state: 'MO' },
    { fips: '29155', name: 'Pemiscot', state: 'MO' },
    { fips: '29157', name: 'Perry', state: 'MO' },
    { fips: '29159', name: 'Pettis', state: 'MO' },
    { fips: '29161', name: 'Phelps', state: 'MO' },
    { fips: '29163', name: 'Pike', state: 'MO' },
    { fips: '29165', name: 'Platte', state: 'MO' },
    { fips: '29167', name: 'Polk', state: 'MO' },
    { fips: '29169', name: 'Pulaski', state: 'MO' },
    { fips: '29171', name: 'Putnam', state: 'MO' },
    { fips: '29173', name: 'Ralls', state: 'MO' },
    { fips: '29175', name: 'Randolph', state: 'MO' },
    { fips: '29177', name: 'Ray', state: 'MO' },
    { fips: '29179', name: 'Reynolds', state: 'MO' },
    { fips: '29181', name: 'Ripley', state: 'MO' },
    { fips: '29183', name: 'St. Charles', state: 'MO' },
    { fips: '29185', name: 'St. Clair', state: 'MO' },
    { fips: '29186', name: 'Ste. Genevieve', state: 'MO' },
    { fips: '29187', name: 'St. Francois', state: 'MO' },
    { fips: '29189', name: 'St. Louis', state: 'MO' },
    { fips: '29195', name: 'Saline', state: 'MO' },
    { fips: '29197', name: 'Schuyler', state: 'MO' },
    { fips: '29199', name: 'Scotland', state: 'MO' },
    { fips: '29201', name: 'Scott', state: 'MO' },
    { fips: '29203', name: 'Shannon', state: 'MO' },
    { fips: '29205', name: 'Shelby', state: 'MO' },
    { fips: '29207', name: 'Stoddard', state: 'MO' },
    { fips: '29209', name: 'Stone', state: 'MO' },
    { fips: '29211', name: 'Sullivan', state: 'MO' },
    { fips: '29213', name: 'Taney', state: 'MO' },
    { fips: '29215', name: 'Texas', state: 'MO' },
    { fips: '29217', name: 'Vernon', state: 'MO' },
    { fips: '29219', name: 'Warren', state: 'MO' },
    { fips: '29221', name: 'Washington', state: 'MO' },
    { fips: '29223', name: 'Wayne', state: 'MO' },
    { fips: '29225', name: 'Webster', state: 'MO' },
    { fips: '29227', name: 'Worth', state: 'MO' },
    { fips: '29229', name: 'Wright', state: 'MO' },
    { fips: '29510', name: 'St. Louis City', state: 'MO' },
    // Montana (MT) - 56 counties
    { fips: '30001', name: 'Beaverhead', state: 'MT' },
    { fips: '30003', name: 'Big Horn', state: 'MT' },
    { fips: '30005', name: 'Blaine', state: 'MT' },
    { fips: '30007', name: 'Broadwater', state: 'MT' },
    { fips: '30009', name: 'Carbon', state: 'MT' },
    { fips: '30011', name: 'Carter', state: 'MT' },
    { fips: '30013', name: 'Cascade', state: 'MT' },
    { fips: '30015', name: 'Chouteau', state: 'MT' },
    { fips: '30017', name: 'Custer', state: 'MT' },
    { fips: '30019', name: 'Daniels', state: 'MT' },
    { fips: '30021', name: 'Dawson', state: 'MT' },
    { fips: '30023', name: 'Deer Lodge', state: 'MT' },
    { fips: '30025', name: 'Fallon', state: 'MT' },
    { fips: '30027', name: 'Fergus', state: 'MT' },
    { fips: '30029', name: 'Flathead', state: 'MT' },
    { fips: '30031', name: 'Gallatin', state: 'MT' },
    { fips: '30033', name: 'Garfield', state: 'MT' },
    { fips: '30035', name: 'Glacier', state: 'MT' },
    { fips: '30037', name: 'Golden Valley', state: 'MT' },
    { fips: '30039', name: 'Granite', state: 'MT' },
    { fips: '30041', name: 'Hill', state: 'MT' },
    { fips: '30043', name: 'Jefferson', state: 'MT' },
    { fips: '30045', name: 'Judith Basin', state: 'MT' },
    { fips: '30047', name: 'Lake', state: 'MT' },
    { fips: '30049', name: 'Lewis and Clark', state: 'MT' },
    { fips: '30051', name: 'Liberty', state: 'MT' },
    { fips: '30053', name: 'Lincoln', state: 'MT' },
    { fips: '30055', name: 'McCone', state: 'MT' },
    { fips: '30057', name: 'Madison', state: 'MT' },
    { fips: '30059', name: 'Meagher', state: 'MT' },
    { fips: '30061', name: 'Mineral', state: 'MT' },
    { fips: '30063', name: 'Missoula', state: 'MT' },
    { fips: '30065', name: 'Musselshell', state: 'MT' },
    { fips: '30067', name: 'Park', state: 'MT' },
    { fips: '30069', name: 'Petroleum', state: 'MT' },
    { fips: '30071', name: 'Phillips', state: 'MT' },
    { fips: '30073', name: 'Pondera', state: 'MT' },
    { fips: '30075', name: 'Powder River', state: 'MT' },
    { fips: '30077', name: 'Powell', state: 'MT' },
    { fips: '30079', name: 'Prairie', state: 'MT' },
    { fips: '30081', name: 'Ravalli', state: 'MT' },
    { fips: '30083', name: 'Richland', state: 'MT' },
    { fips: '30085', name: 'Roosevelt', state: 'MT' },
    { fips: '30087', name: 'Rosebud', state: 'MT' },
    { fips: '30089', name: 'Sanders', state: 'MT' },
    { fips: '30091', name: 'Sheridan', state: 'MT' },
    { fips: '30093', name: 'Silver Bow', state: 'MT' },
    { fips: '30095', name: 'Stillwater', state: 'MT' },
    { fips: '30097', name: 'Sweet Grass', state: 'MT' },
    { fips: '30099', name: 'Teton', state: 'MT' },
    { fips: '30101', name: 'Toole', state: 'MT' },
    { fips: '30103', name: 'Treasure', state: 'MT' },
    { fips: '30105', name: 'Valley', state: 'MT' },
    { fips: '30107', name: 'Wheatland', state: 'MT' },
    { fips: '30109', name: 'Wibaux', state: 'MT' },
    { fips: '30111', name: 'Yellowstone', state: 'MT' },
    // Nebraska (NE) - 93 counties
    { fips: '31001', name: 'Adams', state: 'NE' },
    { fips: '31003', name: 'Antelope', state: 'NE' },
    { fips: '31005', name: 'Arthur', state: 'NE' },
    { fips: '31007', name: 'Banner', state: 'NE' },
    { fips: '31009', name: 'Blaine', state: 'NE' },
    { fips: '31011', name: 'Boone', state: 'NE' },
    { fips: '31013', name: 'Box Butte', state: 'NE' },
    { fips: '31015', name: 'Boyd', state: 'NE' },
    { fips: '31017', name: 'Brown', state: 'NE' },
    { fips: '31019', name: 'Buffalo', state: 'NE' },
    { fips: '31021', name: 'Burt', state: 'NE' },
    { fips: '31023', name: 'Butler', state: 'NE' },
    { fips: '31025', name: 'Cass', state: 'NE' },
    { fips: '31027', name: 'Cedar', state: 'NE' },
    { fips: '31029', name: 'Chase', state: 'NE' },
    { fips: '31031', name: 'Cherry', state: 'NE' },
    { fips: '31033', name: 'Cheyenne', state: 'NE' },
    { fips: '31035', name: 'Clay', state: 'NE' },
    { fips: '31037', name: 'Colfax', state: 'NE' },
    { fips: '31039', name: 'Cuming', state: 'NE' },
    { fips: '31041', name: 'Custer', state: 'NE' },
    { fips: '31043', name: 'Dakota', state: 'NE' },
    { fips: '31045', name: 'Dawes', state: 'NE' },
    { fips: '31047', name: 'Dawson', state: 'NE' },
    { fips: '31049', name: 'Deuel', state: 'NE' },
    { fips: '31051', name: 'Dixon', state: 'NE' },
    { fips: '31053', name: 'Dodge', state: 'NE' },
    { fips: '31055', name: 'Douglas', state: 'NE' },
    { fips: '31057', name: 'Dundy', state: 'NE' },
    { fips: '31059', name: 'Fillmore', state: 'NE' },
    { fips: '31061', name: 'Franklin', state: 'NE' },
    { fips: '31063', name: 'Frontier', state: 'NE' },
    { fips: '31065', name: 'Furnas', state: 'NE' },
    { fips: '31067', name: 'Gage', state: 'NE' },
    { fips: '31069', name: 'Garden', state: 'NE' },
    { fips: '31071', name: 'Garfield', state: 'NE' },
    { fips: '31073', name: 'Gosper', state: 'NE' },
    { fips: '31075', name: 'Grant', state: 'NE' },
    { fips: '31077', name: 'Greeley', state: 'NE' },
    { fips: '31079', name: 'Hall', state: 'NE' },
    { fips: '31081', name: 'Hamilton', state: 'NE' },
    { fips: '31083', name: 'Harlan', state: 'NE' },
    { fips: '31085', name: 'Hayes', state: 'NE' },
    { fips: '31087', name: 'Hitchcock', state: 'NE' },
    { fips: '31089', name: 'Holt', state: 'NE' },
    { fips: '31091', name: 'Hooker', state: 'NE' },
    { fips: '31093', name: 'Howard', state: 'NE' },
    { fips: '31095', name: 'Jefferson', state: 'NE' },
    { fips: '31097', name: 'Johnson', state: 'NE' },
    { fips: '31099', name: 'Kearney', state: 'NE' },
    { fips: '31101', name: 'Keith', state: 'NE' },
    { fips: '31103', name: 'Keya Paha', state: 'NE' },
    { fips: '31105', name: 'Kimball', state: 'NE' },
    { fips: '31107', name: 'Knox', state: 'NE' },
    { fips: '31109', name: 'Lancaster', state: 'NE' },
    { fips: '31111', name: 'Lincoln', state: 'NE' },
    { fips: '31113', name: 'Logan', state: 'NE' },
    { fips: '31115', name: 'Loup', state: 'NE' },
    { fips: '31117', name: 'McPherson', state: 'NE' },
    { fips: '31119', name: 'Madison', state: 'NE' },
    { fips: '31121', name: 'Merrick', state: 'NE' },
    { fips: '31123', name: 'Morrill', state: 'NE' },
    { fips: '31125', name: 'Nance', state: 'NE' },
    { fips: '31127', name: 'Nemaha', state: 'NE' },
    { fips: '31129', name: 'Nuckolls', state: 'NE' },
    { fips: '31131', name: 'Otoe', state: 'NE' },
    { fips: '31133', name: 'Pawnee', state: 'NE' },
    { fips: '31135', name: 'Perkins', state: 'NE' },
    { fips: '31137', name: 'Phelps', state: 'NE' },
    { fips: '31139', name: 'Pierce', state: 'NE' },
    { fips: '31141', name: 'Platte', state: 'NE' },
    { fips: '31143', name: 'Polk', state: 'NE' },
    { fips: '31145', name: 'Red Willow', state: 'NE' },
    { fips: '31147', name: 'Richardson', state: 'NE' },
    { fips: '31149', name: 'Rock', state: 'NE' },
    { fips: '31151', name: 'Saline', state: 'NE' },
    { fips: '31153', name: 'Sarpy', state: 'NE' },
    { fips: '31155', name: 'Saunders', state: 'NE' },
    { fips: '31157', name: 'Scotts Bluff', state: 'NE' },
    { fips: '31159', name: 'Seward', state: 'NE' },
    { fips: '31161', name: 'Sheridan', state: 'NE' },
    { fips: '31163', name: 'Sherman', state: 'NE' },
    { fips: '31165', name: 'Sioux', state: 'NE' },
    { fips: '31167', name: 'Stanton', state: 'NE' },
    { fips: '31169', name: 'Thayer', state: 'NE' },
    { fips: '31171', name: 'Thomas', state: 'NE' },
    { fips: '31173', name: 'Thurston', state: 'NE' },
    { fips: '31175', name: 'Valley', state: 'NE' },
    { fips: '31177', name: 'Washington', state: 'NE' },
    { fips: '31179', name: 'Wayne', state: 'NE' },
    { fips: '31181', name: 'Webster', state: 'NE' },
    { fips: '31183', name: 'Wheeler', state: 'NE' },
    { fips: '31185', name: 'York', state: 'NE' },
    // Nevada (NV) - 17 counties
    { fips: '32001', name: 'Churchill', state: 'NV' },
    { fips: '32003', name: 'Clark', state: 'NV' },
    { fips: '32005', name: 'Douglas', state: 'NV' },
    { fips: '32007', name: 'Elko', state: 'NV' },
    { fips: '32009', name: 'Esmeralda', state: 'NV' },
    { fips: '32011', name: 'Eureka', state: 'NV' },
    { fips: '32013', name: 'Humboldt', state: 'NV' },
    { fips: '32015', name: 'Lander', state: 'NV' },
    { fips: '32017', name: 'Lincoln', state: 'NV' },
    { fips: '32019', name: 'Lyon', state: 'NV' },
    { fips: '32021', name: 'Mineral', state: 'NV' },
    { fips: '32023', name: 'Nye', state: 'NV' },
    { fips: '32027', name: 'Pershing', state: 'NV' },
    { fips: '32029', name: 'Storey', state: 'NV' },
    { fips: '32031', name: 'Washoe', state: 'NV' },
    { fips: '32033', name: 'White Pine', state: 'NV' },
    { fips: '32510', name: 'Carson City', state: 'NV' },
    // New Hampshire (NH) - 10 counties
    { fips: '33001', name: 'Belknap', state: 'NH' },
    { fips: '33003', name: 'Carroll', state: 'NH' },
    { fips: '33005', name: 'Cheshire', state: 'NH' },
    { fips: '33007', name: 'Coos', state: 'NH' },
    { fips: '33009', name: 'Grafton', state: 'NH' },
    { fips: '33011', name: 'Hillsborough', state: 'NH' },
    { fips: '33013', name: 'Merrimack', state: 'NH' },
    { fips: '33015', name: 'Rockingham', state: 'NH' },
    { fips: '33017', name: 'Strafford', state: 'NH' },
    { fips: '33019', name: 'Sullivan', state: 'NH' },
    // New Jersey (NJ) - 21 counties
    { fips: '34001', name: 'Atlantic', state: 'NJ' },
    { fips: '34003', name: 'Bergen', state: 'NJ' },
    { fips: '34005', name: 'Burlington', state: 'NJ' },
    { fips: '34007', name: 'Camden', state: 'NJ' },
    { fips: '34009', name: 'Cape May', state: 'NJ' },
    { fips: '34011', name: 'Cumberland', state: 'NJ' },
    { fips: '34013', name: 'Essex', state: 'NJ' },
    { fips: '34015', name: 'Gloucester', state: 'NJ' },
    { fips: '34017', name: 'Hudson', state: 'NJ' },
    { fips: '34019', name: 'Hunterdon', state: 'NJ' },
    { fips: '34021', name: 'Mercer', state: 'NJ' },
    { fips: '34023', name: 'Middlesex', state: 'NJ' },
    { fips: '34025', name: 'Monmouth', state: 'NJ' },
    { fips: '34027', name: 'Morris', state: 'NJ' },
    { fips: '34029', name: 'Ocean', state: 'NJ' },
    { fips: '34031', name: 'Passaic', state: 'NJ' },
    { fips: '34033', name: 'Salem', state: 'NJ' },
    { fips: '34035', name: 'Somerset', state: 'NJ' },
    { fips: '34037', name: 'Sussex', state: 'NJ' },
    { fips: '34039', name: 'Union', state: 'NJ' },
    { fips: '34041', name: 'Warren', state: 'NJ' },
    // New Mexico (NM) - 33 counties
    { fips: '35001', name: 'Bernalillo', state: 'NM' },
    { fips: '35003', name: 'Catron', state: 'NM' },
    { fips: '35005', name: 'Chaves', state: 'NM' },
    { fips: '35006', name: 'Cibola', state: 'NM' },
    { fips: '35007', name: 'Colfax', state: 'NM' },
    { fips: '35009', name: 'Curry', state: 'NM' },
    { fips: '35011', name: 'De Baca', state: 'NM' },
    { fips: '35013', name: 'Dona Ana', state: 'NM' },
    { fips: '35015', name: 'Eddy', state: 'NM' },
    { fips: '35017', name: 'Grant', state: 'NM' },
    { fips: '35019', name: 'Guadalupe', state: 'NM' },
    { fips: '35021', name: 'Harding', state: 'NM' },
    { fips: '35023', name: 'Hidalgo', state: 'NM' },
    { fips: '35025', name: 'Lea', state: 'NM' },
    { fips: '35027', name: 'Lincoln', state: 'NM' },
    { fips: '35028', name: 'Los Alamos', state: 'NM' },
    { fips: '35029', name: 'Luna', state: 'NM' },
    { fips: '35031', name: 'McKinley', state: 'NM' },
    { fips: '35033', name: 'Mora', state: 'NM' },
    { fips: '35035', name: 'Otero', state: 'NM' },
    { fips: '35037', name: 'Quay', state: 'NM' },
    { fips: '35039', name: 'Rio Arriba', state: 'NM' },
    { fips: '35041', name: 'Roosevelt', state: 'NM' },
    { fips: '35043', name: 'Sandoval', state: 'NM' },
    { fips: '35045', name: 'San Juan', state: 'NM' },
    { fips: '35047', name: 'San Miguel', state: 'NM' },
    { fips: '35049', name: 'Santa Fe', state: 'NM' },
    { fips: '35051', name: 'Sierra', state: 'NM' },
    { fips: '35053', name: 'Socorro', state: 'NM' },
    { fips: '35055', name: 'Taos', state: 'NM' },
    { fips: '35057', name: 'Torrance', state: 'NM' },
    { fips: '35059', name: 'Union', state: 'NM' },
    { fips: '35061', name: 'Valencia', state: 'NM' },
    // New York (NY) - 62 counties
    { fips: '36001', name: 'Albany', state: 'NY' },
    { fips: '36003', name: 'Allegany', state: 'NY' },
    { fips: '36005', name: 'Bronx', state: 'NY' },
    { fips: '36007', name: 'Broome', state: 'NY' },
    { fips: '36009', name: 'Cattaraugus', state: 'NY' },
    { fips: '36011', name: 'Cayuga', state: 'NY' },
    { fips: '36013', name: 'Chautauqua', state: 'NY' },
    { fips: '36015', name: 'Chemung', state: 'NY' },
    { fips: '36017', name: 'Chenango', state: 'NY' },
    { fips: '36019', name: 'Clinton', state: 'NY' },
    { fips: '36021', name: 'Columbia', state: 'NY' },
    { fips: '36023', name: 'Cortland', state: 'NY' },
    { fips: '36025', name: 'Delaware', state: 'NY' },
    { fips: '36027', name: 'Dutchess', state: 'NY' },
    { fips: '36029', name: 'Erie', state: 'NY' },
    { fips: '36031', name: 'Essex', state: 'NY' },
    { fips: '36033', name: 'Franklin', state: 'NY' },
    { fips: '36035', name: 'Fulton', state: 'NY' },
    { fips: '36037', name: 'Genesee', state: 'NY' },
    { fips: '36039', name: 'Greene', state: 'NY' },
    { fips: '36041', name: 'Hamilton', state: 'NY' },
    { fips: '36043', name: 'Herkimer', state: 'NY' },
    { fips: '36045', name: 'Jefferson', state: 'NY' },
    { fips: '36047', name: 'Kings', state: 'NY' },
    { fips: '36049', name: 'Lewis', state: 'NY' },
    { fips: '36051', name: 'Livingston', state: 'NY' },
    { fips: '36053', name: 'Madison', state: 'NY' },
    { fips: '36055', name: 'Monroe', state: 'NY' },
    { fips: '36057', name: 'Montgomery', state: 'NY' },
    { fips: '36059', name: 'Nassau', state: 'NY' },
    { fips: '36061', name: 'New York', state: 'NY' },
    { fips: '36063', name: 'Niagara', state: 'NY' },
    { fips: '36065', name: 'Oneida', state: 'NY' },
    { fips: '36067', name: 'Onondaga', state: 'NY' },
    { fips: '36069', name: 'Ontario', state: 'NY' },
    { fips: '36071', name: 'Orange', state: 'NY' },
    { fips: '36073', name: 'Orleans', state: 'NY' },
    { fips: '36075', name: 'Oswego', state: 'NY' },
    { fips: '36077', name: 'Otsego', state: 'NY' },
    { fips: '36079', name: 'Putnam', state: 'NY' },
    { fips: '36081', name: 'Queens', state: 'NY' },
    { fips: '36083', name: 'Rensselaer', state: 'NY' },
    { fips: '36085', name: 'Richmond', state: 'NY' },
    { fips: '36087', name: 'Rockland', state: 'NY' },
    { fips: '36089', name: 'St. Lawrence', state: 'NY' },
    { fips: '36091', name: 'Saratoga', state: 'NY' },
    { fips: '36093', name: 'Schenectady', state: 'NY' },
    { fips: '36095', name: 'Schoharie', state: 'NY' },
    { fips: '36097', name: 'Schuyler', state: 'NY' },
    { fips: '36099', name: 'Seneca', state: 'NY' },
    { fips: '36101', name: 'Steuben', state: 'NY' },
    { fips: '36103', name: 'Suffolk', state: 'NY' },
    { fips: '36105', name: 'Sullivan', state: 'NY' },
    { fips: '36107', name: 'Tioga', state: 'NY' },
    { fips: '36109', name: 'Tompkins', state: 'NY' },
    { fips: '36111', name: 'Ulster', state: 'NY' },
    { fips: '36113', name: 'Warren', state: 'NY' },
    { fips: '36115', name: 'Washington', state: 'NY' },
    { fips: '36117', name: 'Wayne', state: 'NY' },
    { fips: '36119', name: 'Westchester', state: 'NY' },
    { fips: '36121', name: 'Wyoming', state: 'NY' },
    { fips: '36123', name: 'Yates', state: 'NY' },
    // North Carolina (NC) - 100 counties
    { fips: '37001', name: 'Alamance', state: 'NC' },
    { fips: '37003', name: 'Alexander', state: 'NC' },
    { fips: '37005', name: 'Alleghany', state: 'NC' },
    { fips: '37007', name: 'Anson', state: 'NC' },
    { fips: '37009', name: 'Ashe', state: 'NC' },
    { fips: '37011', name: 'Avery', state: 'NC' },
    { fips: '37013', name: 'Beaufort', state: 'NC' },
    { fips: '37015', name: 'Bertie', state: 'NC' },
    { fips: '37017', name: 'Bladen', state: 'NC' },
    { fips: '37019', name: 'Brunswick', state: 'NC' },
    { fips: '37021', name: 'Buncombe', state: 'NC' },
    { fips: '37023', name: 'Burke', state: 'NC' },
    { fips: '37025', name: 'Cabarrus', state: 'NC' },
    { fips: '37027', name: 'Caldwell', state: 'NC' },
    { fips: '37029', name: 'Camden', state: 'NC' },
    { fips: '37031', name: 'Carteret', state: 'NC' },
    { fips: '37033', name: 'Caswell', state: 'NC' },
    { fips: '37035', name: 'Catawba', state: 'NC' },
    { fips: '37037', name: 'Chatham', state: 'NC' },
    { fips: '37039', name: 'Cherokee', state: 'NC' },
    { fips: '37041', name: 'Chowan', state: 'NC' },
    { fips: '37043', name: 'Clay', state: 'NC' },
    { fips: '37045', name: 'Cleveland', state: 'NC' },
    { fips: '37047', name: 'Columbus', state: 'NC' },
    { fips: '37049', name: 'Craven', state: 'NC' },
    { fips: '37051', name: 'Cumberland', state: 'NC' },
    { fips: '37053', name: 'Currituck', state: 'NC' },
    { fips: '37055', name: 'Dare', state: 'NC' },
    { fips: '37057', name: 'Davidson', state: 'NC' },
    { fips: '37059', name: 'Davie', state: 'NC' },
    { fips: '37061', name: 'Duplin', state: 'NC' },
    { fips: '37063', name: 'Durham', state: 'NC' },
    { fips: '37065', name: 'Edgecombe', state: 'NC' },
    { fips: '37067', name: 'Forsyth', state: 'NC' },
    { fips: '37069', name: 'Franklin', state: 'NC' },
    { fips: '37071', name: 'Gaston', state: 'NC' },
    { fips: '37073', name: 'Gates', state: 'NC' },
    { fips: '37075', name: 'Graham', state: 'NC' },
    { fips: '37077', name: 'Granville', state: 'NC' },
    { fips: '37079', name: 'Greene', state: 'NC' },
    { fips: '37081', name: 'Guilford', state: 'NC' },
    { fips: '37083', name: 'Halifax', state: 'NC' },
    { fips: '37085', name: 'Harnett', state: 'NC' },
    { fips: '37087', name: 'Haywood', state: 'NC' },
    { fips: '37089', name: 'Henderson', state: 'NC' },
    { fips: '37091', name: 'Hertford', state: 'NC' },
    { fips: '37093', name: 'Hoke', state: 'NC' },
    { fips: '37095', name: 'Hyde', state: 'NC' },
    { fips: '37097', name: 'Iredell', state: 'NC' },
    { fips: '37099', name: 'Jackson', state: 'NC' },
    { fips: '37101', name: 'Johnston', state: 'NC' },
    { fips: '37103', name: 'Jones', state: 'NC' },
    { fips: '37105', name: 'Lee', state: 'NC' },
    { fips: '37107', name: 'Lenoir', state: 'NC' },
    { fips: '37109', name: 'Lincoln', state: 'NC' },
    { fips: '37111', name: 'McDowell', state: 'NC' },
    { fips: '37113', name: 'Macon', state: 'NC' },
    { fips: '37115', name: 'Madison', state: 'NC' },
    { fips: '37117', name: 'Martin', state: 'NC' },
    { fips: '37119', name: 'Mecklenburg', state: 'NC' },
    { fips: '37121', name: 'Mitchell', state: 'NC' },
    { fips: '37123', name: 'Montgomery', state: 'NC' },
    { fips: '37125', name: 'Moore', state: 'NC' },
    { fips: '37127', name: 'Nash', state: 'NC' },
    { fips: '37129', name: 'New Hanover', state: 'NC' },
    { fips: '37131', name: 'Northampton', state: 'NC' },
    { fips: '37133', name: 'Onslow', state: 'NC' },
    { fips: '37135', name: 'Orange', state: 'NC' },
    { fips: '37137', name: 'Pamlico', state: 'NC' },
    { fips: '37139', name: 'Pasquotank', state: 'NC' },
    { fips: '37141', name: 'Pender', state: 'NC' },
    { fips: '37143', name: 'Perquimans', state: 'NC' },
    { fips: '37145', name: 'Person', state: 'NC' },
    { fips: '37147', name: 'Pitt', state: 'NC' },
    { fips: '37149', name: 'Polk', state: 'NC' },
    { fips: '37151', name: 'Randolph', state: 'NC' },
    { fips: '37153', name: 'Richmond', state: 'NC' },
    { fips: '37155', name: 'Robeson', state: 'NC' },
    { fips: '37157', name: 'Rockingham', state: 'NC' },
    { fips: '37159', name: 'Rowan', state: 'NC' },
    { fips: '37161', name: 'Rutherford', state: 'NC' },
    { fips: '37163', name: 'Sampson', state: 'NC' },
    { fips: '37165', name: 'Scotland', state: 'NC' },
    { fips: '37167', name: 'Stanly', state: 'NC' },
    { fips: '37169', name: 'Stokes', state: 'NC' },
    { fips: '37171', name: 'Surry', state: 'NC' },
    { fips: '37173', name: 'Swain', state: 'NC' },
    { fips: '37175', name: 'Transylvania', state: 'NC' },
    { fips: '37177', name: 'Tyrrell', state: 'NC' },
    { fips: '37179', name: 'Union', state: 'NC' },
    { fips: '37181', name: 'Vance', state: 'NC' },
    { fips: '37183', name: 'Wake', state: 'NC' },
    { fips: '37185', name: 'Warren', state: 'NC' },
    { fips: '37187', name: 'Washington', state: 'NC' },
    { fips: '37189', name: 'Watauga', state: 'NC' },
    { fips: '37191', name: 'Wayne', state: 'NC' },
    { fips: '37193', name: 'Wilkes', state: 'NC' },
    { fips: '37195', name: 'Wilson', state: 'NC' },
    { fips: '37197', name: 'Yadkin', state: 'NC' },
    { fips: '37199', name: 'Yancey', state: 'NC' },
    // North Dakota (ND) - 53 counties
    { fips: '38001', name: 'Adams', state: 'ND' },
    { fips: '38003', name: 'Barnes', state: 'ND' },
    { fips: '38005', name: 'Benson', state: 'ND' },
    { fips: '38007', name: 'Billings', state: 'ND' },
    { fips: '38009', name: 'Bottineau', state: 'ND' },
    { fips: '38011', name: 'Bowman', state: 'ND' },
    { fips: '38013', name: 'Burke', state: 'ND' },
    { fips: '38015', name: 'Burleigh', state: 'ND' },
    { fips: '38017', name: 'Cass', state: 'ND' },
    { fips: '38019', name: 'Cavalier', state: 'ND' },
    { fips: '38021', name: 'Dickey', state: 'ND' },
    { fips: '38023', name: 'Divide', state: 'ND' },
    { fips: '38025', name: 'Dunn', state: 'ND' },
    { fips: '38027', name: 'Eddy', state: 'ND' },
    { fips: '38029', name: 'Emmons', state: 'ND' },
    { fips: '38031', name: 'Foster', state: 'ND' },
    { fips: '38033', name: 'Golden Valley', state: 'ND' },
    { fips: '38035', name: 'Grand Forks', state: 'ND' },
    { fips: '38037', name: 'Grant', state: 'ND' },
    { fips: '38039', name: 'Griggs', state: 'ND' },
    { fips: '38041', name: 'Hettinger', state: 'ND' },
    { fips: '38043', name: 'Kidder', state: 'ND' },
    { fips: '38045', name: 'LaMoure', state: 'ND' },
    { fips: '38047', name: 'Logan', state: 'ND' },
    { fips: '38049', name: 'McHenry', state: 'ND' },
    { fips: '38051', name: 'McIntosh', state: 'ND' },
    { fips: '38053', name: 'McKenzie', state: 'ND' },
    { fips: '38055', name: 'McLean', state: 'ND' },
    { fips: '38057', name: 'Mercer', state: 'ND' },
    { fips: '38059', name: 'Morton', state: 'ND' },
    { fips: '38061', name: 'Mountrail', state: 'ND' },
    { fips: '38063', name: 'Nelson', state: 'ND' },
    { fips: '38065', name: 'Oliver', state: 'ND' },
    { fips: '38067', name: 'Pembina', state: 'ND' },
    { fips: '38069', name: 'Pierce', state: 'ND' },
    { fips: '38071', name: 'Ramsey', state: 'ND' },
    { fips: '38073', name: 'Ransom', state: 'ND' },
    { fips: '38075', name: 'Renville', state: 'ND' },
    { fips: '38077', name: 'Richland', state: 'ND' },
    { fips: '38079', name: 'Rolette', state: 'ND' },
    { fips: '38081', name: 'Sargent', state: 'ND' },
    { fips: '38083', name: 'Sheridan', state: 'ND' },
    { fips: '38085', name: 'Sioux', state: 'ND' },
    { fips: '38087', name: 'Slope', state: 'ND' },
    { fips: '38089', name: 'Stark', state: 'ND' },
    { fips: '38091', name: 'Steele', state: 'ND' },
    { fips: '38093', name: 'Stutsman', state: 'ND' },
    { fips: '38095', name: 'Towner', state: 'ND' },
    { fips: '38097', name: 'Traill', state: 'ND' },
    { fips: '38099', name: 'Walsh', state: 'ND' },
    { fips: '38101', name: 'Ward', state: 'ND' },
    { fips: '38103', name: 'Wells', state: 'ND' },
    { fips: '38105', name: 'Williams', state: 'ND' },
    // Ohio (OH) - 88 counties
    { fips: '39001', name: 'Adams', state: 'OH' },
    { fips: '39003', name: 'Allen', state: 'OH' },
    { fips: '39005', name: 'Ashland', state: 'OH' },
    { fips: '39007', name: 'Ashtabula', state: 'OH' },
    { fips: '39009', name: 'Athens', state: 'OH' },
    { fips: '39011', name: 'Auglaize', state: 'OH' },
    { fips: '39013', name: 'Belmont', state: 'OH' },
    { fips: '39015', name: 'Brown', state: 'OH' },
    { fips: '39017', name: 'Butler', state: 'OH' },
    { fips: '39019', name: 'Carroll', state: 'OH' },
    { fips: '39021', name: 'Champaign', state: 'OH' },
    { fips: '39023', name: 'Clark', state: 'OH' },
    { fips: '39025', name: 'Clermont', state: 'OH' },
    { fips: '39027', name: 'Clinton', state: 'OH' },
    { fips: '39029', name: 'Columbiana', state: 'OH' },
    { fips: '39031', name: 'Coshocton', state: 'OH' },
    { fips: '39033', name: 'Crawford', state: 'OH' },
    { fips: '39035', name: 'Cuyahoga', state: 'OH' },
    { fips: '39037', name: 'Darke', state: 'OH' },
    { fips: '39039', name: 'Defiance', state: 'OH' },
    { fips: '39041', name: 'Delaware', state: 'OH' },
    { fips: '39043', name: 'Erie', state: 'OH' },
    { fips: '39045', name: 'Fairfield', state: 'OH' },
    { fips: '39047', name: 'Fayette', state: 'OH' },
    { fips: '39049', name: 'Franklin', state: 'OH' },
    { fips: '39051', name: 'Fulton', state: 'OH' },
    { fips: '39053', name: 'Gallia', state: 'OH' },
    { fips: '39055', name: 'Geauga', state: 'OH' },
    { fips: '39057', name: 'Greene', state: 'OH' },
    { fips: '39059', name: 'Guernsey', state: 'OH' },
    { fips: '39061', name: 'Hamilton', state: 'OH' },
    { fips: '39063', name: 'Hancock', state: 'OH' },
    { fips: '39065', name: 'Hardin', state: 'OH' },
    { fips: '39067', name: 'Harrison', state: 'OH' },
    { fips: '39069', name: 'Henry', state: 'OH' },
    { fips: '39071', name: 'Highland', state: 'OH' },
    { fips: '39073', name: 'Hocking', state: 'OH' },
    { fips: '39075', name: 'Holmes', state: 'OH' },
    { fips: '39077', name: 'Huron', state: 'OH' },
    { fips: '39079', name: 'Jackson', state: 'OH' },
    { fips: '39081', name: 'Jefferson', state: 'OH' },
    { fips: '39083', name: 'Knox', state: 'OH' },
    { fips: '39085', name: 'Lake', state: 'OH' },
    { fips: '39087', name: 'Lawrence', state: 'OH' },
    { fips: '39089', name: 'Licking', state: 'OH' },
    { fips: '39091', name: 'Logan', state: 'OH' },
    { fips: '39093', name: 'Lorain', state: 'OH' },
    { fips: '39095', name: 'Lucas', state: 'OH' },
    { fips: '39097', name: 'Madison', state: 'OH' },
    { fips: '39099', name: 'Mahoning', state: 'OH' },
    { fips: '39101', name: 'Marion', state: 'OH' },
    { fips: '39103', name: 'Medina', state: 'OH' },
    { fips: '39105', name: 'Meigs', state: 'OH' },
    { fips: '39107', name: 'Mercer', state: 'OH' },
    { fips: '39109', name: 'Miami', state: 'OH' },
    { fips: '39111', name: 'Monroe', state: 'OH' },
    { fips: '39113', name: 'Montgomery', state: 'OH' },
    { fips: '39115', name: 'Morgan', state: 'OH' },
    { fips: '39117', name: 'Morrow', state: 'OH' },
    { fips: '39119', name: 'Muskingum', state: 'OH' },
    { fips: '39121', name: 'Noble', state: 'OH' },
    { fips: '39123', name: 'Ottawa', state: 'OH' },
    { fips: '39125', name: 'Paulding', state: 'OH' },
    { fips: '39127', name: 'Perry', state: 'OH' },
    { fips: '39129', name: 'Pickaway', state: 'OH' },
    { fips: '39131', name: 'Pike', state: 'OH' },
    { fips: '39133', name: 'Portage', state: 'OH' },
    { fips: '39135', name: 'Preble', state: 'OH' },
    { fips: '39137', name: 'Putnam', state: 'OH' },
    { fips: '39139', name: 'Richland', state: 'OH' },
    { fips: '39141', name: 'Ross', state: 'OH' },
    { fips: '39143', name: 'Sandusky', state: 'OH' },
    { fips: '39145', name: 'Scioto', state: 'OH' },
    { fips: '39147', name: 'Seneca', state: 'OH' },
    { fips: '39149', name: 'Shelby', state: 'OH' },
    { fips: '39151', name: 'Stark', state: 'OH' },
    { fips: '39153', name: 'Summit', state: 'OH' },
    { fips: '39155', name: 'Trumbull', state: 'OH' },
    { fips: '39157', name: 'Tuscarawas', state: 'OH' },
    { fips: '39159', name: 'Union', state: 'OH' },
    { fips: '39161', name: 'Van Wert', state: 'OH' },
    { fips: '39163', name: 'Vinton', state: 'OH' },
    { fips: '39165', name: 'Warren', state: 'OH' },
    { fips: '39167', name: 'Washington', state: 'OH' },
    { fips: '39169', name: 'Wayne', state: 'OH' },
    { fips: '39171', name: 'Williams', state: 'OH' },
    { fips: '39173', name: 'Wood', state: 'OH' },
    { fips: '39175', name: 'Wyandot', state: 'OH' },
    // Oklahoma (OK) - 77 counties
    { fips: '40001', name: 'Adair', state: 'OK' },
    { fips: '40003', name: 'Alfalfa', state: 'OK' },
    { fips: '40005', name: 'Atoka', state: 'OK' },
    { fips: '40007', name: 'Beaver', state: 'OK' },
    { fips: '40009', name: 'Beckham', state: 'OK' },
    { fips: '40011', name: 'Blaine', state: 'OK' },
    { fips: '40013', name: 'Bryan', state: 'OK' },
    { fips: '40015', name: 'Caddo', state: 'OK' },
    { fips: '40017', name: 'Canadian', state: 'OK' },
    { fips: '40019', name: 'Carter', state: 'OK' },
    { fips: '40021', name: 'Cherokee', state: 'OK' },
    { fips: '40023', name: 'Choctaw', state: 'OK' },
    { fips: '40025', name: 'Cimarron', state: 'OK' },
    { fips: '40027', name: 'Cleveland', state: 'OK' },
    { fips: '40029', name: 'Coal', state: 'OK' },
    { fips: '40031', name: 'Comanche', state: 'OK' },
    { fips: '40033', name: 'Cotton', state: 'OK' },
    { fips: '40035', name: 'Craig', state: 'OK' },
    { fips: '40037', name: 'Creek', state: 'OK' },
    { fips: '40039', name: 'Custer', state: 'OK' },
    { fips: '40041', name: 'Delaware', state: 'OK' },
    { fips: '40043', name: 'Dewey', state: 'OK' },
    { fips: '40045', name: 'Ellis', state: 'OK' },
    { fips: '40047', name: 'Garfield', state: 'OK' },
    { fips: '40049', name: 'Garvin', state: 'OK' },
    { fips: '40051', name: 'Grady', state: 'OK' },
    { fips: '40053', name: 'Grant', state: 'OK' },
    { fips: '40055', name: 'Greer', state: 'OK' },
    { fips: '40057', name: 'Harmon', state: 'OK' },
    { fips: '40059', name: 'Harper', state: 'OK' },
    { fips: '40061', name: 'Haskell', state: 'OK' },
    { fips: '40063', name: 'Hughes', state: 'OK' },
    { fips: '40065', name: 'Jackson', state: 'OK' },
    { fips: '40067', name: 'Jefferson', state: 'OK' },
    { fips: '40069', name: 'Johnston', state: 'OK' },
    { fips: '40071', name: 'Kay', state: 'OK' },
    { fips: '40073', name: 'Kingfisher', state: 'OK' },
    { fips: '40075', name: 'Kiowa', state: 'OK' },
    { fips: '40077', name: 'Latimer', state: 'OK' },
    { fips: '40079', name: 'Le Flore', state: 'OK' },
    { fips: '40081', name: 'Lincoln', state: 'OK' },
    { fips: '40083', name: 'Logan', state: 'OK' },
    { fips: '40085', name: 'Love', state: 'OK' },
    { fips: '40087', name: 'McClain', state: 'OK' },
    { fips: '40089', name: 'McCurtain', state: 'OK' },
    { fips: '40091', name: 'McIntosh', state: 'OK' },
    { fips: '40093', name: 'Major', state: 'OK' },
    { fips: '40095', name: 'Marshall', state: 'OK' },
    { fips: '40097', name: 'Mayes', state: 'OK' },
    { fips: '40099', name: 'Murray', state: 'OK' },
    { fips: '40101', name: 'Muskogee', state: 'OK' },
    { fips: '40103', name: 'Noble', state: 'OK' },
    { fips: '40105', name: 'Nowata', state: 'OK' },
    { fips: '40107', name: 'Okfuskee', state: 'OK' },
    { fips: '40109', name: 'Oklahoma', state: 'OK' },
    { fips: '40111', name: 'Okmulgee', state: 'OK' },
    { fips: '40113', name: 'Osage', state: 'OK' },
    { fips: '40115', name: 'Ottawa', state: 'OK' },
    { fips: '40117', name: 'Pawnee', state: 'OK' },
    { fips: '40119', name: 'Payne', state: 'OK' },
    { fips: '40121', name: 'Pittsburg', state: 'OK' },
    { fips: '40123', name: 'Pontotoc', state: 'OK' },
    { fips: '40125', name: 'Pottawatomie', state: 'OK' },
    { fips: '40127', name: 'Pushmataha', state: 'OK' },
    { fips: '40129', name: 'Roger Mills', state: 'OK' },
    { fips: '40131', name: 'Rogers', state: 'OK' },
    { fips: '40133', name: 'Seminole', state: 'OK' },
    { fips: '40135', name: 'Sequoyah', state: 'OK' },
    { fips: '40137', name: 'Stephens', state: 'OK' },
    { fips: '40139', name: 'Texas', state: 'OK' },
    { fips: '40141', name: 'Tillman', state: 'OK' },
    { fips: '40143', name: 'Tulsa', state: 'OK' },
    { fips: '40145', name: 'Wagoner', state: 'OK' },
    { fips: '40147', name: 'Washington', state: 'OK' },
    { fips: '40149', name: 'Washita', state: 'OK' },
    { fips: '40151', name: 'Woods', state: 'OK' },
    { fips: '40153', name: 'Woodward', state: 'OK' },
    // Oregon (OR) - 36 counties
    { fips: '41001', name: 'Baker', state: 'OR' },
    { fips: '41003', name: 'Benton', state: 'OR' },
    { fips: '41005', name: 'Clackamas', state: 'OR' },
    { fips: '41007', name: 'Clatsop', state: 'OR' },
    { fips: '41009', name: 'Columbia', state: 'OR' },
    { fips: '41011', name: 'Coos', state: 'OR' },
    { fips: '41013', name: 'Crook', state: 'OR' },
    { fips: '41015', name: 'Curry', state: 'OR' },
    { fips: '41017', name: 'Deschutes', state: 'OR' },
    { fips: '41019', name: 'Douglas', state: 'OR' },
    { fips: '41021', name: 'Gilliam', state: 'OR' },
    { fips: '41023', name: 'Grant', state: 'OR' },
    { fips: '41025', name: 'Harney', state: 'OR' },
    { fips: '41027', name: 'Hood River', state: 'OR' },
    { fips: '41029', name: 'Jackson', state: 'OR' },
    { fips: '41031', name: 'Jefferson', state: 'OR' },
    { fips: '41033', name: 'Josephine', state: 'OR' },
    { fips: '41035', name: 'Klamath', state: 'OR' },
    { fips: '41037', name: 'Lake', state: 'OR' },
    { fips: '41039', name: 'Lane', state: 'OR' },
    { fips: '41041', name: 'Lincoln', state: 'OR' },
    { fips: '41043', name: 'Linn', state: 'OR' },
    { fips: '41045', name: 'Malheur', state: 'OR' },
    { fips: '41047', name: 'Marion', state: 'OR' },
    { fips: '41049', name: 'Morrow', state: 'OR' },
    { fips: '41051', name: 'Multnomah', state: 'OR' },
    { fips: '41053', name: 'Polk', state: 'OR' },
    { fips: '41055', name: 'Sherman', state: 'OR' },
    { fips: '41057', name: 'Tillamook', state: 'OR' },
    { fips: '41059', name: 'Umatilla', state: 'OR' },
    { fips: '41061', name: 'Union', state: 'OR' },
    { fips: '41063', name: 'Wallowa', state: 'OR' },
    { fips: '41065', name: 'Wasco', state: 'OR' },
    { fips: '41067', name: 'Washington', state: 'OR' },
    { fips: '41069', name: 'Wheeler', state: 'OR' },
    { fips: '41071', name: 'Yamhill', state: 'OR' },
    // Pennsylvania (PA) - 67 counties
    { fips: '42001', name: 'Adams', state: 'PA' },
    { fips: '42003', name: 'Allegheny', state: 'PA' },
    { fips: '42005', name: 'Armstrong', state: 'PA' },
    { fips: '42007', name: 'Beaver', state: 'PA' },
    { fips: '42009', name: 'Bedford', state: 'PA' },
    { fips: '42011', name: 'Berks', state: 'PA' },
    { fips: '42013', name: 'Blair', state: 'PA' },
    { fips: '42015', name: 'Bradford', state: 'PA' },
    { fips: '42017', name: 'Bucks', state: 'PA' },
    { fips: '42019', name: 'Butler', state: 'PA' },
    { fips: '42021', name: 'Cambria', state: 'PA' },
    { fips: '42023', name: 'Cameron', state: 'PA' },
    { fips: '42025', name: 'Carbon', state: 'PA' },
    { fips: '42027', name: 'Centre', state: 'PA' },
    { fips: '42029', name: 'Chester', state: 'PA' },
    { fips: '42031', name: 'Clarion', state: 'PA' },
    { fips: '42033', name: 'Clearfield', state: 'PA' },
    { fips: '42035', name: 'Clinton', state: 'PA' },
    { fips: '42037', name: 'Columbia', state: 'PA' },
    { fips: '42039', name: 'Crawford', state: 'PA' },
    { fips: '42041', name: 'Cumberland', state: 'PA' },
    { fips: '42043', name: 'Dauphin', state: 'PA' },
    { fips: '42045', name: 'Delaware', state: 'PA' },
    { fips: '42047', name: 'Elk', state: 'PA' },
    { fips: '42049', name: 'Erie', state: 'PA' },
    { fips: '42051', name: 'Fayette', state: 'PA' },
    { fips: '42053', name: 'Forest', state: 'PA' },
    { fips: '42055', name: 'Franklin', state: 'PA' },
    { fips: '42057', name: 'Fulton', state: 'PA' },
    { fips: '42059', name: 'Greene', state: 'PA' },
    { fips: '42061', name: 'Huntingdon', state: 'PA' },
    { fips: '42063', name: 'Indiana', state: 'PA' },
    { fips: '42065', name: 'Jefferson', state: 'PA' },
    { fips: '42067', name: 'Juniata', state: 'PA' },
    { fips: '42069', name: 'Lackawanna', state: 'PA' },
    { fips: '42071', name: 'Lancaster', state: 'PA' },
    { fips: '42073', name: 'Lawrence', state: 'PA' },
    { fips: '42075', name: 'Lebanon', state: 'PA' },
    { fips: '42077', name: 'Lehigh', state: 'PA' },
    { fips: '42079', name: 'Luzerne', state: 'PA' },
    { fips: '42081', name: 'Lycoming', state: 'PA' },
    { fips: '42083', name: 'McKean', state: 'PA' },
    { fips: '42085', name: 'Mercer', state: 'PA' },
    { fips: '42087', name: 'Mifflin', state: 'PA' },
    { fips: '42089', name: 'Monroe', state: 'PA' },
    { fips: '42091', name: 'Montgomery', state: 'PA' },
    { fips: '42093', name: 'Montour', state: 'PA' },
    { fips: '42095', name: 'Northampton', state: 'PA' },
    { fips: '42097', name: 'Northumberland', state: 'PA' },
    { fips: '42099', name: 'Perry', state: 'PA' },
    { fips: '42101', name: 'Philadelphia', state: 'PA' },
    { fips: '42103', name: 'Pike', state: 'PA' },
    { fips: '42105', name: 'Potter', state: 'PA' },
    { fips: '42107', name: 'Schuylkill', state: 'PA' },
    { fips: '42109', name: 'Snyder', state: 'PA' },
    { fips: '42111', name: 'Somerset', state: 'PA' },
    { fips: '42113', name: 'Sullivan', state: 'PA' },
    { fips: '42115', name: 'Susquehanna', state: 'PA' },
    { fips: '42117', name: 'Tioga', state: 'PA' },
    { fips: '42119', name: 'Union', state: 'PA' },
    { fips: '42121', name: 'Venango', state: 'PA' },
    { fips: '42123', name: 'Warren', state: 'PA' },
    { fips: '42125', name: 'Washington', state: 'PA' },
    { fips: '42127', name: 'Wayne', state: 'PA' },
    { fips: '42129', name: 'Westmoreland', state: 'PA' },
    { fips: '42131', name: 'Wyoming', state: 'PA' },
    { fips: '42133', name: 'York', state: 'PA' },
    // Rhode Island (RI) - 5 counties
    { fips: '44001', name: 'Bristol', state: 'RI' },
    { fips: '44003', name: 'Kent', state: 'RI' },
    { fips: '44005', name: 'Newport', state: 'RI' },
    { fips: '44007', name: 'Providence', state: 'RI' },
    { fips: '44009', name: 'Washington', state: 'RI' },
    // South Carolina (SC) - 46 counties
    { fips: '45001', name: 'Abbeville', state: 'SC' },
    { fips: '45003', name: 'Aiken', state: 'SC' },
    { fips: '45005', name: 'Allendale', state: 'SC' },
    { fips: '45007', name: 'Anderson', state: 'SC' },
    { fips: '45009', name: 'Bamberg', state: 'SC' },
    { fips: '45011', name: 'Barnwell', state: 'SC' },
    { fips: '45013', name: 'Beaufort', state: 'SC' },
    { fips: '45015', name: 'Berkeley', state: 'SC' },
    { fips: '45017', name: 'Calhoun', state: 'SC' },
    { fips: '45019', name: 'Charleston', state: 'SC' },
    { fips: '45021', name: 'Cherokee', state: 'SC' },
    { fips: '45023', name: 'Chester', state: 'SC' },
    { fips: '45025', name: 'Chesterfield', state: 'SC' },
    { fips: '45027', name: 'Clarendon', state: 'SC' },
    { fips: '45029', name: 'Colleton', state: 'SC' },
    { fips: '45031', name: 'Darlington', state: 'SC' },
    { fips: '45033', name: 'Dillon', state: 'SC' },
    { fips: '45035', name: 'Dorchester', state: 'SC' },
    { fips: '45037', name: 'Edgefield', state: 'SC' },
    { fips: '45039', name: 'Fairfield', state: 'SC' },
    { fips: '45041', name: 'Florence', state: 'SC' },
    { fips: '45043', name: 'Georgetown', state: 'SC' },
    { fips: '45045', name: 'Greenville', state: 'SC' },
    { fips: '45047', name: 'Greenwood', state: 'SC' },
    { fips: '45049', name: 'Hampton', state: 'SC' },
    { fips: '45051', name: 'Horry', state: 'SC' },
    { fips: '45053', name: 'Jasper', state: 'SC' },
    { fips: '45055', name: 'Kershaw', state: 'SC' },
    { fips: '45057', name: 'Lancaster', state: 'SC' },
    { fips: '45059', name: 'Laurens', state: 'SC' },
    { fips: '45061', name: 'Lee', state: 'SC' },
    { fips: '45063', name: 'Lexington', state: 'SC' },
    { fips: '45065', name: 'McCormick', state: 'SC' },
    { fips: '45067', name: 'Marion', state: 'SC' },
    { fips: '45069', name: 'Marlboro', state: 'SC' },
    { fips: '45071', name: 'Newberry', state: 'SC' },
    { fips: '45073', name: 'Oconee', state: 'SC' },
    { fips: '45075', name: 'Orangeburg', state: 'SC' },
    { fips: '45077', name: 'Pickens', state: 'SC' },
    { fips: '45079', name: 'Richland', state: 'SC' },
    { fips: '45081', name: 'Saluda', state: 'SC' },
    { fips: '45083', name: 'Spartanburg', state: 'SC' },
    { fips: '45085', name: 'Sumter', state: 'SC' },
    { fips: '45087', name: 'Union', state: 'SC' },
    { fips: '45089', name: 'Williamsburg', state: 'SC' },
    { fips: '45091', name: 'York', state: 'SC' },
    // South Dakota (SD) - 66 counties
    { fips: '46003', name: 'Aurora', state: 'SD' },
    { fips: '46005', name: 'Beadle', state: 'SD' },
    { fips: '46007', name: 'Bennett', state: 'SD' },
    { fips: '46009', name: 'Bon Homme', state: 'SD' },
    { fips: '46011', name: 'Brookings', state: 'SD' },
    { fips: '46013', name: 'Brown', state: 'SD' },
    { fips: '46015', name: 'Brule', state: 'SD' },
    { fips: '46017', name: 'Buffalo', state: 'SD' },
    { fips: '46019', name: 'Butte', state: 'SD' },
    { fips: '46021', name: 'Campbell', state: 'SD' },
    { fips: '46023', name: 'Charles Mix', state: 'SD' },
    { fips: '46025', name: 'Clark', state: 'SD' },
    { fips: '46027', name: 'Clay', state: 'SD' },
    { fips: '46029', name: 'Codington', state: 'SD' },
    { fips: '46031', name: 'Corson', state: 'SD' },
    { fips: '46033', name: 'Custer', state: 'SD' },
    { fips: '46035', name: 'Davison', state: 'SD' },
    { fips: '46037', name: 'Day', state: 'SD' },
    { fips: '46039', name: 'Deuel', state: 'SD' },
    { fips: '46041', name: 'Dewey', state: 'SD' },
    { fips: '46043', name: 'Douglas', state: 'SD' },
    { fips: '46045', name: 'Edmunds', state: 'SD' },
    { fips: '46047', name: 'Fall River', state: 'SD' },
    { fips: '46049', name: 'Faulk', state: 'SD' },
    { fips: '46051', name: 'Grant', state: 'SD' },
    { fips: '46053', name: 'Gregory', state: 'SD' },
    { fips: '46055', name: 'Haakon', state: 'SD' },
    { fips: '46057', name: 'Hamlin', state: 'SD' },
    { fips: '46059', name: 'Hand', state: 'SD' },
    { fips: '46061', name: 'Hanson', state: 'SD' },
    { fips: '46063', name: 'Harding', state: 'SD' },
    { fips: '46065', name: 'Hughes', state: 'SD' },
    { fips: '46067', name: 'Hutchinson', state: 'SD' },
    { fips: '46069', name: 'Hyde', state: 'SD' },
    { fips: '46071', name: 'Jackson', state: 'SD' },
    { fips: '46073', name: 'Jerauld', state: 'SD' },
    { fips: '46075', name: 'Jones', state: 'SD' },
    { fips: '46077', name: 'Kingsbury', state: 'SD' },
    { fips: '46079', name: 'Lake', state: 'SD' },
    { fips: '46081', name: 'Lawrence', state: 'SD' },
    { fips: '46083', name: 'Lincoln', state: 'SD' },
    { fips: '46085', name: 'Lyman', state: 'SD' },
    { fips: '46087', name: 'McCook', state: 'SD' },
    { fips: '46089', name: 'McPherson', state: 'SD' },
    { fips: '46091', name: 'Marshall', state: 'SD' },
    { fips: '46093', name: 'Meade', state: 'SD' },
    { fips: '46095', name: 'Mellette', state: 'SD' },
    { fips: '46097', name: 'Miner', state: 'SD' },
    { fips: '46099', name: 'Minnehaha', state: 'SD' },
    { fips: '46101', name: 'Moody', state: 'SD' },
    { fips: '46102', name: 'Oglala Lakota', state: 'SD' },
    { fips: '46103', name: 'Pennington', state: 'SD' },
    { fips: '46105', name: 'Perkins', state: 'SD' },
    { fips: '46107', name: 'Potter', state: 'SD' },
    { fips: '46109', name: 'Roberts', state: 'SD' },
    { fips: '46111', name: 'Sanborn', state: 'SD' },
    { fips: '46115', name: 'Spink', state: 'SD' },
    { fips: '46117', name: 'Stanley', state: 'SD' },
    { fips: '46119', name: 'Sully', state: 'SD' },
    { fips: '46121', name: 'Todd', state: 'SD' },
    { fips: '46123', name: 'Tripp', state: 'SD' },
    { fips: '46125', name: 'Turner', state: 'SD' },
    { fips: '46127', name: 'Union', state: 'SD' },
    { fips: '46129', name: 'Walworth', state: 'SD' },
    { fips: '46135', name: 'Yankton', state: 'SD' },
    { fips: '46137', name: 'Ziebach', state: 'SD' },
    // Tennessee (TN) - 95 counties
    { fips: '47001', name: 'Anderson', state: 'TN' },
    { fips: '47003', name: 'Bedford', state: 'TN' },
    { fips: '47005', name: 'Benton', state: 'TN' },
    { fips: '47007', name: 'Bledsoe', state: 'TN' },
    { fips: '47009', name: 'Blount', state: 'TN' },
    { fips: '47011', name: 'Bradley', state: 'TN' },
    { fips: '47013', name: 'Campbell', state: 'TN' },
    { fips: '47015', name: 'Cannon', state: 'TN' },
    { fips: '47017', name: 'Carroll', state: 'TN' },
    { fips: '47019', name: 'Carter', state: 'TN' },
    { fips: '47021', name: 'Cheatham', state: 'TN' },
    { fips: '47023', name: 'Chester', state: 'TN' },
    { fips: '47025', name: 'Claiborne', state: 'TN' },
    { fips: '47027', name: 'Clay', state: 'TN' },
    { fips: '47029', name: 'Cocke', state: 'TN' },
    { fips: '47031', name: 'Coffee', state: 'TN' },
    { fips: '47033', name: 'Crockett', state: 'TN' },
    { fips: '47035', name: 'Cumberland', state: 'TN' },
    { fips: '47037', name: 'Davidson', state: 'TN' },
    { fips: '47039', name: 'Decatur', state: 'TN' },
    { fips: '47041', name: 'DeKalb', state: 'TN' },
    { fips: '47043', name: 'Dickson', state: 'TN' },
    { fips: '47045', name: 'Dyer', state: 'TN' },
    { fips: '47047', name: 'Fayette', state: 'TN' },
    { fips: '47049', name: 'Fentress', state: 'TN' },
    { fips: '47051', name: 'Franklin', state: 'TN' },
    { fips: '47053', name: 'Gibson', state: 'TN' },
    { fips: '47055', name: 'Giles', state: 'TN' },
    { fips: '47057', name: 'Grainger', state: 'TN' },
    { fips: '47059', name: 'Greene', state: 'TN' },
    { fips: '47061', name: 'Grundy', state: 'TN' },
    { fips: '47063', name: 'Hamblen', state: 'TN' },
    { fips: '47065', name: 'Hamilton', state: 'TN' },
    { fips: '47067', name: 'Hancock', state: 'TN' },
    { fips: '47069', name: 'Hardeman', state: 'TN' },
    { fips: '47071', name: 'Hardin', state: 'TN' },
    { fips: '47073', name: 'Hawkins', state: 'TN' },
    { fips: '47075', name: 'Haywood', state: 'TN' },
    { fips: '47077', name: 'Henderson', state: 'TN' },
    { fips: '47079', name: 'Henry', state: 'TN' },
    { fips: '47081', name: 'Hickman', state: 'TN' },
    { fips: '47083', name: 'Houston', state: 'TN' },
    { fips: '47085', name: 'Humphreys', state: 'TN' },
    { fips: '47087', name: 'Jackson', state: 'TN' },
    { fips: '47089', name: 'Jefferson', state: 'TN' },
    { fips: '47091', name: 'Johnson', state: 'TN' },
    { fips: '47093', name: 'Knox', state: 'TN' },
    { fips: '47095', name: 'Lake', state: 'TN' },
    { fips: '47097', name: 'Lauderdale', state: 'TN' },
    { fips: '47099', name: 'Lawrence', state: 'TN' },
    { fips: '47101', name: 'Lewis', state: 'TN' },
    { fips: '47103', name: 'Lincoln', state: 'TN' },
    { fips: '47105', name: 'Loudon', state: 'TN' },
    { fips: '47107', name: 'McMinn', state: 'TN' },
    { fips: '47109', name: 'McNairy', state: 'TN' },
    { fips: '47111', name: 'Macon', state: 'TN' },
    { fips: '47113', name: 'Madison', state: 'TN' },
    { fips: '47115', name: 'Marion', state: 'TN' },
    { fips: '47117', name: 'Marshall', state: 'TN' },
    { fips: '47119', name: 'Maury', state: 'TN' },
    { fips: '47121', name: 'Meigs', state: 'TN' },
    { fips: '47123', name: 'Monroe', state: 'TN' },
    { fips: '47125', name: 'Montgomery', state: 'TN' },
    { fips: '47127', name: 'Moore', state: 'TN' },
    { fips: '47129', name: 'Morgan', state: 'TN' },
    { fips: '47131', name: 'Obion', state: 'TN' },
    { fips: '47133', name: 'Overton', state: 'TN' },
    { fips: '47135', name: 'Perry', state: 'TN' },
    { fips: '47137', name: 'Pickett', state: 'TN' },
    { fips: '47139', name: 'Polk', state: 'TN' },
    { fips: '47141', name: 'Putnam', state: 'TN' },
    { fips: '47143', name: 'Rhea', state: 'TN' },
    { fips: '47145', name: 'Roane', state: 'TN' },
    { fips: '47147', name: 'Robertson', state: 'TN' },
    { fips: '47149', name: 'Rutherford', state: 'TN' },
    { fips: '47151', name: 'Scott', state: 'TN' },
    { fips: '47153', name: 'Sequatchie', state: 'TN' },
    { fips: '47155', name: 'Sevier', state: 'TN' },
    { fips: '47157', name: 'Shelby', state: 'TN' },
    { fips: '47159', name: 'Smith', state: 'TN' },
    { fips: '47161', name: 'Stewart', state: 'TN' },
    { fips: '47163', name: 'Sullivan', state: 'TN' },
    { fips: '47165', name: 'Sumner', state: 'TN' },
    { fips: '47167', name: 'Tipton', state: 'TN' },
    { fips: '47169', name: 'Trousdale', state: 'TN' },
    { fips: '47171', name: 'Unicoi', state: 'TN' },
    { fips: '47173', name: 'Union', state: 'TN' },
    { fips: '47175', name: 'Van Buren', state: 'TN' },
    { fips: '47177', name: 'Warren', state: 'TN' },
    { fips: '47179', name: 'Washington', state: 'TN' },
    { fips: '47181', name: 'Wayne', state: 'TN' },
    { fips: '47183', name: 'Weakley', state: 'TN' },
    { fips: '47185', name: 'White', state: 'TN' },
    { fips: '47187', name: 'Williamson', state: 'TN' },
    { fips: '47189', name: 'Wilson', state: 'TN' },
    // Texas (TX) - 254 counties
    { fips: '48001', name: 'Anderson', state: 'TX' },
    { fips: '48003', name: 'Andrews', state: 'TX' },
    { fips: '48005', name: 'Angelina', state: 'TX' },
    { fips: '48007', name: 'Aransas', state: 'TX' },
    { fips: '48009', name: 'Archer', state: 'TX' },
    { fips: '48011', name: 'Armstrong', state: 'TX' },
    { fips: '48013', name: 'Atascosa', state: 'TX' },
    { fips: '48015', name: 'Austin', state: 'TX' },
    { fips: '48017', name: 'Bailey', state: 'TX' },
    { fips: '48019', name: 'Bandera', state: 'TX' },
    { fips: '48021', name: 'Bastrop', state: 'TX' },
    { fips: '48023', name: 'Baylor', state: 'TX' },
    { fips: '48025', name: 'Bee', state: 'TX' },
    { fips: '48027', name: 'Bell', state: 'TX' },
    { fips: '48029', name: 'Bexar', state: 'TX' },
    { fips: '48031', name: 'Blanco', state: 'TX' },
    { fips: '48033', name: 'Borden', state: 'TX' },
    { fips: '48035', name: 'Bosque', state: 'TX' },
    { fips: '48037', name: 'Bowie', state: 'TX' },
    { fips: '48039', name: 'Brazoria', state: 'TX' },
    { fips: '48041', name: 'Brazos', state: 'TX' },
    { fips: '48043', name: 'Brewster', state: 'TX' },
    { fips: '48045', name: 'Briscoe', state: 'TX' },
    { fips: '48047', name: 'Brooks', state: 'TX' },
    { fips: '48049', name: 'Brown', state: 'TX' },
    { fips: '48051', name: 'Burleson', state: 'TX' },
    { fips: '48053', name: 'Burnet', state: 'TX' },
    { fips: '48055', name: 'Caldwell', state: 'TX' },
    { fips: '48057', name: 'Calhoun', state: 'TX' },
    { fips: '48059', name: 'Callahan', state: 'TX' },
    { fips: '48061', name: 'Cameron', state: 'TX' },
    { fips: '48063', name: 'Camp', state: 'TX' },
    { fips: '48065', name: 'Carson', state: 'TX' },
    { fips: '48067', name: 'Cass', state: 'TX' },
    { fips: '48069', name: 'Castro', state: 'TX' },
    { fips: '48071', name: 'Chambers', state: 'TX' },
    { fips: '48073', name: 'Cherokee', state: 'TX' },
    { fips: '48075', name: 'Childress', state: 'TX' },
    { fips: '48077', name: 'Clay', state: 'TX' },
    { fips: '48079', name: 'Cochran', state: 'TX' },
    { fips: '48081', name: 'Coke', state: 'TX' },
    { fips: '48083', name: 'Coleman', state: 'TX' },
    { fips: '48085', name: 'Collin', state: 'TX' },
    { fips: '48087', name: 'Collingsworth', state: 'TX' },
    { fips: '48089', name: 'Colorado', state: 'TX' },
    { fips: '48091', name: 'Comal', state: 'TX' },
    { fips: '48093', name: 'Comanche', state: 'TX' },
    { fips: '48095', name: 'Concho', state: 'TX' },
    { fips: '48097', name: 'Cooke', state: 'TX' },
    { fips: '48099', name: 'Coryell', state: 'TX' },
    { fips: '48101', name: 'Cottle', state: 'TX' },
    { fips: '48103', name: 'Crane', state: 'TX' },
    { fips: '48105', name: 'Crockett', state: 'TX' },
    { fips: '48107', name: 'Crosby', state: 'TX' },
    { fips: '48109', name: 'Culberson', state: 'TX' },
    { fips: '48111', name: 'Dallam', state: 'TX' },
    { fips: '48113', name: 'Dallas', state: 'TX' },
    { fips: '48115', name: 'Dawson', state: 'TX' },
    { fips: '48117', name: 'Deaf Smith', state: 'TX' },
    { fips: '48119', name: 'Delta', state: 'TX' },
    { fips: '48121', name: 'Denton', state: 'TX' },
    { fips: '48123', name: 'DeWitt', state: 'TX' },
    { fips: '48125', name: 'Dickens', state: 'TX' },
    { fips: '48127', name: 'Dimmit', state: 'TX' },
    { fips: '48129', name: 'Donley', state: 'TX' },
    { fips: '48131', name: 'Duval', state: 'TX' },
    { fips: '48133', name: 'Eastland', state: 'TX' },
    { fips: '48135', name: 'Ector', state: 'TX' },
    { fips: '48137', name: 'Edwards', state: 'TX' },
    { fips: '48139', name: 'Ellis', state: 'TX' },
    { fips: '48141', name: 'El Paso', state: 'TX' },
    { fips: '48143', name: 'Erath', state: 'TX' },
    { fips: '48145', name: 'Falls', state: 'TX' },
    { fips: '48147', name: 'Fannin', state: 'TX' },
    { fips: '48149', name: 'Fayette', state: 'TX' },
    { fips: '48151', name: 'Fisher', state: 'TX' },
    { fips: '48153', name: 'Floyd', state: 'TX' },
    { fips: '48155', name: 'Foard', state: 'TX' },
    { fips: '48157', name: 'Fort Bend', state: 'TX' },
    { fips: '48159', name: 'Franklin', state: 'TX' },
    { fips: '48161', name: 'Freestone', state: 'TX' },
    { fips: '48163', name: 'Frio', state: 'TX' },
    { fips: '48165', name: 'Gaines', state: 'TX' },
    { fips: '48167', name: 'Galveston', state: 'TX' },
    { fips: '48169', name: 'Garza', state: 'TX' },
    { fips: '48171', name: 'Gillespie', state: 'TX' },
    { fips: '48173', name: 'Glasscock', state: 'TX' },
    { fips: '48175', name: 'Goliad', state: 'TX' },
    { fips: '48177', name: 'Gonzales', state: 'TX' },
    { fips: '48179', name: 'Gray', state: 'TX' },
    { fips: '48181', name: 'Grayson', state: 'TX' },
    { fips: '48183', name: 'Gregg', state: 'TX' },
    { fips: '48185', name: 'Grimes', state: 'TX' },
    { fips: '48187', name: 'Guadalupe', state: 'TX' },
    { fips: '48189', name: 'Hale', state: 'TX' },
    { fips: '48191', name: 'Hall', state: 'TX' },
    { fips: '48193', name: 'Hamilton', state: 'TX' },
    { fips: '48195', name: 'Hansford', state: 'TX' },
    { fips: '48197', name: 'Hardeman', state: 'TX' },
    { fips: '48199', name: 'Hardin', state: 'TX' },
    { fips: '48201', name: 'Harris', state: 'TX' },
    { fips: '48203', name: 'Harrison', state: 'TX' },
    { fips: '48205', name: 'Hartley', state: 'TX' },
    { fips: '48207', name: 'Haskell', state: 'TX' },
    { fips: '48209', name: 'Hays', state: 'TX' },
    { fips: '48211', name: 'Hemphill', state: 'TX' },
    { fips: '48213', name: 'Henderson', state: 'TX' },
    { fips: '48215', name: 'Hidalgo', state: 'TX' },
    { fips: '48217', name: 'Hill', state: 'TX' },
    { fips: '48219', name: 'Hockley', state: 'TX' },
    { fips: '48221', name: 'Hood', state: 'TX' },
    { fips: '48223', name: 'Hopkins', state: 'TX' },
    { fips: '48225', name: 'Houston', state: 'TX' },
    { fips: '48227', name: 'Howard', state: 'TX' },
    { fips: '48229', name: 'Hudspeth', state: 'TX' },
    { fips: '48231', name: 'Hunt', state: 'TX' },
    { fips: '48233', name: 'Hutchinson', state: 'TX' },
    { fips: '48235', name: 'Irion', state: 'TX' },
    { fips: '48237', name: 'Jack', state: 'TX' },
    { fips: '48239', name: 'Jackson', state: 'TX' },
    { fips: '48241', name: 'Jasper', state: 'TX' },
    { fips: '48243', name: 'Jeff Davis', state: 'TX' },
    { fips: '48245', name: 'Jefferson', state: 'TX' },
    { fips: '48247', name: 'Jim Hogg', state: 'TX' },
    { fips: '48249', name: 'Jim Wells', state: 'TX' },
    { fips: '48251', name: 'Johnson', state: 'TX' },
    { fips: '48253', name: 'Jones', state: 'TX' },
    { fips: '48255', name: 'Karnes', state: 'TX' },
    { fips: '48257', name: 'Kaufman', state: 'TX' },
    { fips: '48259', name: 'Kendall', state: 'TX' },
    { fips: '48261', name: 'Kenedy', state: 'TX' },
    { fips: '48263', name: 'Kent', state: 'TX' },
    { fips: '48265', name: 'Kerr', state: 'TX' },
    { fips: '48267', name: 'Kimble', state: 'TX' },
    { fips: '48269', name: 'King', state: 'TX' },
    { fips: '48271', name: 'Kinney', state: 'TX' },
    { fips: '48273', name: 'Kleberg', state: 'TX' },
    { fips: '48275', name: 'Knox', state: 'TX' },
    { fips: '48277', name: 'Lamar', state: 'TX' },
    { fips: '48279', name: 'Lamb', state: 'TX' },
    { fips: '48281', name: 'Lampasas', state: 'TX' },
    { fips: '48283', name: 'La Salle', state: 'TX' },
    { fips: '48285', name: 'Lavaca', state: 'TX' },
    { fips: '48287', name: 'Lee', state: 'TX' },
    { fips: '48289', name: 'Leon', state: 'TX' },
    { fips: '48291', name: 'Liberty', state: 'TX' },
    { fips: '48293', name: 'Limestone', state: 'TX' },
    { fips: '48295', name: 'Lipscomb', state: 'TX' },
    { fips: '48297', name: 'Live Oak', state: 'TX' },
    { fips: '48299', name: 'Llano', state: 'TX' },
    { fips: '48301', name: 'Loving', state: 'TX' },
    { fips: '48303', name: 'Lubbock', state: 'TX' },
    { fips: '48305', name: 'Lynn', state: 'TX' },
    { fips: '48307', name: 'McCulloch', state: 'TX' },
    { fips: '48309', name: 'McLennan', state: 'TX' },
    { fips: '48311', name: 'McMullen', state: 'TX' },
    { fips: '48313', name: 'Madison', state: 'TX' },
    { fips: '48315', name: 'Marion', state: 'TX' },
    { fips: '48317', name: 'Martin', state: 'TX' },
    { fips: '48319', name: 'Mason', state: 'TX' },
    { fips: '48321', name: 'Matagorda', state: 'TX' },
    { fips: '48323', name: 'Maverick', state: 'TX' },
    { fips: '48325', name: 'Medina', state: 'TX' },
    { fips: '48327', name: 'Menard', state: 'TX' },
    { fips: '48329', name: 'Midland', state: 'TX' },
    { fips: '48331', name: 'Milam', state: 'TX' },
    { fips: '48333', name: 'Mills', state: 'TX' },
    { fips: '48335', name: 'Mitchell', state: 'TX' },
    { fips: '48337', name: 'Montague', state: 'TX' },
    { fips: '48339', name: 'Montgomery', state: 'TX' },
    { fips: '48341', name: 'Moore', state: 'TX' },
    { fips: '48343', name: 'Morris', state: 'TX' },
    { fips: '48345', name: 'Motley', state: 'TX' },
    { fips: '48347', name: 'Nacogdoches', state: 'TX' },
    { fips: '48349', name: 'Navarro', state: 'TX' },
    { fips: '48351', name: 'Newton', state: 'TX' },
    { fips: '48353', name: 'Nolan', state: 'TX' },
    { fips: '48355', name: 'Nueces', state: 'TX' },
    { fips: '48357', name: 'Ochiltree', state: 'TX' },
    { fips: '48359', name: 'Oldham', state: 'TX' },
    { fips: '48361', name: 'Orange', state: 'TX' },
    { fips: '48363', name: 'Palo Pinto', state: 'TX' },
    { fips: '48365', name: 'Panola', state: 'TX' },
    { fips: '48367', name: 'Parker', state: 'TX' },
    { fips: '48369', name: 'Parmer', state: 'TX' },
    { fips: '48371', name: 'Pecos', state: 'TX' },
    { fips: '48373', name: 'Polk', state: 'TX' },
    { fips: '48375', name: 'Potter', state: 'TX' },
    { fips: '48377', name: 'Presidio', state: 'TX' },
    { fips: '48379', name: 'Rains', state: 'TX' },
    { fips: '48381', name: 'Randall', state: 'TX' },
    { fips: '48383', name: 'Reagan', state: 'TX' },
    { fips: '48385', name: 'Real', state: 'TX' },
    { fips: '48387', name: 'Red River', state: 'TX' },
    { fips: '48389', name: 'Reeves', state: 'TX' },
    { fips: '48391', name: 'Refugio', state: 'TX' },
    { fips: '48393', name: 'Roberts', state: 'TX' },
    { fips: '48395', name: 'Robertson', state: 'TX' },
    { fips: '48397', name: 'Rockwall', state: 'TX' },
    { fips: '48399', name: 'Runnels', state: 'TX' },
    { fips: '48401', name: 'Rusk', state: 'TX' },
    { fips: '48403', name: 'Sabine', state: 'TX' },
    { fips: '48405', name: 'San Augustine', state: 'TX' },
    { fips: '48407', name: 'San Jacinto', state: 'TX' },
    { fips: '48409', name: 'San Patricio', state: 'TX' },
    { fips: '48411', name: 'San Saba', state: 'TX' },
    { fips: '48413', name: 'Schleicher', state: 'TX' },
    { fips: '48415', name: 'Scurry', state: 'TX' },
    { fips: '48417', name: 'Shackelford', state: 'TX' },
    { fips: '48419', name: 'Shelby', state: 'TX' },
    { fips: '48421', name: 'Sherman', state: 'TX' },
    { fips: '48423', name: 'Smith', state: 'TX' },
    { fips: '48425', name: 'Somervell', state: 'TX' },
    { fips: '48427', name: 'Starr', state: 'TX' },
    { fips: '48429', name: 'Stephens', state: 'TX' },
    { fips: '48431', name: 'Sterling', state: 'TX' },
    { fips: '48433', name: 'Stonewall', state: 'TX' },
    { fips: '48435', name: 'Sutton', state: 'TX' },
    { fips: '48437', name: 'Swisher', state: 'TX' },
    { fips: '48439', name: 'Tarrant', state: 'TX' },
    { fips: '48441', name: 'Taylor', state: 'TX' },
    { fips: '48443', name: 'Terrell', state: 'TX' },
    { fips: '48445', name: 'Terry', state: 'TX' },
    { fips: '48447', name: 'Throckmorton', state: 'TX' },
    { fips: '48449', name: 'Titus', state: 'TX' },
    { fips: '48451', name: 'Tom Green', state: 'TX' },
    { fips: '48453', name: 'Travis', state: 'TX' },
    { fips: '48455', name: 'Trinity', state: 'TX' },
    { fips: '48457', name: 'Tyler', state: 'TX' },
    { fips: '48459', name: 'Upshur', state: 'TX' },
    { fips: '48461', name: 'Upton', state: 'TX' },
    { fips: '48463', name: 'Uvalde', state: 'TX' },
    { fips: '48465', name: 'Val Verde', state: 'TX' },
    { fips: '48467', name: 'Van Zandt', state: 'TX' },
    { fips: '48469', name: 'Victoria', state: 'TX' },
    { fips: '48471', name: 'Walker', state: 'TX' },
    { fips: '48473', name: 'Waller', state: 'TX' },
    { fips: '48475', name: 'Ward', state: 'TX' },
    { fips: '48477', name: 'Washington', state: 'TX' },
    { fips: '48479', name: 'Webb', state: 'TX' },
    { fips: '48481', name: 'Wharton', state: 'TX' },
    { fips: '48483', name: 'Wheeler', state: 'TX' },
    { fips: '48485', name: 'Wichita', state: 'TX' },
    { fips: '48487', name: 'Wilbarger', state: 'TX' },
    { fips: '48489', name: 'Willacy', state: 'TX' },
    { fips: '48491', name: 'Williamson', state: 'TX' },
    { fips: '48493', name: 'Wilson', state: 'TX' },
    { fips: '48495', name: 'Winkler', state: 'TX' },
    { fips: '48497', name: 'Wise', state: 'TX' },
    { fips: '48499', name: 'Wood', state: 'TX' },
    { fips: '48501', name: 'Yoakum', state: 'TX' },
    { fips: '48503', name: 'Young', state: 'TX' },
    { fips: '48505', name: 'Zapata', state: 'TX' },
    { fips: '48507', name: 'Zavala', state: 'TX' },
    // Utah (UT) - 29 counties
    { fips: '49001', name: 'Beaver', state: 'UT' },
    { fips: '49003', name: 'Box Elder', state: 'UT' },
    { fips: '49005', name: 'Cache', state: 'UT' },
    { fips: '49007', name: 'Carbon', state: 'UT' },
    { fips: '49009', name: 'Daggett', state: 'UT' },
    { fips: '49011', name: 'Davis', state: 'UT' },
    { fips: '49013', name: 'Duchesne', state: 'UT' },
    { fips: '49015', name: 'Emery', state: 'UT' },
    { fips: '49017', name: 'Garfield', state: 'UT' },
    { fips: '49019', name: 'Grand', state: 'UT' },
    { fips: '49021', name: 'Iron', state: 'UT' },
    { fips: '49023', name: 'Juab', state: 'UT' },
    { fips: '49025', name: 'Kane', state: 'UT' },
    { fips: '49027', name: 'Millard', state: 'UT' },
    { fips: '49029', name: 'Morgan', state: 'UT' },
    { fips: '49031', name: 'Piute', state: 'UT' },
    { fips: '49033', name: 'Rich', state: 'UT' },
    { fips: '49035', name: 'Salt Lake', state: 'UT' },
    { fips: '49037', name: 'San Juan', state: 'UT' },
    { fips: '49039', name: 'Sanpete', state: 'UT' },
    { fips: '49041', name: 'Sevier', state: 'UT' },
    { fips: '49043', name: 'Summit', state: 'UT' },
    { fips: '49045', name: 'Tooele', state: 'UT' },
    { fips: '49047', name: 'Uintah', state: 'UT' },
    { fips: '49049', name: 'Utah', state: 'UT' },
    { fips: '49051', name: 'Wasatch', state: 'UT' },
    { fips: '49053', name: 'Washington', state: 'UT' },
    { fips: '49055', name: 'Wayne', state: 'UT' },
    { fips: '49057', name: 'Weber', state: 'UT' },
    // Vermont (VT) - 14 counties
    { fips: '50001', name: 'Addison', state: 'VT' },
    { fips: '50003', name: 'Bennington', state: 'VT' },
    { fips: '50005', name: 'Caledonia', state: 'VT' },
    { fips: '50007', name: 'Chittenden', state: 'VT' },
    { fips: '50009', name: 'Essex', state: 'VT' },
    { fips: '50011', name: 'Franklin', state: 'VT' },
    { fips: '50013', name: 'Grand Isle', state: 'VT' },
    { fips: '50015', name: 'Lamoille', state: 'VT' },
    { fips: '50017', name: 'Orange', state: 'VT' },
    { fips: '50019', name: 'Orleans', state: 'VT' },
    { fips: '50021', name: 'Rutland', state: 'VT' },
    { fips: '50023', name: 'Washington', state: 'VT' },
    { fips: '50025', name: 'Windham', state: 'VT' },
    { fips: '50027', name: 'Windsor', state: 'VT' },
    // Virginia (VA) - 95 counties + 38 independent cities
    { fips: '51001', name: 'Accomack', state: 'VA' },
    { fips: '51003', name: 'Albemarle', state: 'VA' },
    { fips: '51005', name: 'Alleghany', state: 'VA' },
    { fips: '51007', name: 'Amelia', state: 'VA' },
    { fips: '51009', name: 'Amherst', state: 'VA' },
    { fips: '51011', name: 'Appomattox', state: 'VA' },
    { fips: '51013', name: 'Arlington', state: 'VA' },
    { fips: '51015', name: 'Augusta', state: 'VA' },
    { fips: '51017', name: 'Bath', state: 'VA' },
    { fips: '51019', name: 'Bedford', state: 'VA' },
    { fips: '51021', name: 'Bland', state: 'VA' },
    { fips: '51023', name: 'Botetourt', state: 'VA' },
    { fips: '51025', name: 'Brunswick', state: 'VA' },
    { fips: '51027', name: 'Buchanan', state: 'VA' },
    { fips: '51029', name: 'Buckingham', state: 'VA' },
    { fips: '51031', name: 'Campbell', state: 'VA' },
    { fips: '51033', name: 'Caroline', state: 'VA' },
    { fips: '51035', name: 'Carroll', state: 'VA' },
    { fips: '51036', name: 'Charles City', state: 'VA' },
    { fips: '51037', name: 'Charlotte', state: 'VA' },
    { fips: '51041', name: 'Chesterfield', state: 'VA' },
    { fips: '51043', name: 'Clarke', state: 'VA' },
    { fips: '51045', name: 'Craig', state: 'VA' },
    { fips: '51047', name: 'Culpeper', state: 'VA' },
    { fips: '51049', name: 'Cumberland', state: 'VA' },
    { fips: '51051', name: 'Dickenson', state: 'VA' },
    { fips: '51053', name: 'Dinwiddie', state: 'VA' },
    { fips: '51057', name: 'Essex', state: 'VA' },
    { fips: '51059', name: 'Fairfax', state: 'VA' },
    { fips: '51061', name: 'Fauquier', state: 'VA' },
    { fips: '51063', name: 'Floyd', state: 'VA' },
    { fips: '51065', name: 'Fluvanna', state: 'VA' },
    { fips: '51067', name: 'Franklin', state: 'VA' },
    { fips: '51069', name: 'Frederick', state: 'VA' },
    { fips: '51071', name: 'Giles', state: 'VA' },
    { fips: '51073', name: 'Gloucester', state: 'VA' },
    { fips: '51075', name: 'Goochland', state: 'VA' },
    { fips: '51077', name: 'Grayson', state: 'VA' },
    { fips: '51079', name: 'Greene', state: 'VA' },
    { fips: '51081', name: 'Greensville', state: 'VA' },
    { fips: '51083', name: 'Halifax', state: 'VA' },
    { fips: '51085', name: 'Hanover', state: 'VA' },
    { fips: '51087', name: 'Henrico', state: 'VA' },
    { fips: '51089', name: 'Henry', state: 'VA' },
    { fips: '51091', name: 'Highland', state: 'VA' },
    { fips: '51093', name: 'Isle of Wight', state: 'VA' },
    { fips: '51095', name: 'James City', state: 'VA' },
    { fips: '51097', name: 'King and Queen', state: 'VA' },
    { fips: '51099', name: 'King George', state: 'VA' },
    { fips: '51101', name: 'King William', state: 'VA' },
    { fips: '51103', name: 'Lancaster', state: 'VA' },
    { fips: '51105', name: 'Lee', state: 'VA' },
    { fips: '51107', name: 'Loudoun', state: 'VA' },
    { fips: '51109', name: 'Louisa', state: 'VA' },
    { fips: '51111', name: 'Lunenburg', state: 'VA' },
    { fips: '51113', name: 'Madison', state: 'VA' },
    { fips: '51115', name: 'Mathews', state: 'VA' },
    { fips: '51117', name: 'Mecklenburg', state: 'VA' },
    { fips: '51119', name: 'Middlesex', state: 'VA' },
    { fips: '51121', name: 'Montgomery', state: 'VA' },
    { fips: '51125', name: 'Nelson', state: 'VA' },
    { fips: '51127', name: 'New Kent', state: 'VA' },
    { fips: '51131', name: 'Northampton', state: 'VA' },
    { fips: '51133', name: 'Northumberland', state: 'VA' },
    { fips: '51135', name: 'Nottoway', state: 'VA' },
    { fips: '51137', name: 'Orange', state: 'VA' },
    { fips: '51139', name: 'Page', state: 'VA' },
    { fips: '51141', name: 'Patrick', state: 'VA' },
    { fips: '51143', name: 'Pittsylvania', state: 'VA' },
    { fips: '51145', name: 'Powhatan', state: 'VA' },
    { fips: '51147', name: 'Prince Edward', state: 'VA' },
    { fips: '51149', name: 'Prince George', state: 'VA' },
    { fips: '51153', name: 'Prince William', state: 'VA' },
    { fips: '51155', name: 'Pulaski', state: 'VA' },
    { fips: '51157', name: 'Rappahannock', state: 'VA' },
    { fips: '51159', name: 'Richmond', state: 'VA' },
    { fips: '51161', name: 'Roanoke', state: 'VA' },
    { fips: '51163', name: 'Rockbridge', state: 'VA' },
    { fips: '51165', name: 'Rockingham', state: 'VA' },
    { fips: '51167', name: 'Russell', state: 'VA' },
    { fips: '51169', name: 'Scott', state: 'VA' },
    { fips: '51171', name: 'Shenandoah', state: 'VA' },
    { fips: '51173', name: 'Smyth', state: 'VA' },
    { fips: '51175', name: 'Southampton', state: 'VA' },
    { fips: '51177', name: 'Spotsylvania', state: 'VA' },
    { fips: '51179', name: 'Stafford', state: 'VA' },
    { fips: '51181', name: 'Surry', state: 'VA' },
    { fips: '51183', name: 'Sussex', state: 'VA' },
    { fips: '51185', name: 'Tazewell', state: 'VA' },
    { fips: '51187', name: 'Warren', state: 'VA' },
    { fips: '51191', name: 'Washington', state: 'VA' },
    { fips: '51193', name: 'Westmoreland', state: 'VA' },
    { fips: '51195', name: 'Wise', state: 'VA' },
    { fips: '51197', name: 'Wythe', state: 'VA' },
    { fips: '51199', name: 'York', state: 'VA' },
    // Virginia Independent Cities
    { fips: '51510', name: 'Alexandria', state: 'VA' },
    { fips: '51520', name: 'Bristol', state: 'VA' },
    { fips: '51530', name: 'Buena Vista', state: 'VA' },
    { fips: '51540', name: 'Charlottesville', state: 'VA' },
    { fips: '51550', name: 'Chesapeake', state: 'VA' },
    { fips: '51570', name: 'Colonial Heights', state: 'VA' },
    { fips: '51580', name: 'Covington', state: 'VA' },
    { fips: '51590', name: 'Danville', state: 'VA' },
    { fips: '51595', name: 'Emporia', state: 'VA' },
    { fips: '51600', name: 'Fairfax City', state: 'VA' },
    { fips: '51610', name: 'Falls Church', state: 'VA' },
    { fips: '51620', name: 'Franklin City', state: 'VA' },
    { fips: '51630', name: 'Fredericksburg', state: 'VA' },
    { fips: '51640', name: 'Galax', state: 'VA' },
    { fips: '51650', name: 'Hampton', state: 'VA' },
    { fips: '51660', name: 'Harrisonburg', state: 'VA' },
    { fips: '51670', name: 'Hopewell', state: 'VA' },
    { fips: '51678', name: 'Lexington', state: 'VA' },
    { fips: '51680', name: 'Lynchburg', state: 'VA' },
    { fips: '51683', name: 'Manassas', state: 'VA' },
    { fips: '51685', name: 'Manassas Park', state: 'VA' },
    { fips: '51690', name: 'Martinsville', state: 'VA' },
    { fips: '51700', name: 'Newport News', state: 'VA' },
    { fips: '51710', name: 'Norfolk', state: 'VA' },
    { fips: '51720', name: 'Norton', state: 'VA' },
    { fips: '51730', name: 'Petersburg', state: 'VA' },
    { fips: '51735', name: 'Poquoson', state: 'VA' },
    { fips: '51740', name: 'Portsmouth', state: 'VA' },
    { fips: '51750', name: 'Radford', state: 'VA' },
    { fips: '51760', name: 'Richmond City', state: 'VA' },
    { fips: '51770', name: 'Roanoke City', state: 'VA' },
    { fips: '51775', name: 'Salem', state: 'VA' },
    { fips: '51790', name: 'Staunton', state: 'VA' },
    { fips: '51800', name: 'Suffolk', state: 'VA' },
    { fips: '51810', name: 'Virginia Beach', state: 'VA' },
    { fips: '51820', name: 'Waynesboro', state: 'VA' },
    { fips: '51830', name: 'Williamsburg', state: 'VA' },
    { fips: '51840', name: 'Winchester', state: 'VA' },
    // Washington (WA) - 39 counties
    { fips: '53001', name: 'Adams', state: 'WA' },
    { fips: '53003', name: 'Asotin', state: 'WA' },
    { fips: '53005', name: 'Benton', state: 'WA' },
    { fips: '53007', name: 'Chelan', state: 'WA' },
    { fips: '53009', name: 'Clallam', state: 'WA' },
    { fips: '53011', name: 'Clark', state: 'WA' },
    { fips: '53013', name: 'Columbia', state: 'WA' },
    { fips: '53015', name: 'Cowlitz', state: 'WA' },
    { fips: '53017', name: 'Douglas', state: 'WA' },
    { fips: '53019', name: 'Ferry', state: 'WA' },
    { fips: '53021', name: 'Franklin', state: 'WA' },
    { fips: '53023', name: 'Garfield', state: 'WA' },
    { fips: '53025', name: 'Grant', state: 'WA' },
    { fips: '53027', name: 'Grays Harbor', state: 'WA' },
    { fips: '53029', name: 'Island', state: 'WA' },
    { fips: '53031', name: 'Jefferson', state: 'WA' },
    { fips: '53033', name: 'King', state: 'WA' },
    { fips: '53035', name: 'Kitsap', state: 'WA' },
    { fips: '53037', name: 'Kittitas', state: 'WA' },
    { fips: '53039', name: 'Klickitat', state: 'WA' },
    { fips: '53041', name: 'Lewis', state: 'WA' },
    { fips: '53043', name: 'Lincoln', state: 'WA' },
    { fips: '53045', name: 'Mason', state: 'WA' },
    { fips: '53047', name: 'Okanogan', state: 'WA' },
    { fips: '53049', name: 'Pacific', state: 'WA' },
    { fips: '53051', name: 'Pend Oreille', state: 'WA' },
    { fips: '53053', name: 'Pierce', state: 'WA' },
    { fips: '53055', name: 'San Juan', state: 'WA' },
    { fips: '53057', name: 'Skagit', state: 'WA' },
    { fips: '53059', name: 'Skamania', state: 'WA' },
    { fips: '53061', name: 'Snohomish', state: 'WA' },
    { fips: '53063', name: 'Spokane', state: 'WA' },
    { fips: '53065', name: 'Stevens', state: 'WA' },
    { fips: '53067', name: 'Thurston', state: 'WA' },
    { fips: '53069', name: 'Wahkiakum', state: 'WA' },
    { fips: '53071', name: 'Walla Walla', state: 'WA' },
    { fips: '53073', name: 'Whatcom', state: 'WA' },
    { fips: '53075', name: 'Whitman', state: 'WA' },
    { fips: '53077', name: 'Yakima', state: 'WA' },
    // West Virginia (WV) - 55 counties
    { fips: '54001', name: 'Barbour', state: 'WV' },
    { fips: '54003', name: 'Berkeley', state: 'WV' },
    { fips: '54005', name: 'Boone', state: 'WV' },
    { fips: '54007', name: 'Braxton', state: 'WV' },
    { fips: '54009', name: 'Brooke', state: 'WV' },
    { fips: '54011', name: 'Cabell', state: 'WV' },
    { fips: '54013', name: 'Calhoun', state: 'WV' },
    { fips: '54015', name: 'Clay', state: 'WV' },
    { fips: '54017', name: 'Doddridge', state: 'WV' },
    { fips: '54019', name: 'Fayette', state: 'WV' },
    { fips: '54021', name: 'Gilmer', state: 'WV' },
    { fips: '54023', name: 'Grant', state: 'WV' },
    { fips: '54025', name: 'Greenbrier', state: 'WV' },
    { fips: '54027', name: 'Hampshire', state: 'WV' },
    { fips: '54029', name: 'Hancock', state: 'WV' },
    { fips: '54031', name: 'Hardy', state: 'WV' },
    { fips: '54033', name: 'Harrison', state: 'WV' },
    { fips: '54035', name: 'Jackson', state: 'WV' },
    { fips: '54037', name: 'Jefferson', state: 'WV' },
    { fips: '54039', name: 'Kanawha', state: 'WV' },
    { fips: '54041', name: 'Lewis', state: 'WV' },
    { fips: '54043', name: 'Lincoln', state: 'WV' },
    { fips: '54045', name: 'Logan', state: 'WV' },
    { fips: '54047', name: 'McDowell', state: 'WV' },
    { fips: '54049', name: 'Marion', state: 'WV' },
    { fips: '54051', name: 'Marshall', state: 'WV' },
    { fips: '54053', name: 'Mason', state: 'WV' },
    { fips: '54055', name: 'Mercer', state: 'WV' },
    { fips: '54057', name: 'Mineral', state: 'WV' },
    { fips: '54059', name: 'Mingo', state: 'WV' },
    { fips: '54061', name: 'Monongalia', state: 'WV' },
    { fips: '54063', name: 'Monroe', state: 'WV' },
    { fips: '54065', name: 'Morgan', state: 'WV' },
    { fips: '54067', name: 'Nicholas', state: 'WV' },
    { fips: '54069', name: 'Ohio', state: 'WV' },
    { fips: '54071', name: 'Pendleton', state: 'WV' },
    { fips: '54073', name: 'Pleasants', state: 'WV' },
    { fips: '54075', name: 'Pocahontas', state: 'WV' },
    { fips: '54077', name: 'Preston', state: 'WV' },
    { fips: '54079', name: 'Putnam', state: 'WV' },
    { fips: '54081', name: 'Raleigh', state: 'WV' },
    { fips: '54083', name: 'Randolph', state: 'WV' },
    { fips: '54085', name: 'Ritchie', state: 'WV' },
    { fips: '54087', name: 'Roane', state: 'WV' },
    { fips: '54089', name: 'Summers', state: 'WV' },
    { fips: '54091', name: 'Taylor', state: 'WV' },
    { fips: '54093', name: 'Tucker', state: 'WV' },
    { fips: '54095', name: 'Tyler', state: 'WV' },
    { fips: '54097', name: 'Upshur', state: 'WV' },
    { fips: '54099', name: 'Wayne', state: 'WV' },
    { fips: '54101', name: 'Webster', state: 'WV' },
    { fips: '54103', name: 'Wetzel', state: 'WV' },
    { fips: '54105', name: 'Wirt', state: 'WV' },
    { fips: '54107', name: 'Wood', state: 'WV' },
    { fips: '54109', name: 'Wyoming', state: 'WV' },
    // Wisconsin (WI) - 72 counties
    { fips: '55001', name: 'Adams', state: 'WI' },
    { fips: '55003', name: 'Ashland', state: 'WI' },
    { fips: '55005', name: 'Barron', state: 'WI' },
    { fips: '55007', name: 'Bayfield', state: 'WI' },
    { fips: '55009', name: 'Brown', state: 'WI' },
    { fips: '55011', name: 'Buffalo', state: 'WI' },
    { fips: '55013', name: 'Burnett', state: 'WI' },
    { fips: '55015', name: 'Calumet', state: 'WI' },
    { fips: '55017', name: 'Chippewa', state: 'WI' },
    { fips: '55019', name: 'Clark', state: 'WI' },
    { fips: '55021', name: 'Columbia', state: 'WI' },
    { fips: '55023', name: 'Crawford', state: 'WI' },
    { fips: '55025', name: 'Dane', state: 'WI' },
    { fips: '55027', name: 'Dodge', state: 'WI' },
    { fips: '55029', name: 'Door', state: 'WI' },
    { fips: '55031', name: 'Douglas', state: 'WI' },
    { fips: '55033', name: 'Dunn', state: 'WI' },
    { fips: '55035', name: 'Eau Claire', state: 'WI' },
    { fips: '55037', name: 'Florence', state: 'WI' },
    { fips: '55039', name: 'Fond du Lac', state: 'WI' },
    { fips: '55041', name: 'Forest', state: 'WI' },
    { fips: '55043', name: 'Grant', state: 'WI' },
    { fips: '55045', name: 'Green', state: 'WI' },
    { fips: '55047', name: 'Green Lake', state: 'WI' },
    { fips: '55049', name: 'Iowa', state: 'WI' },
    { fips: '55051', name: 'Iron', state: 'WI' },
    { fips: '55053', name: 'Jackson', state: 'WI' },
    { fips: '55055', name: 'Jefferson', state: 'WI' },
    { fips: '55057', name: 'Juneau', state: 'WI' },
    { fips: '55059', name: 'Kenosha', state: 'WI' },
    { fips: '55061', name: 'Kewaunee', state: 'WI' },
    { fips: '55063', name: 'La Crosse', state: 'WI' },
    { fips: '55065', name: 'Lafayette', state: 'WI' },
    { fips: '55067', name: 'Langlade', state: 'WI' },
    { fips: '55069', name: 'Lincoln', state: 'WI' },
    { fips: '55071', name: 'Manitowoc', state: 'WI' },
    { fips: '55073', name: 'Marathon', state: 'WI' },
    { fips: '55075', name: 'Marinette', state: 'WI' },
    { fips: '55077', name: 'Marquette', state: 'WI' },
    { fips: '55078', name: 'Menominee', state: 'WI' },
    { fips: '55079', name: 'Milwaukee', state: 'WI' },
    { fips: '55081', name: 'Monroe', state: 'WI' },
    { fips: '55083', name: 'Oconto', state: 'WI' },
    { fips: '55085', name: 'Oneida', state: 'WI' },
    { fips: '55087', name: 'Outagamie', state: 'WI' },
    { fips: '55089', name: 'Ozaukee', state: 'WI' },
    { fips: '55091', name: 'Pepin', state: 'WI' },
    { fips: '55093', name: 'Pierce', state: 'WI' },
    { fips: '55095', name: 'Polk', state: 'WI' },
    { fips: '55097', name: 'Portage', state: 'WI' },
    { fips: '55099', name: 'Price', state: 'WI' },
    { fips: '55101', name: 'Racine', state: 'WI' },
    { fips: '55103', name: 'Richland', state: 'WI' },
    { fips: '55105', name: 'Rock', state: 'WI' },
    { fips: '55107', name: 'Rusk', state: 'WI' },
    { fips: '55109', name: 'St. Croix', state: 'WI' },
    { fips: '55111', name: 'Sauk', state: 'WI' },
    { fips: '55113', name: 'Sawyer', state: 'WI' },
    { fips: '55115', name: 'Shawano', state: 'WI' },
    { fips: '55117', name: 'Sheboygan', state: 'WI' },
    { fips: '55119', name: 'Taylor', state: 'WI' },
    { fips: '55121', name: 'Trempealeau', state: 'WI' },
    { fips: '55123', name: 'Vernon', state: 'WI' },
    { fips: '55125', name: 'Vilas', state: 'WI' },
    { fips: '55127', name: 'Walworth', state: 'WI' },
    { fips: '55129', name: 'Washburn', state: 'WI' },
    { fips: '55131', name: 'Washington', state: 'WI' },
    { fips: '55133', name: 'Waukesha', state: 'WI' },
    { fips: '55135', name: 'Waupaca', state: 'WI' },
    { fips: '55137', name: 'Waushara', state: 'WI' },
    { fips: '55139', name: 'Winnebago', state: 'WI' },
    { fips: '55141', name: 'Wood', state: 'WI' },
    // Wyoming (WY) - 23 counties
    { fips: '56001', name: 'Albany', state: 'WY' },
    { fips: '56003', name: 'Big Horn', state: 'WY' },
    { fips: '56005', name: 'Campbell', state: 'WY' },
    { fips: '56007', name: 'Carbon', state: 'WY' },
    { fips: '56009', name: 'Converse', state: 'WY' },
    { fips: '56011', name: 'Crook', state: 'WY' },
    { fips: '56013', name: 'Fremont', state: 'WY' },
    { fips: '56015', name: 'Goshen', state: 'WY' },
    { fips: '56017', name: 'Hot Springs', state: 'WY' },
    { fips: '56019', name: 'Johnson', state: 'WY' },
    { fips: '56021', name: 'Laramie', state: 'WY' },
    { fips: '56023', name: 'Lincoln', state: 'WY' },
    { fips: '56025', name: 'Natrona', state: 'WY' },
    { fips: '56027', name: 'Niobrara', state: 'WY' },
    { fips: '56029', name: 'Park', state: 'WY' },
    { fips: '56031', name: 'Platte', state: 'WY' },
    { fips: '56033', name: 'Sheridan', state: 'WY' },
    { fips: '56035', name: 'Sublette', state: 'WY' },
    { fips: '56037', name: 'Sweetwater', state: 'WY' },
    { fips: '56039', name: 'Teton', state: 'WY' },
    { fips: '56041', name: 'Uinta', state: 'WY' },
    { fips: '56043', name: 'Washakie', state: 'WY' },
    { fips: '56045', name: 'Weston', state: 'WY' }
];

export function searchCounties(query, limit = 20) {
    if (!query || query.length < 2) return [];
    const q = query.toLowerCase();
    const results = [];
    for (let i = 0; i < US_COUNTIES.length && results.length < limit; i++) {
        const c = US_COUNTIES[i];
        const nameLower = c.name.toLowerCase();
        if (
            nameLower.includes(q) ||
            c.state.toLowerCase().includes(q) ||
            `${c.name}, ${c.state}`.toLowerCase().includes(q) ||
            `${c.name} county, ${c.state}`.toLowerCase().startsWith(q)
        ) {
            results.push(c);
        }
    }
    return results;
}

/**
 * Format a county record for display.
 * MD/MO/NV/VA use FIPS county codes ≥ 500 for independent cities (county equivalents) —
 * those get no "County" suffix. Everything else does.
 */
export function formatCounty(c) {
    if (!c) return '';
    const isIndependentCity = ['24', '29', '32', '51'].includes(c.fips.slice(0, 2)) &&
        parseInt(c.fips.slice(2), 10) >= 500;
    return isIndependentCity ? `${c.name}, ${c.state}` : `${c.name} County, ${c.state}`;
}

let fipsMap = null;
export function lookupCountyByFips(fips) {
    if (!fipsMap) {
        fipsMap = new Map();
        for (const c of US_COUNTIES) {
            fipsMap.set(c.fips, c);
        }
    }
    return fipsMap.get(fips) || null;
}

export default US_COUNTIES;
